import { _ as _inherits, a as _createClass, S as SpanProperty, b as _classCallCheck, c as _getPrototypeOf, d as _possibleConstructorReturn, e as _toConsumableArray, T as TextNode$1, p as pxToTwips, I as InlineNode$1, f as InlineProperty, P as ParagraphNode$1, g as TextAlignmentType, L as LineSpacingType, h as ParaProperty, i as ListProperty, D as DocumentNode$1, j as DocumentProperty, A as AnchorType, W as WhiteSpaceType, k as TailWhitespaceCalculation, t as twipsToPx, C as CoordinateZero, l as LineExpandDirection, B as BoxKind, m as TextRunMeasureEngine, n as TextLayoutEngine, o as AbstractLayoutAdapter, s as styleInject, q as _slicedToArray, R as Range, r as throttle_1, u as _get, v as Transforms, E as Editor$1, w as Point, x as lib_3, y as Path, z as Element, F as Text, G as __rest, H as Scrubber, J as _defineProperty, V as VerticalType, K as _typeof, M as createEditor } from './vendor-bedf3a45.esm.js';
export { A as AnchorType, B as BoxKind, C as CoordinateZero, O as DocSizeType, L as LineSpacingType, N as ListFormat, k as TailWhitespaceCalculation, g as TextAlignmentType, V as VerticalType, W as WhiteSpaceType, Q as traverseLayoutBoxWithHandlers, U as traverseLayoutBoxesWithHandlers, t as twipsToPx } from './vendor-bedf3a45.esm.js';

// 事件响应区域
var EventArea;
(function (EventArea) {
  // 文字内容区域
  EventArea["text"] = "text";
  // 传入的 rect 区域
  EventArea["all"] = "all";
  // 文字区域和 rect 区域组成的并集
  EventArea["maxBlock"] = "maxBlock";
  EventArea["none"] = "none";
})(EventArea || (EventArea = {}));
// 设备类型
var Platform;
(function (Platform) {
  Platform["pc"] = "pc";
  Platform["iosMobile"] = "iosMobile";
  Platform["androidMobile"] = "androidMobile";
})(Platform || (Platform = {}));

function _callSuper$l(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$l() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$l() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$l = function _isNativeReflectConstruct() { return !!t; })(); }
// 继承自 SpanProperty，用来实现额外属性的透传
var TextProperty = /*#__PURE__*/function (_SpanProperty) {
  function TextProperty() {
    var _this;
    _classCallCheck(this, TextProperty);
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    _this = _callSuper$l(this, TextProperty, [].concat(params));
    _this.customizeProps = new Map();
    return _this;
  }
  _inherits(TextProperty, _SpanProperty);
  return _createClass(TextProperty, [{
    key: "setCustomizeProp",
    value: function setCustomizeProp(key, value) {
      this.customizeProps.set(key, value);
    }
  }, {
    key: "getCustomizeProp",
    value: function getCustomizeProp(key) {
      return this.customizeProps.get(key);
    }
    // 设置文字最终渲染时的颜色
  }, {
    key: "setRenderColor",
    value: function setRenderColor(color) {
      this.setCustomizeProp('renderColor', color);
    }
  }, {
    key: "getRenderColor",
    value: function getRenderColor() {
      return this.getCustomizeProp('renderColor');
    }
  }]);
}(SpanProperty);

function legalizeText(text) {
  if (text === null || text === undefined) {
    return '';
  }
  try {
    return String(text);
  } catch (err) {
    console.log('legalizeText text error: ', err);
    return '';
  }
}

function _callSuper$k(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$k() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$k() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$k = function _isNativeReflectConstruct() { return !!t; })(); }
function createTextProperty(textElement, path) {
  var property = new TextProperty();
  var fontWeight = textElement.fontWeight,
    fontSize = textElement.fontSize,
    fontFamily = textElement.fontFamily,
    background = textElement.background,
    color = textElement.color,
    _textElement$italic = textElement.italic,
    italic = _textElement$italic === void 0 ? false : _textElement$italic,
    _textElement$underlin = textElement.underline,
    underline = _textElement$underlin === void 0 ? false : _textElement$underlin,
    _textElement$strike = textElement.strike,
    strike = _textElement$strike === void 0 ? false : _textElement$strike,
    letterSpacing = textElement.letterSpacing,
    baselineOffset = textElement.baselineOffset;
  property.underline = underline;
  property.strike = strike;
  property.italic = italic;
  fontWeight && (property.fontWeight = fontWeight);
  fontSize && (property.fontSize = pxToTwips(fontSize));
  fontFamily && (property.fontFamily = fontFamily);
  color && (property.textColor = color);
  background && (property.textBackground = background);
  letterSpacing && (property.letterSpacing = pxToTwips(letterSpacing));
  baselineOffset && (property.baselineOffset = baselineOffset);
  // 保存当前 textElement 的 path
  property.setCustomizeProp('slatePath', path);
  return property;
}
var TextNode = /*#__PURE__*/function (_ATextNode) {
  function TextNode(parentNode, index) {
    var _this;
    _classCallCheck(this, TextNode);
    _this = _callSuper$k(this, TextNode, [parentNode]);
    _this.index = index;
    return _this;
  }
  _inherits(TextNode, _ATextNode);
  return _createClass(TextNode, [{
    key: "getProperty",
    value: function getProperty() {
      var element = this.getElement();
      return createTextProperty(element, this.getPath());
    }
  }, {
    key: "getNextSibling",
    value: function getNextSibling() {
      var nextIdx = this.index + 1;
      return this.getParentNode().getChild(nextIdx);
    }
  }, {
    key: "getPrevSibling",
    value: function getPrevSibling() {
      var prevIdx = this.index - 1;
      return this.getParentNode().getChild(prevIdx);
    }
  }, {
    key: "getText",
    value: function getText() {
      return legalizeText(this.getElement().text);
    }
  }, {
    key: "getPath",
    value: function getPath() {
      var parentNode = this.getParentNode();
      var parentPath = parentNode.getPath();
      return [].concat(_toConsumableArray(parentPath), [this.index]);
    }
  }, {
    key: "getElement",
    value: function getElement() {
      var parentNode = this.getParentNode();
      return parentNode.getElementChildren()[this.index];
    }
  }]);
}(TextNode$1);

function _callSuper$j(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$j() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$j() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$j = function _isNativeReflectConstruct() { return !!t; })(); }
function createInlineProperty(textElement) {
  var _a;
  var inlineProperty = new InlineProperty();
  var size = pxToTwips(textElement.fontSize || 28);
  inlineProperty.containerSize = {
    width: size,
    height: size
  };
  if (textElement.inlineType) {
    inlineProperty.inlineType = textElement.inlineType;
  }
  if (textElement.baselineOffset) {
    inlineProperty.baselineOffset = textElement.baselineOffset;
  }
  inlineProperty.isRotateInVertLayout = true; // 文本框竖排时，InlineNode跟随其旋转
  if ((_a = textElement.inlineProps) === null || _a === void 0 ? void 0 : _a.icon) {
    inlineProperty.drawingSrc = {
      picSrc: textElement.inlineProps.icon,
      width: textElement.fontSize || 28,
      height: textElement.fontSize || 28
    };
  }
  if (textElement.margin) {
    var _ref = textElement.margin || {},
      _ref$start = _ref.start,
      start = _ref$start === void 0 ? 0 : _ref$start,
      _ref$end = _ref.end,
      end = _ref$end === void 0 ? 5 : _ref$end,
      _ref$before = _ref.before,
      before = _ref$before === void 0 ? 0 : _ref$before,
      _ref$after = _ref.after,
      after = _ref$after === void 0 ? 0 : _ref$after;
    inlineProperty.containerMargin = {
      start: pxToTwips(start),
      end: pxToTwips(end),
      before: pxToTwips(before),
      after: pxToTwips(after)
    };
  }
  return inlineProperty;
}
var InlineNode = /*#__PURE__*/function (_AInlineNode) {
  function InlineNode(parentNode, index) {
    var _this;
    _classCallCheck(this, InlineNode);
    _this = _callSuper$j(this, InlineNode, [parentNode]);
    _this.index = index;
    return _this;
  }
  _inherits(InlineNode, _AInlineNode);
  return _createClass(InlineNode, [{
    key: "getProperty",
    value: function getProperty() {
      var element = this.getElement();
      var inlineProp = createTextProperty(element, this.getPath());
      return inlineProp;
    }
  }, {
    key: "getNextSibling",
    value: function getNextSibling() {
      var nextIdx = this.index + 1;
      return this.getParentNode().getChild(nextIdx);
    }
  }, {
    key: "getInlineProperty",
    value: function getInlineProperty() {
      var element = this.getElement();
      var inlineProp = createInlineProperty(element);
      return inlineProp;
    }
  }, {
    key: "getPrevSibling",
    value: function getPrevSibling() {
      var prevIdx = this.index - 1;
      return this.getParentNode().getChild(prevIdx);
    }
  }, {
    key: "getText",
    value: function getText() {
      return legalizeText(this.getElement().text);
    }
  }, {
    key: "getPath",
    value: function getPath() {
      var parentNode = this.getParentNode();
      var parentPath = parentNode.getPath();
      return [].concat(_toConsumableArray(parentPath), [this.index]);
    }
  }, {
    key: "getElement",
    value: function getElement() {
      var parentNode = this.getParentNode();
      return parentNode.getElementChildren()[this.index];
    }
  }]);
}(InlineNode$1);

function _callSuper$i(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$i() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$i() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$i = function _isNativeReflectConstruct() { return !!t; })(); }
function createCharacterProperty(characterProps) {
  var listFormat = characterProps.listFormat,
    _characterProps$level = characterProps.levelText,
    levelText = _characterProps$level === void 0 ? '' : _characterProps$level;
  var property = new ListProperty();
  property.listFormat = listFormat;
  property.levelText = levelText;
  var opacity = characterProps.opacity;
  var textProperty = new TextProperty();
  if (typeof opacity === 'number') {
    textProperty.setCustomizeProp('opacity', opacity);
  }
  property.listMarkerSpanProp = textProperty;
  var fontSize = characterProps.fontSize;
  fontSize && (textProperty.fontSize = pxToTwips(fontSize));
  if ('src' in characterProps) {
    var src = characterProps.src,
      width = characterProps.width,
      height = characterProps.height;
    property.listPicMarkProp = {
      picSrc: src,
      width: pxToTwips(width),
      height: pxToTwips(height)
    };
  } else {
    var color = characterProps.color,
      fontFamily = characterProps.fontFamily;
    color && (textProperty.textColor = color);
    fontFamily && (textProperty.fontFamily = fontFamily);
  }
  return property;
}
function createParaProperty(paragraphElement) {
  var _paragraphElement$tex = paragraphElement.textAlign,
    textAlign = _paragraphElement$tex === void 0 ? TextAlignmentType.Center : _paragraphElement$tex,
    _paragraphElement$mar = paragraphElement.marginLeft,
    marginLeft = _paragraphElement$mar === void 0 ? 0 : _paragraphElement$mar,
    _paragraphElement$lin = paragraphElement.lineSpacing,
    lineSpacing = _paragraphElement$lin === void 0 ? 1 : _paragraphElement$lin,
    _paragraphElement$lin2 = paragraphElement.lineSpacingRule,
    lineSpacingRule = _paragraphElement$lin2 === void 0 ? LineSpacingType.Multiple : _paragraphElement$lin2,
    _paragraphElement$tex2 = paragraphElement.textIndent,
    textIndent = _paragraphElement$tex2 === void 0 ? 0 : _paragraphElement$tex2,
    _paragraphElement$spa = paragraphElement.spaceBefore,
    spaceBefore = _paragraphElement$spa === void 0 ? 0 : _paragraphElement$spa,
    _paragraphElement$spa2 = paragraphElement.spaceAfter,
    spaceAfter = _paragraphElement$spa2 === void 0 ? 0 : _paragraphElement$spa2,
    characterProps = paragraphElement.characterProps,
    defaultTabSize = paragraphElement.defaultTabSize;
  var property = characterProps ? createCharacterProperty(characterProps) : new ParaProperty();
  property.textAlignment = textAlign;
  property.marginLeft = pxToTwips(marginLeft);
  property.lineSpacing = lineSpacingRule === LineSpacingType.Exactly ? pxToTwips(lineSpacing) : lineSpacing;
  property.lineSpacingRule = lineSpacingRule;
  property.indent = pxToTwips(textIndent);
  property.spaceBefore = pxToTwips(spaceBefore);
  property.spaceAfter = pxToTwips(spaceAfter);
  property.spaceZeroInEdge = true;
  if (typeof defaultTabSize === 'number') {
    property.defaultTabSize = pxToTwips(defaultTabSize);
  }
  if (paragraphElement.tabList) {
    var tabListCopy = paragraphElement.tabList.map(function (tabstop) {
      return {
        position: pxToTwips(tabstop.position),
        alignment: tabstop.alignment
      };
    });
    property.tabList = tabListCopy;
  }
  return property;
}
var ParagraphNode = /*#__PURE__*/function (_AParagraphNode) {
  function ParagraphNode(parentNode, index) {
    var _this;
    _classCallCheck(this, ParagraphNode);
    _this = _callSuper$i(this, ParagraphNode, [parentNode]);
    _this.index = index;
    return _this;
  }
  _inherits(ParagraphNode, _AParagraphNode);
  return _createClass(ParagraphNode, [{
    key: "getProperty",
    value: function getProperty() {
      var element = this.getElement();
      return createParaProperty(element);
    }
  }, {
    key: "getNextSibling",
    value: function getNextSibling() {
      var nextIdx = this.index + 1;
      return this.getParentNode().getChild(nextIdx);
    }
  }, {
    key: "getPrevSibling",
    value: function getPrevSibling() {
      var prevIdx = this.index - 1;
      return this.getParentNode().getChild(prevIdx);
    }
  }, {
    key: "getChild",
    value: function getChild(index) {
      var childElement = this.getElementChildren()[index];
      if (!childElement) {
        return null;
      }
      if (childElement.inlineProps && childElement.text) {
        return new InlineNode(this, index);
      }
      return new TextNode(this, index);
    }
  }, {
    key: "getBeginChild",
    value: function getBeginChild() {
      return this.getChild(0);
    }
  }, {
    key: "getElementChildren",
    value: function getElementChildren() {
      var _a;
      return (_a = this.getElement()) === null || _a === void 0 ? void 0 : _a.children;
    }
  }, {
    key: "getElement",
    value: function getElement() {
      var parentNode = this.getParentNode();
      return parentNode.getElementChildren()[this.index];
    }
  }, {
    key: "getPath",
    value: function getPath() {
      var parentNode = this.getParentNode();
      var parentPath = parentNode.getPath();
      return [].concat(_toConsumableArray(parentPath), [this.index]);
    }
  }]);
}(ParagraphNode$1);

function _callSuper$h(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$h() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$h() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$h = function _isNativeReflectConstruct() { return !!t; })(); }
function createDocumentProperty(documentElement) {
  var documentProperty = new DocumentProperty();
  var _documentElement$padd = documentElement.paddingLeft,
    paddingLeft = _documentElement$padd === void 0 ? 0 : _documentElement$padd,
    _documentElement$padd2 = documentElement.paddingTop,
    paddingTop = _documentElement$padd2 === void 0 ? 0 : _documentElement$padd2,
    _documentElement$padd3 = documentElement.paddingBottom,
    paddingBottom = _documentElement$padd3 === void 0 ? 0 : _documentElement$padd3,
    _documentElement$padd4 = documentElement.paddingRight,
    paddingRight = _documentElement$padd4 === void 0 ? 0 : _documentElement$padd4,
    _documentElement$anch = documentElement.anchor,
    anchor = _documentElement$anch === void 0 ? AnchorType.Top : _documentElement$anch,
    vertical = documentElement.vertical,
    _documentElement$anch2 = documentElement.anchorCenter,
    anchorCenter = _documentElement$anch2 === void 0 ? false : _documentElement$anch2,
    _documentElement$whit = documentElement.whiteSpaceType,
    whiteSpaceType = _documentElement$whit === void 0 ? WhiteSpaceType.Normal : _documentElement$whit,
    docSizeType = documentElement.docSizeType,
    _documentElement$colu = documentElement.columnNumber,
    columnNumber = _documentElement$colu === void 0 ? 1 : _documentElement$colu,
    columnSpace = documentElement.columnSpace,
    _documentElement$hand = documentElement.handingChar4OneLine,
    handingChar4OneLine = _documentElement$hand === void 0 ? false : _documentElement$hand,
    _documentElement$hand2 = documentElement.handingMaxSpace,
    handingMaxSpace = _documentElement$hand2 === void 0 ? -1 : _documentElement$hand2,
    _documentElement$tail = documentElement.tailWhitespaceCalculation,
    tailWhitespaceCalculation = _documentElement$tail === void 0 ? TailWhitespaceCalculation.Exclude : _documentElement$tail;
  documentProperty.leftPadding = pxToTwips(paddingLeft);
  documentProperty.rightPadding = pxToTwips(paddingRight);
  documentProperty.topPadding = pxToTwips(paddingTop);
  documentProperty.bottomPadding = pxToTwips(paddingBottom);
  documentProperty.anchor = anchor;
  documentProperty.whiteSpaceType = whiteSpaceType;
  documentProperty.anchorCenter = anchorCenter;
  if (docSizeType) {
    documentProperty.docSizeType = docSizeType;
  }
  if (vertical) {
    documentProperty.vertical = vertical;
  }
  documentProperty.columnNumber = columnNumber;
  if (columnSpace) {
    documentProperty.columnSpace = pxToTwips(columnSpace);
  }
  documentProperty.handingChar4OneLine = handingChar4OneLine;
  if (handingMaxSpace >= 0) {
    documentProperty.handingMaxSpace = pxToTwips(handingMaxSpace);
  }
  documentProperty.tailWhitespaceCalculation = tailWhitespaceCalculation;
  return documentProperty;
}
var DocumentNode = /*#__PURE__*/function (_ADocumentNode) {
  function DocumentNode(getElement) {
    var _this;
    _classCallCheck(this, DocumentNode);
    _this = _callSuper$h(this, DocumentNode);
    _this.getElement = getElement;
    return _this;
  }
  _inherits(DocumentNode, _ADocumentNode);
  return _createClass(DocumentNode, [{
    key: "getProperty",
    value: function getProperty() {
      var element = this.getElement();
      return createDocumentProperty(element);
    }
  }, {
    key: "getChild",
    value: function getChild(index) {
      var childElement = this.getElementChildren()[index];
      if (!childElement) {
        return null;
      }
      return new ParagraphNode(this, index);
    }
  }, {
    key: "getBeginChild",
    value: function getBeginChild() {
      return this.getChild(0);
    }
  }, {
    key: "getElementChildren",
    value: function getElementChildren() {
      var _a;
      return (_a = this.getElement()) === null || _a === void 0 ? void 0 : _a.children;
    }
  }, {
    key: "getPath",
    value: function getPath() {
      return [];
    }
  }]);
}(DocumentNode$1);

/**
 * 获取指定 box 指定类型的祖先
 * @param box
 * @param ancestorKind
 * @returns
 */
function getAncestorBox(box, ancestorKind) {
  if (!(box === null || box === void 0 ? void 0 : box.parentBox)) {
    return null;
  }
  var current = box.parentBox;
  while (current && current.kind !== ancestorKind) {
    current = current.parentBox;
  }
  return current;
}
/**
 * 获取下一个同级的 box
 * @param box
 * @returns
 */
function getNextBox(box) {
  var _a;
  var parent = box.parentBox;
  if (!parent) {
    return null;
  }
  var nextBox = box.nextSibling;
  if (nextBox) {
    return nextBox;
  }
  return (_a = getNextBox(parent)) === null || _a === void 0 ? void 0 : _a.firstChild;
}
/**
 * 获取上一个同级的 box
 * @param box
 */
function getPrevBox(box) {
  var _a;
  var parent = box === null || box === void 0 ? void 0 : box.parentBox;
  if (!parent) {
    return null;
  }
  var prevBox = box.prevSibling;
  if (prevBox) {
    return prevBox;
  }
  return (_a = getPrevBox(parent)) === null || _a === void 0 ? void 0 : _a.lastChild;
}
/**
 * 获取文字 box 中部分文字的宽度
 * @param box
 * @param offset
 * @returns
 */
function getOffsetWidthOfBox(box, offset) {
  // 如果获取的是整个 box 的所有文字宽度，直接返回 box 的宽度即可
  if (offset + 1 === box.text.length) {
    return twipsToPx(box.measure);
  }
  var _TextRunMeasureEngine = TextRunMeasureEngine.getDefaultEngine().measureChar(box.text, box.textStyle, 0, offset + 1),
    width = _TextRunMeasureEngine.width;
  return twipsToPx(width);
}
/**
 * 获取 box 相对于指定祖先的逻辑尺寸偏移，无关横排竖排
 * start: inline 方向的偏移（left）
 * before: block 方向的偏移（top）
 * @param box
 * @param ancestor
 * @returns
 */
function getLogicOffsetOfAncestorBox(box, ancestor) {
  var start = 0;
  var before = 0;
  var current = box;
  while (current !== ancestor) {
    start += current.logicPoint.start;
    before += current.logicPoint.before;
    current = current.parentBox;
  }
  return {
    start: twipsToPx(start),
    before: twipsToPx(before)
  };
}
/**
 * 获取 box 指定文字相对于文档的逻辑偏移
 * @param box
 * @param offset
 * @returns
 */
function getCharacterLogicOffsetOfDocument(box, offset) {
  if (!box) {
    return;
  }
  var _getLogicOffsetOfAnce = getLogicOffsetOfAncestorBox(box, undefined),
    start = _getLogicOffsetOfAnce.start,
    before = _getLogicOffsetOfAnce.before;
  var measure = getOffsetWidthOfBox(box, offset);
  return {
    start: start + measure,
    before: before
  };
}
/**
 * 获取 box 相对于指定祖先的实际尺寸偏移，无关横排竖排
 * @param coordinate
 * @param lineExpandDirection
 * @param logicOffset
 * @param ancestorRect
 * @returns
 */
function logicOffsetToRealOffset(coordinate, lineExpandDirection, logicOffset, ancestorRect) {
  var start = logicOffset.start,
    before = logicOffset.before;
  switch (coordinate) {
    case CoordinateZero.RIGHT_TOP:
      {
        return {
          x: ancestorRect.width - before,
          y: start
        };
      }
    case CoordinateZero.LEFT_BOTTOM:
      {
        return {
          x: before,
          y: ancestorRect.height - start
        };
      }
    case CoordinateZero.LEFT_TOP:
      if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
        return {
          x: before,
          y: start
        };
      }
    default:
      {
        return {
          x: start,
          y: before
        };
      }
  }
}
/**
 * 逻辑尺寸转为物理尺寸
 * @param coordinate
 * @param lineExpandDirection
 * @param logicSize
 * @returns
 */
function logicSizeToRealSize(coordinate, lineExpandDirection, logicSize) {
  var measure = logicSize.measure,
    extent = logicSize.extent;
  switch (coordinate) {
    case CoordinateZero.RIGHT_TOP:
    case CoordinateZero.LEFT_BOTTOM:
      {
        return {
          width: extent,
          height: measure
        };
      }
    case CoordinateZero.LEFT_TOP:
      if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
        return {
          width: extent,
          height: measure
        };
      }
    default:
      {
        return {
          width: measure,
          height: extent
        };
      }
  }
}
/**
 * 获取当前行文字的真正尺寸，只算文字（行尾的空白）
 * @param lineBox
 */
function getLineTextLogicSize(lineBox) {
  var children = lineBox.children,
    extent = lineBox.extent;
  var measure = children.reduce(function (measure, textBox) {
    return measure + textBox.measure;
  }, 0);
  return {
    measure: twipsToPx(measure),
    extent: twipsToPx(extent)
  };
}
/**
 * 获取当前行文字的基线距离行底部的位置
 * 当前行文字基线位置等于这一行中没有修改基线位置的文字基线位置
 * @param lineBox
 */
function getLineBaselinePosition(lineBox) {
  var children = lineBox.children,
    lineExtent = lineBox.extent;
  // 获取当前行中没有修改基线位置的文字 box
  var textBoxWhichBaselineIsNormal = children.find(function (textBox) {
    return !textBox.isListMark && !textBox.textStyle.baselineOffset;
  });
  // 如果当前行所有文字基线位置都被修改了，以第一个 textBox 为基准
  var standardTextBox = textBoxWhichBaselineIsNormal || children[0];
  var textExtent = standardTextBox.extent,
    descent = standardTextBox.descent;
  var offsetToLineTop = standardTextBox.logicPoint.before;
  // 获取文字 box 到当前行底部的距离
  var offsetToLineBottom = lineExtent - offsetToLineTop - textExtent;
  // 获取文字 box 基线到当前行底部的距离
  var currentDescentToLineBottom = descent + offsetToLineBottom;
  return twipsToPx(currentDescentToLineBottom);
}
/**
 * 返回一个函数，来计算传入的 lineBox 的基线距离行底部的位置
 * @param lineBox
 * @returns
 */
function createLineBaselinePositionGetter(lineBox) {
  return function () {
    return getLineBaselinePosition(lineBox);
  };
}
/**
 * 获取整个文档中最大的逻辑宽度
 * @param documentBox
 * @returns
 */
function getMaxLogicSize(documentBox) {
  var maxSize = 0;
  var _loop = function loop(box) {
    if (box.kind === BoxKind.TextLine) {
      maxSize = Math.max(maxSize, box.measure);
      return;
    }
    if (box.children) {
      box.children.forEach(function (child) {
        return _loop(child);
      });
    }
  };
  _loop(documentBox);
  return twipsToPx(maxSize);
}
/**
 * 获取给定 box 中对应索引的 lineBox
 * @param layoutBox
 * @param lineIndex
 * @returns
 */
function getLineBoxByIndex(layoutBox, lineIndex) {
  var lineBox;
  var index = -1;
  var _loop2 = function loop(box) {
    if (box.kind === BoxKind.TextLine) {
      index += 1;
      if (index === lineIndex) {
        lineBox = box;
        return;
      }
    }
    if (box.children) {
      box.children.forEach(function (child) {
        return _loop2(child);
      });
    }
  };
  _loop2(layoutBox);
  return lineBox;
}
/**
 * 根据最终 rect 和坐标系还原出逻辑 rect
 * @param coordinate
 * @param lineExpandDirection
 * @param realRect 实际尺寸
 * @param ancestorRect 父级的逻辑尺寸
 * @returns
 */
function getLogicRectFromRealRect(coordinate, lineExpandDirection, realRect, ancestorRect) {
  var x = realRect.x,
    y = realRect.y,
    width = realRect.width,
    height = realRect.height;
  var start;
  var before;
  var measure;
  var extent;
  switch (coordinate) {
    case CoordinateZero.RIGHT_TOP:
      {
        start = y;
        before = ancestorRect.extent - width - x;
        measure = height;
        extent = width;
        break;
      }
    case CoordinateZero.LEFT_BOTTOM:
      {
        start = ancestorRect.measure - y - height;
        before = x;
        measure = height;
        extent = width;
        break;
      }
    case CoordinateZero.LEFT_TOP:
      if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
        start = y;
        before = x;
        measure = height;
        extent = width;
        break;
      }
    default:
      {
        start = x;
        before = y;
        measure = width;
        extent = height;
      }
  }
  return {
    start: start,
    before: before,
    measure: measure,
    extent: extent
  };
}

function _callSuper$g(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$g() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$g() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$g = function _isNativeReflectConstruct() { return !!t; })(); }
var LayoutAdapter = /*#__PURE__*/function (_AbstractLayoutAdapte) {
  function LayoutAdapter(getEditorValue) {
    var _this;
    _classCallCheck(this, LayoutAdapter);
    _this = _callSuper$g(this, LayoutAdapter);
    _this.getEditorValue = getEditorValue;
    return _this;
  }
  _inherits(LayoutAdapter, _AbstractLayoutAdapte);
  return _createClass(LayoutAdapter, [{
    key: "getRootNode",
    value: function getRootNode() {
      return new DocumentNode(this.getEditorValue);
    }
  }]);
}(AbstractLayoutAdapter);
var LayoutManager = /*#__PURE__*/function () {
  function LayoutManager(getEditorValue) {
    var _this2 = this;
    _classCallCheck(this, LayoutManager);
    this.getPointFromViewPoint = function (x, y) {
      var _a, _b;
      var pointInfo = _this2.layoutController.findHitViewPoint({
        x: pxToTwips(x),
        y: pxToTwips(y)
      });
      if (!pointInfo) {
        return null;
      }
      var leafBox = pointInfo.leafBox,
        runOffset = pointInfo.runOffset,
        caretRect = pointInfo.caretRect;
      var path = (_b = (_a = leafBox.textStyle) === null || _a === void 0 ? void 0 : _a.getCustomizeProp) === null || _b === void 0 ? void 0 : _b.call(_a, 'slatePath');
      return {
        caretRect: caretRect,
        box: leafBox,
        point: {
          path: path,
          offset: runOffset
        }
      };
    };
    var layoutEngine = LayoutManager.getLayoutEngine();
    var layoutAdapter = new LayoutAdapter(getEditorValue);
    this.layoutController = layoutEngine.createTextLayout(layoutAdapter);
  }
  return _createClass(LayoutManager, [{
    key: "layout",
    value: function layout(rect) {
      var width = rect.width,
        height = rect.height;
      // 排版时不需要考虑位置的偏移，位置偏移统一在渲染时做
      this.layoutController.doLayout(0, 0, width, height);
      this.layoutBox = this.layoutController.getLayoutBox();
    }
    /**
     * 获取某一行的逻辑尺寸和位置
     * @param lineIndex
     * @returns
     */
  }, {
    key: "getLineLogicRect",
    value: function getLineLogicRect(lineIndex) {
      var lineBox = getLineBoxByIndex(this.layoutBox, lineIndex);
      if (!lineBox) {
        return null;
      }
      var _getLogicOffsetOfAnce = getLogicOffsetOfAncestorBox(lineBox, undefined),
        start = _getLogicOffsetOfAnce.start,
        before = _getLogicOffsetOfAnce.before;
      var measure = twipsToPx(lineBox.measure);
      var extent = twipsToPx(lineBox.extent);
      return {
        logicX: start,
        logicY: before,
        logicWidth: measure,
        logicHeight: extent
      };
    }
  }], [{
    key: "setDefaultFontFamily",
    value:
    // 设置全局默认字体
    function setDefaultFontFamily(defaultFontFamilyString, specificFontFamilies) {
      var layoutEngine = this.getLayoutEngine();
      layoutEngine.setDefaultFontFamily(defaultFontFamilyString, specificFontFamilies);
    }
  }, {
    key: "invalidateMeasureCache",
    value: function invalidateMeasureCache(fontFamily) {
      var layoutEngineInstance = TextLayoutEngine.getInstance();
      layoutEngineInstance.invalidateMeasureCache(fontFamily);
    }
    // 设置精确测量状态
  }, {
    key: "setPreciseMeasurement",
    value: function setPreciseMeasurement(preciseMeasurement) {
      this.preciseMeasurement = preciseMeasurement;
      TextLayoutEngine.getInstance().setPreciseMeasurement(preciseMeasurement);
    }
  }, {
    key: "getPreciseMeasurement",
    value: function getPreciseMeasurement() {
      return this.preciseMeasurement;
    }
    // 保证 layoutEngine 是全局单例的
  }, {
    key: "getLayoutEngine",
    value: function getLayoutEngine() {
      if (!this.layoutEngine) {
        this.layoutEngine = TextLayoutEngine.initWithDefaultMeasureContext(this.preciseMeasurement);
      }
      return this.layoutEngine;
    }
  }]);
}(); // 是否需要精确测量
LayoutManager.preciseMeasurement = false;

// 目前绘制文本需要的 container 类型
var ContainerType;
(function (ContainerType) {
  ContainerType["text"] = "text";
  ContainerType["background"] = "background";
  ContainerType["selection"] = "selection";
  ContainerType["eventArea"] = "eventArea";
})(ContainerType || (ContainerType = {}));

var TEXT_BG_INDEX = 0;
var TEXT_SELECTION_INDEX = 1;
// 如果事件响应区域放在背景和选区下面的话，可能会出现这种情况：双击选中文字，选区就会出现，此时如果连击第三次事件可能会触发在选区元素上，影响三击事件的触发
var EVENT_AREA_INDEX = 2;
var TEXT_INDEX = 3;

var RenderManager = /*#__PURE__*/function () {
  function RenderManager(option) {
    _classCallCheck(this, RenderManager);
    var drawContext = option.drawContext,
      renderUtils = option.renderUtils,
      renderText = option.renderText,
      traverseTextHook = option.traverseTextHook,
      getNodeByPath = option.getNodeByPath,
      eventArea = option.eventArea,
      coordinate = option.coordinate,
      lineExpandDirection = option.lineExpandDirection,
      isTextElementExpired = option.isTextElementExpired;
    this.drawContext = drawContext;
    this.renderUtils = renderUtils;
    this.coordinate = coordinate;
    this.lineExpandDirection = lineExpandDirection;
    this.renderText = renderText;
    this.traverseTextHook = traverseTextHook;
    this.getNodeByPath = getNodeByPath;
    this.isTextElementExpired = isTextElementExpired;
    this.eventArea = eventArea;
    // 目前 container 的索引是固定的,bgContainer 是层级最低的,如果动态创建背景容器的话,有可能导致选区的层级高于文字层级,所以暂时去掉动态创建 container 的逻辑
    this.bgContainer = this.drawContext.createContainer(TEXT_BG_INDEX, {
      type: ContainerType.background
    });
    if (this.eventArea !== EventArea.none) {
      this.eventAreaContainer = this.drawContext.createContainer(EVENT_AREA_INDEX, {
        type: ContainerType.eventArea
      });
    }
    this.textContainer = this.drawContext.createContainer(TEXT_INDEX, {
      type: ContainerType.text
    });
  }
  // 根据 blockRect 的偏移统一做文字偏移
  return _createClass(RenderManager, [{
    key: "startDraw",
    value: function startDraw(layoutBox, blockRect) {
      this.drawEventArea(layoutBox, blockRect);
      var x = blockRect.x,
        y = blockRect.y;
      this.drawParentBox(layoutBox, {
        x: pxToTwips(x),
        y: pxToTwips(y)
      });
    }
  }, {
    key: "clearRect",
    value: function clearRect(rect) {
      var x = rect.x,
        y = rect.y,
        width = rect.width,
        height = rect.height;
      this.drawContext.clearRect(this.textContainer, x, y, width, height);
      this.bgContainer && this.drawContext.clearRect(this.bgContainer, x, y, width, height);
      this.eventAreaContainer && this.drawContext.clearRect(this.eventAreaContainer, x, y, width, height);
    }
    /**
     * 绘制全局事件响应区域
     */
  }, {
    key: "drawEventArea",
    value: function drawEventArea(layoutBox, blockRect) {
      if (this.eventArea === EventArea.none) {
        return;
      }
      switch (this.eventArea) {
        case EventArea.all:
          {
            var x = blockRect.x,
              y = blockRect.y,
              width = blockRect.width,
              height = blockRect.height;
            this.drawContext.fillRect(this.eventAreaContainer, {
              x: x,
              y: y,
              width: width,
              height: height,
              color: 'transparent'
            });
            break;
          }
        case EventArea.maxBlock:
          {
            var _layoutBox$rect = layoutBox.rect,
              layoutX = _layoutBox$rect.x,
              layoutY = _layoutBox$rect.y,
              layoutWidth = _layoutBox$rect.width,
              layoutHeight = _layoutBox$rect.height;
            var blockX = blockRect.x,
              blockY = blockRect.y,
              blockWidth = blockRect.width,
              blockHeight = blockRect.height;
            // 由于排版时没有传入 block 的偏移量，所以计算起始位置需要加上偏移量
            var _x = twipsToPx(layoutX) + blockX;
            var _y = twipsToPx(layoutY) + blockY;
            // 宽高都取最大值，保证事件渲染区域覆盖 block 以及所有文字
            var _width = Math.max(twipsToPx(layoutWidth), blockWidth);
            var _height = Math.max(twipsToPx(layoutHeight), blockHeight);
            this.drawContext.fillRect(this.eventAreaContainer, {
              x: _x,
              y: _y,
              width: _width,
              height: _height,
              color: 'transparent'
            });
            break;
          }
        case EventArea.text:
        default:
          {
            var _layoutBox$contentRec = layoutBox.contentRect,
              _x2 = _layoutBox$contentRec.x,
              _y2 = _layoutBox$contentRec.y,
              _width2 = _layoutBox$contentRec.width,
              _height2 = _layoutBox$contentRec.height;
            this.drawContext.fillRect(this.eventAreaContainer, {
              x: twipsToPx(_x2) + blockRect.x,
              y: twipsToPx(_y2) + blockRect.y,
              width: twipsToPx(_width2),
              height: twipsToPx(_height2),
              color: 'transparent'
            });
          }
      }
    }
  }, {
    key: "traverseBox",
    value: function traverseBox(box, offset) {
      if (!box) {
        return;
      }
      var kind = box.kind;
      if (kind === BoxKind.Text) {
        this.drawTextNode(box, offset);
      } else if (kind === BoxKind.Inline) {
        this.drawInlineNode(box, offset);
      } else {
        this.drawParentBox(box, offset);
      }
    }
  }, {
    key: "drawParentBox",
    value: function drawParentBox(box, offset) {
      var _this = this;
      var children = box.children,
        rect = box.rect;
      // rect 中位置都是相对于父级的，在遍历中做下累加
      var newOffset = {
        x: offset.x + rect.x,
        y: offset.y + rect.y
      };
      children.forEach(function (child) {
        _this.traverseBox(child, newOffset);
      });
    }
    // 绘制文本节点，可能含有项目符号图片
  }, {
    key: "drawTextNode",
    value: function drawTextNode(box, offset) {
      if (box.glyph.picSrc) {
        this.drawImage(box, offset, this.textContainer);
        return;
      }
      this.drawText(box, offset, this.textContainer);
    }
    // 绘制inline节点
  }, {
    key: "drawInlineNode",
    value: function drawInlineNode(box, offset) {
      var container = this.createInlineContainer();
      var extraOption = {
        drawLineOffsetX: 0
      };
      if (box.glyph.picSrc) {
        this.drawImage(box, offset, container);
        extraOption.drawLineOffsetX = twipsToPx(box.glyph.width);
      }
      this.drawText(box, offset, container, extraOption);
    }
    // 绘制文字，包括文字的额外渲染renderText
  }, {
    key: "drawText",
    value: function drawText(box, offset, container, extraOption) {
      var _this2 = this;
      var _a, _b, _c, _d;
      var lineBox = getAncestorBox(box, BoxKind.TextLine);
      var slatePath = (_b = (_a = box.textStyle) === null || _a === void 0 ? void 0 : _a.getCustomizeProp) === null || _b === void 0 ? void 0 : _b.call(_a, 'slatePath');
      var textElement = this.getTextElement(slatePath);
      var text = box.text,
        textStyle = box.textStyle,
        rect = box.rect,
        rotate = box.rotate,
        rotateOrigin = box.rotateOrigin,
        isListMark = box.isListMark;
      var boxX = twipsToPx(offset.x + rect.x);
      var boxY = twipsToPx(offset.y + rect.y);
      var x = boxX + twipsToPx(box.fontOffsetX);
      var y = boxY + twipsToPx(box.fontOffsetY);
      var fontSize = textStyle.fontSize,
        italic = textStyle.italic,
        strike = textStyle.strike,
        underline = textStyle.underline,
        fontFamily = textStyle.fontFamily,
        fontWeight = textStyle.fontWeight,
        _textStyle$textColor = textStyle.textColor,
        color = _textStyle$textColor === void 0 ? '#000' : _textStyle$textColor,
        letterSpacing = textStyle.letterSpacing;
      var opacity = (_c = textStyle === null || textStyle === void 0 ? void 0 : textStyle.getCustomizeProp) === null || _c === void 0 ? void 0 : _c.call(textStyle, 'opacity');
      // 绘制文字背景
      var textBgNode = this.drawTextBackground(box, offset.x, offset.y);
      // 传递 boxX 和 boxY 是为了设置文字的 bounds
      var textNode = this.drawContext.fillText(container, text, Object.assign({
        x: x,
        y: y,
        boxX: boxX,
        boxY: boxY,
        width: twipsToPx(rect.width),
        height: twipsToPx(rect.height),
        fontSize: twipsToPx(fontSize),
        fontWeight: fontWeight,
        fontFamily: this.addWithDefaultFontFamily(fontFamily),
        opacity: opacity,
        letterSpacing: twipsToPx(letterSpacing),
        strike: strike && !isListMark,
        underline: underline && !isListMark,
        italic: italic && !isListMark,
        color: color,
        rotate: rotate,
        rotateOrigin: rotateOrigin && {
          x: twipsToPx(rotateOrigin.x),
          y: twipsToPx(rotateOrigin.y)
        },
        textElement: textElement,
        /**
         * 获取 textElement,如果 textElement 过期的话会重新获取
         * 加这个是为了解决一些特殊情况，如果数据改变之后没有重新渲染（例如调用了 resetValueWithoutEffect 接口）
         * 那么此时 textElement 就已经不对了，这个方法可以保证拿到的 textElement 永远是正确的数据
         * @returns
         */
        getTextElement: function getTextElement() {
          if (textElement && !_this2.isTextElementExpired(textElement)) {
            return textElement;
          }
          textElement = _this2.getTextElement(slatePath);
          return textElement;
        },
        lineId: lineBox._uuid
      }, extraOption));
      // 调用自定义渲染逻辑
      if (this.renderText) {
        var measure = box.measure,
          extent = box.extent,
          bgRect = box.bgRect;
        var offsetOfLine = getLogicOffsetOfAncestorBox(box, lineBox);
        var lineTextLogicSize = getLineTextLogicSize(lineBox);
        var bgLogicRect = getLogicRectFromRealRect(this.coordinate, this.lineExpandDirection, bgRect, lineBox);
        var option = {
          textNode: textNode,
          textBgNode: textBgNode,
          text: text,
          x: x,
          y: y,
          logicWidth: twipsToPx(measure),
          logicHeight: twipsToPx(extent),
          /** @deprecated 请直接在 ${@link textElement} 上挂载和获取自定义属性  */
          textStyle: textStyle,
          logicOffsetXOfLine: offsetOfLine.start,
          logicOffsetYOfLine: offsetOfLine.before,
          logicLineWidth: lineTextLogicSize.measure,
          logicLineHeight: lineTextLogicSize.extent,
          textElement: textElement,
          /**
           * 注意
           * 1. 这里不直接根据 lineBox 计算好 lineBaselinePosition，是因为大部分情况下都不需要这个计算逻辑，传递一个函数在需要当前数据的时候再执行，避免浪费资源
           * 2. 之前这里是一个匿名函数，那样会导致这个匿名函数的上下文会包含当前的作用域链，如果这个 option 被错误抓住而没释放的话，会顺着这个匿名函数隐式引用到当前的作用域链，连锁反应导致很多对象都无法被回收。
           *    所以这里传递的 getLineBaselinePosition 值改为在其他地方创建
           */
          getLineBaselinePosition: createLineBaselinePositionGetter(lineBox),
          bgLogicHeight: twipsToPx(bgLogicRect.extent),
          bgLogicWidth: twipsToPx(bgLogicRect.measure),
          bgLogicOffsetXOfLine: twipsToPx(bgLogicRect.start),
          bgLogicOffsetYOfLine: twipsToPx(bgLogicRect.before)
        };
        this.renderText(option);
      }
      if (slatePath) {
        (_d = this.traverseTextHook) === null || _d === void 0 ? void 0 : _d.call(this, slatePath, box, textElement);
      }
      this.setTextRenderColor(textNode, box);
    }
    // 设置文字节点最终渲染时的颜色
  }, {
    key: "setTextRenderColor",
    value: function setTextRenderColor(textNode, textBox) {
      var _a, _b;
      var textRenderColor = (_a = this.renderUtils) === null || _a === void 0 ? void 0 : _a.getTextColor(textNode);
      if (textRenderColor) {
        (_b = textBox.textStyle) === null || _b === void 0 ? void 0 : _b.setRenderColor(textRenderColor);
      }
    }
  }, {
    key: "getTextElement",
    value: function getTextElement(path) {
      if (path) {
        return this.getNodeByPath(path);
      }
      return;
    }
    // 绘制文字背景色
  }, {
    key: "drawTextBackground",
    value: function drawTextBackground(box, lineX, lineY) {
      var textBackground = box.textStyle.textBackground;
      if (!textBackground || textBackground === 'transparent') {
        return;
      }
      var _box$bgRect = box.bgRect,
        x = _box$bgRect.x,
        y = _box$bgRect.y,
        width = _box$bgRect.width,
        height = _box$bgRect.height;
      return this.drawContext.fillRect(this.bgContainer, {
        x: twipsToPx(lineX + x),
        y: twipsToPx(lineY + y),
        width: twipsToPx(width),
        height: twipsToPx(height),
        color: textBackground
      });
    }
    // 目前主要是绘制自定义图片项目符号和inlineNode内的图片
  }, {
    key: "drawImage",
    value: function drawImage(box, offset, container) {
      var _a, _b, _c;
      var rect = box.rect,
        glyph = box.glyph,
        textStyle = box.textStyle,
        rotate = box.rotate,
        rotateOrigin = box.rotateOrigin,
        imgOffsetY = box.imgOffsetY,
        imgOffsetX = box.imgOffsetX;
      var x = twipsToPx(offset.x + rect.x + imgOffsetX);
      var y = twipsToPx(offset.y + rect.y + imgOffsetY);
      var opacity = (_a = textStyle === null || textStyle === void 0 ? void 0 : textStyle.getCustomizeProp) === null || _a === void 0 ? void 0 : _a.call(textStyle, 'opacity');
      (_c = (_b = this.drawContext) === null || _b === void 0 ? void 0 : _b.drawImage) === null || _c === void 0 ? void 0 : _c.call(_b, container, {
        x: x,
        y: y,
        // 图片的宽高应该使用固定的，而不是测量的
        width: twipsToPx(glyph.width),
        height: twipsToPx(glyph.height),
        rotate: rotate,
        rotateOrigin: rotateOrigin && {
          x: twipsToPx(rotateOrigin.x),
          y: twipsToPx(rotateOrigin.y)
        },
        src: glyph.picSrc,
        opacity: opacity
      });
    }
    // 绘制InlineNode节点的容器
  }, {
    key: "createInlineContainer",
    value: function createInlineContainer() {
      var inlineContainer = this.drawContext.createContainer(0);
      this.textContainer.addChild(inlineContainer);
      return inlineContainer;
    }
    // 拼接上默认字体
  }, {
    key: "addWithDefaultFontFamily",
    value: function addWithDefaultFontFamily(fontFamily) {
      if (!Editor.defaultFontFamilyString) {
        return fontFamily;
      }
      if (!fontFamily) {
        return Editor.defaultFontFamilyString;
      }
      return "".concat(fontFamily, ",").concat(Editor.defaultFontFamilyString);
    }
  }]);
}();

var css_248z$3 = ".style_caret__PMMaU .style_alloy-caret__JhBbP {\n  position: absolute;\n  left: 0;\n  top: 0;\n  background-color: #1e6fff;\n  pointer-events: none;\n  cursor: text;\n  width: 1px;\n  transform-origin: left top;\n}\n.style_caret__PMMaU .style_alloy-caret-blink-transparent__Fo08H {\n  animation: style_fadeOutIn-blink-transparent__gXK2s 1s infinite linear;\n}\n@keyframes style_fadeOutIn-blink-transparent__gXK2s {\n  from {\n    opacity: 1;\n  }\n  13%, 50% {\n    opacity: 0;\n  }\n  63%, to {\n    opacity: 1;\n  }\n}";
var style$3 = {"caret":"style_caret__PMMaU","alloy-caret":"style_alloy-caret__JhBbP","alloy-caret-blink-transparent":"style_alloy-caret-blink-transparent__Fo08H","fadeOutIn-blink-transparent":"style_fadeOutIn-blink-transparent__gXK2s","alloyCaret":"style_alloy-caret__JhBbP","alloyCaretBlinkTransparent":"style_alloy-caret-blink-transparent__Fo08H","fadeOutInBlinkTransparent":"style_fadeOutIn-blink-transparent__gXK2s"};
styleInject(css_248z$3);

var defaultColor = '#1e6fff';
var Caret = /*#__PURE__*/function () {
  function Caret() {
    _classCallCheck(this, Caret);
    this.state = {
      height: 20,
      width: 1,
      x: 0,
      y: 0,
      isBlink: false,
      visible: false,
      color: defaultColor
    };
  }
  return _createClass(Caret, [{
    key: "attach",
    value: function attach(surface) {
      this.surfaceDom = surface;
      this.containerDom = document.createElement('div');
      this.containerDom.className = style$3.caret;
      this.caretDom = document.createElement('div');
      this.containerDom.appendChild(this.caretDom);
      surface.appendChild(this.containerDom);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.surfaceDom.removeChild(this.containerDom);
    }
  }, {
    key: "update",
    value: function update(x, y, width, height, color) {
      this.setState({
        x: x,
        y: y,
        width: width,
        height: height,
        color: color
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.clearDelayBlink();
      this.setState({
        isBlink: false,
        visible: false
      });
    }
    /**
     * 隐藏并重置光标
     */
  }, {
    key: "hideAndReset",
    value: function hideAndReset() {
      this.clearDelayBlink();
      this.setState({
        x: 0,
        y: 0,
        height: 20,
        width: 1,
        isBlink: false,
        visible: false
      });
    }
  }, {
    key: "show",
    value: function show() {
      var _this = this;
      this.clearDelayBlink();
      this.setState({
        visible: true,
        isBlink: false
      });
      // 延迟 500ms 开始闪烁，保证光标在快速切换的时候不会闪烁
      this.timeout = setTimeout(function () {
        _this.setState({
          isBlink: true
        });
      }, 500);
    }
  }, {
    key: "visible",
    get: function get() {
      return this.state.visible;
    }
    // 清除延迟闪烁的定时器
  }, {
    key: "clearDelayBlink",
    value: function clearDelayBlink() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "stateToStyle",
    value: function stateToStyle(key, value) {
      var _a;
      var stateStyleMap = {
        x: function x(value) {
          return ['left', "".concat(value, "px")];
        },
        y: function y(value) {
          return ['top', "".concat(value, "px")];
        },
        width: function width(value) {
          return ['width', "".concat(value, "px")];
        },
        height: function height(value) {
          return ['height', "".concat(value, "px")];
        },
        visible: function visible(value) {
          return ['visibility', value ? 'visible' : 'hidden'];
        },
        color: function color(value) {
          return ['background-color', value || defaultColor];
        }
      };
      return ((_a = stateStyleMap[key]) === null || _a === void 0 ? void 0 : _a.call(stateStyleMap, value)) || [];
    }
  }, {
    key: "setState",
    value: function setState(state) {
      this.state = Object.assign(this.state, state);
      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var className = [style$3.alloyCaret];
      if (this.state.isBlink) {
        className.push(style$3.alloyCaretBlinkTransparent);
      }
      this.caretDom.className = className.join(' ');
      Object.entries(this.state).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        var _this2$stateToStyle = _this2.stateToStyle(key, value),
          _this2$stateToStyle2 = _slicedToArray(_this2$stateToStyle, 2),
          styleKey = _this2$stateToStyle2[0],
          styleValue = _this2$stateToStyle2[1];
        styleKey && (_this2.caretDom.style[styleKey] = styleValue);
      });
    }
  }]);
}();
var EDITOR_CARET_CLASS_NAME = style$3.alloyCaret;

function isAlphabet(character) {
  var charCode = character.charCodeAt(0);
  return charCode >= 65 && charCode <= 90 || charCode >= 97 && charCode <= 122;
}
/**
 * 判断给定的字符是否是 ios 九宫格拼音输入法第一格的拼音按钮
 * @param character
 * @returns
 */
function isIosPinyinPunctuation(character) {
  var charCode = character.charCodeAt(0);
  return charCode === 65281 || charCode === 65292 || charCode === 65311 || charCode === 12290;
}
function isNumber(character) {
  var charCode = character.charCodeAt(0);
  return charCode >= 48 && charCode <= 57;
}
function isAlphabetOrNumber(character) {
  return isAlphabet(character) || isNumber(character);
}

var css_248z$2 = ".style_hidden-editor__p2PlP {\n  width: 0;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n.style_hidden-editor-input__d1UFL {\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  background: transparent;\n  color: transparent;\n  overflow: hidden;\n  outline: none;\n  width: 50px;\n  height: 5px;\n  font-size: 1px;\n  z-index: -2;\n  white-space: pre-wrap;\n  transform: scale(0.1);\n}\n.style_hidden-editor-input-pc__Bza34 {\n  caret-color: transparent;\n}\n.style_hidden-editor-input-mobile__rQuLr {\n  caret-color: auto;\n}";
var style$2 = {"hidden-editor":"style_hidden-editor__p2PlP","hidden-editor-input":"style_hidden-editor-input__d1UFL","hidden-editor-input-pc":"style_hidden-editor-input-pc__Bza34","hidden-editor-input-mobile":"style_hidden-editor-input-mobile__rQuLr","hiddenEditor":"style_hidden-editor__p2PlP","hiddenEditorInput":"style_hidden-editor-input__d1UFL","hiddenEditorInputPc":"style_hidden-editor-input-pc__Bza34","hiddenEditorInputMobile":"style_hidden-editor-input-mobile__rQuLr"};
styleInject(css_248z$2);

var IS_APPLE = typeof navigator !== 'undefined' && /Mac OS X/.test(navigator.userAgent);
var isMobile = function isMobile(platform) {
  return platform === Platform.iosMobile || platform === Platform.androidMobile;
};
var IS_SAFARI = /^((?!chrome|android|mqbhd|MQQBrowser).)*safari/i.test(navigator.userAgent);
var IS_MOBILE = /mobile|android/i.test(navigator.userAgent);
var IS_PC_SAFARI = IS_SAFARI && !IS_MOBILE;

/**
 * 保留可显示字符
 * ASCII中包含两种类型字符：控制字符(control code chart)和可显示字符(printable chars)
 * 范围在 [0-31]|127的字符为控制字符，主要是用来操控已经处理过的文字
 * 除控制字符外的其他95个为可显示字符，用键盘敲下可以显示在内容中
 * 过滤控制字符(control code chart), 仅保留可显示字符, 过滤掉特殊键盘非法输入控制字符
 * @param text
 * @returns 可显示字符
 **/
function getPrintableText() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!text) {
    return text;
  }
  // 部分键盘backSpace键值（'\b'）会非法输入，这里对所有类似于'\b'的控制字符（ASCII范围在 [0-31]|127的字符）进行过滤
  // eslint-disable-next-line no-control-regex
  var CONTROL_CODE_CHART_REG = /([\u0000-\u001F]|\u007F)+/;
  var reg = new RegExp(CONTROL_CODE_CHART_REG, 'g');
  var filteredText = text.replace(reg, '');
  return filteredText;
}

var BaseHiddenEditor = /*#__PURE__*/function () {
  function BaseHiddenEditor(option) {
    var _this = this;
    _classCallCheck(this, BaseHiddenEditor);
    /**
     * 挂载入口
     */
    this.attach = function (surface) {
      var container = _this.initContainer();
      var inputDom = _this.initInputDom();
      container.appendChild(inputDom);
      surface.appendChild(container);
      _this.inputDomRef = inputDom;
      _this.initEventListener();
    };
    /**
     * 卸载入口
     */
    this.detach = function () {
      _this.removeEventListener();
    };
    this.initEventListener = function () {
      _this.inputDomRef.addEventListener('input', _this.handleInput);
      _this.inputDomRef.addEventListener('keydown', _this.handleKeyDown);
      _this.inputDomRef.addEventListener('focus', _this.handleFocus);
      _this.inputDomRef.addEventListener('blur', _this.handleBlur);
      _this.inputDomRef.addEventListener('paste', _this.handlePaste);
      _this.inputDomRef.addEventListener('copy', _this.handleCopy);
      _this.inputDomRef.addEventListener('cut', _this.handleCut);
      _this.inputDomRef.addEventListener('compositionstart', _this.handleCompositionStart);
      _this.inputDomRef.addEventListener('compositionupdate', _this.handleCompositionUpdate);
      _this.inputDomRef.addEventListener('compositionend', _this.handleCompositionEnd);
    };
    this.removeEventListener = function () {
      _this.inputDomRef.removeEventListener('input', _this.handleInput);
      _this.inputDomRef.removeEventListener('keydown', _this.handleKeyDown);
      _this.inputDomRef.removeEventListener('focus', _this.handleFocus);
      _this.inputDomRef.removeEventListener('blur', _this.handleBlur);
      _this.inputDomRef.removeEventListener('paste', _this.handlePaste);
      _this.inputDomRef.removeEventListener('copy', _this.handleCopy);
      _this.inputDomRef.removeEventListener('cut', _this.handleCut);
      _this.inputDomRef.removeEventListener('compositionstart', _this.handleCompositionStart);
      _this.inputDomRef.removeEventListener('compositionupdate', _this.handleCompositionUpdate);
      _this.inputDomRef.removeEventListener('compositionend', _this.handleCompositionEnd);
    };
    this.handleCompositionStart = function (event) {
      var _a;
      _this.clearInput();
      // 合成输入开始时需要清除上次合成输入的状态定时器
      // 否则如果输入比较快时，在 clearComposingStateTimer 还没执行时就可能触发了 CompositionStart
      // 导致当前的合成输入状态可能被清除
      clearTimeout(_this.clearComposingStateTimer);
      _this.isComposing = true;
      (_a = _this.onCompositionStart) === null || _a === void 0 ? void 0 : _a.call(_this, event);
    };
    this.handleCompositionUpdate = function (event) {
      var _a;
      var filteredText = getPrintableText(event.data);
      // 合成输入时，就算文本是空的也要往外传，可能是删除操作
      (_a = _this.onCompositionText) === null || _a === void 0 ? void 0 : _a.call(_this, filteredText);
    };
    this.handleCompositionEnd = function (event) {
      var _a;
      var filteredText = getPrintableText(event.data);
      (_a = _this.onCompositionEnd) === null || _a === void 0 ? void 0 : _a.call(_this, filteredText);
      _this.isComposing = false;
      _this.clearInput();
    };
    this.handleInput = function () {
      var _a;
      if (_this.isComposing) {
        return;
      }
      var value = _this.processTextContent();
      var filteredText = getPrintableText(value);
      if (filteredText) {
        (_a = _this.onTypeText) === null || _a === void 0 ? void 0 : _a.call(_this, filteredText);
      }
    };
    this.handleKeyDown = function (event) {
      var _a;
      // 合成输入过程中不触发外面的 keydown 处理
      if (_this.isComposing) {
        return;
      }
      /**
       * safari 中 keydown 事件比合成事件后触发，
       * 在合成输入过程中按 backspace 触发 compositionend 时（也就是删除输入的拼音），
       * 由于 compositionend 中已经重置了 isComposing 状态，此时如果触发外层 onKeyDown 会导致拼音前的文字被删除
       * 这里判断下 safari 合成输入过程中触发的 backspace 不需要执行 keydown 逻辑（正常 backspace 的 keycode 是 8）
       */
      if (IS_PC_SAFARI && event.keyCode === 229 && event.key === 'Backspace') {
        return;
      }
      (_a = _this.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(_this, event);
    };
    this.handleFocus = function (event) {
      var _a;
      event.preventDefault();
      _this.isFocus = true;
      (_a = _this.onFocus) === null || _a === void 0 ? void 0 : _a.call(_this);
      _this.clearInput();
    };
    /**
     * 因为某些失去焦点的逻辑外面监控不到，比如点击其他页面
     * 所以失去焦点时要更新给外面，用于隐藏模拟光标以及取消选区等逻辑
     * 加延迟和判断的逻辑是这样：
     * 如果不加的话，在编辑器内部点击其他文字也会触发 onBlur，而且触发事件在 editor 的 mousedown 之后，
     * 所以在 mousedown 中设置的光标位置和选区就会被删除。
     * 由于 mousedown 里面我们会手动触发输入框的 focus, 在延迟之后判断如果 this.isFocus === false，说明此时并不是在编辑器内部点击，可以触发外面的 onBlur
     * 如果 this.isFocus === true，说明是在编辑器内部点击，就不用触发外面的 onBlur
     * @param event
     */
    this.handleBlur = function (event) {
      event.preventDefault();
      // 清除 isComposing 状态，避免在拼音输入过程中直接退出编辑态时状态没清除
      _this.isComposing = false;
      _this.isFocus = false;
      setTimeout(function () {
        var _a;
        if (!_this.isFocus) {
          (_a = _this.onBlur) === null || _a === void 0 ? void 0 : _a.call(_this);
        }
      }, 100);
      _this.clearInput();
    };
    this.handleCopy = function (event) {
      var _a;
      // 目前内部没有默认处理，交给业务处理，阻止掉默认事件
      event.preventDefault();
      (_a = _this.onCopy) === null || _a === void 0 ? void 0 : _a.call(_this, event);
    };
    this.handlePaste = function (event) {
      var _a;
      // 目前内部没有默认处理，交给业务处理，阻止掉默认事件
      event.preventDefault();
      (_a = _this.onPaste) === null || _a === void 0 ? void 0 : _a.call(_this, event);
    };
    this.handleCut = function (event) {
      var _a;
      // 目前内部没有默认处理，交给业务处理，阻止掉默认事件
      event.preventDefault();
      (_a = _this.onCut) === null || _a === void 0 ? void 0 : _a.call(_this, event);
    };
    this.initContainer = function () {
      var container = document.createElement('div');
      container.classList.add(style$2.hiddenEditor);
      return container;
    };
    this.initInputDom = function () {
      var input = document.createElement('input');
      input.classList.add(style$2.hiddenEditorInput, _this.getInputClass());
      return input;
    };
    this.initHooks(option);
    this.state = {
      x: 0,
      y: 0,
      visible: false
    };
  }
  return _createClass(BaseHiddenEditor, [{
    key: "show",
    value: function show(x, y) {
      var needFocus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var preventScroll = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      this.setState({
        x: x,
        y: y,
        visible: true
      });
      if (needFocus) {
        this.setFocus(preventScroll);
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      /**
       * 正常不需要隐藏这个输入框，因为本来就看不见，但是在 safari 中有如下 bug：
       *   editor 退出编辑态之后，接着按键盘输入，当前 input 又会自动获取焦点
       * 所以在退出编辑态之后，需要把输入框隐藏掉。
       */
      this.setState({
        x: 0,
        y: 0,
        visible: false
      });
      this.setBlur();
    }
  }, {
    key: "stateToStyle",
    value: function stateToStyle(key, value) {
      var _a;
      var stateStyleMap = {
        x: function x(value) {
          return ['left', "".concat(value, "px")];
        },
        y: function y(value) {
          return ['top', "".concat(value, "px")];
        },
        visible: function visible(value) {
          return ['visibility', value ? 'visible' : 'hidden'];
        }
      };
      return ((_a = stateStyleMap[key]) === null || _a === void 0 ? void 0 : _a.call(stateStyleMap, value)) || [];
    }
    /**
     * 手动触发焦点
     */
  }, {
    key: "setFocus",
    value: function setFocus() {
      var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.inputDomRef) {
        // mousedown 其他元素手动触发可编辑元素 focus 时，可编辑元素会先 focus 然后立即 blur，可能因为点击可编辑元素之外的位置时默认会使其失焦，解决办法是在其他元素的 mousedown 中阻止默认事件
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
        // If you call HTMLElement.focus() from a mousedown event handler, you must call event.preventDefault() to keep the focus from leaving the HTMLElement
        this.inputDomRef.focus({
          preventScroll: preventScroll
        });
      }
    }
  }, {
    key: "setBlur",
    value: function setBlur() {
      if (this.inputDomRef) {
        this.inputDomRef.blur();
      }
    }
  }, {
    key: "initHooks",
    value: function initHooks(option) {
      var onKeyDown = option.onKeyDown,
        onTypeText = option.onTypeText,
        onBlur = option.onBlur,
        onFocus = option.onFocus,
        onCompositionText = option.onCompositionText,
        onCompositionStart = option.onCompositionStart,
        onCompositionEnd = option.onCompositionEnd,
        deleteCharacterBack = option.deleteCharacterBack,
        clearCompositionState = option.clearCompositionState,
        onCopy = option.onCopy,
        onCut = option.onCut,
        onPaste = option.onPaste;
      this.onTypeText = onTypeText;
      this.onCompositionText = onCompositionText;
      this.onCompositionStart = onCompositionStart;
      this.onCompositionEnd = onCompositionEnd;
      this.onBlur = onBlur;
      this.onFocus = onFocus;
      this.onKeyDown = onKeyDown;
      this.deleteCharacterBack = deleteCharacterBack;
      this.clearCompositionState = clearCompositionState;
      this.onCopy = onCopy;
      this.onPaste = onPaste;
      this.onCut = onCut;
    }
  }, {
    key: "setState",
    value: function setState(state) {
      this.state = Object.assign(this.state, state);
      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      Object.entries(this.state).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        var _this2$stateToStyle = _this2.stateToStyle(key, value),
          _this2$stateToStyle2 = _slicedToArray(_this2$stateToStyle, 2),
          styleKey = _this2$stateToStyle2[0],
          styleValue = _this2$stateToStyle2[1];
        styleKey && (_this2.inputDomRef.style[styleKey] = styleValue);
      });
    }
  }]);
}();

function _callSuper$f(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$f() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$f() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$f = function _isNativeReflectConstruct() { return !!t; })(); }
var MobileHiddenEditor = /*#__PURE__*/function (_BaseHiddenEditor) {
  function MobileHiddenEditor() {
    var _this;
    _classCallCheck(this, MobileHiddenEditor);
    _this = _callSuper$f(this, MobileHiddenEditor, arguments);
    // 暂存上次 input 的内容，用于处理部分手机英文输入法的兼容性问题
    _this.cacheInputValue = '';
    /**
     * 移动端 input 事件触发逻辑可能会和 pc 不一致
     * 在英文联想输入中，input 元素的 value 可能会包含上次输入的内容，所以需要处理这个差异，避免内容重复输入
     */
    _this.processTextContent = function () {
      var originValue = _this.inputDomRef.value || '';
      var _this$findDiff = _this.findDiff(originValue),
        toDeleteLength = _this$findDiff.toDeleteLength,
        toInputValue = _this$findDiff.toInputValue;
      if (toDeleteLength) {
        _this.deleteCharacterBack(toDeleteLength);
      }
      _this.cacheInputValue = originValue;
      var lastCharacter = toInputValue[toInputValue.length - 1];
      // 如果 toInputValue 长度大于 1，那么判断为点击了输入法的联想词，需要清空暂存的输入内容
      // 如果输入的最后一个字符不是英文字母，那么就判断结束了联想输入，需要清空暂存的输入内容
      // 兼容 ios 九宫格拼音输入法，左上角第一格的标点符号支持连续点击切换
      if (toInputValue.length > 1 || lastCharacter && !isAlphabet(lastCharacter) && !isIosPinyinPunctuation(lastCharacter)) {
        _this.clearInput();
      }
      return toInputValue;
    };
    return _this;
  }
  /**
   * 移动端 touch 时会切换光标位置，但是大部分输入法的中间状态都不会正常清除，所以需要手动处理下
   */
  _inherits(MobileHiddenEditor, _BaseHiddenEditor);
  return _createClass(MobileHiddenEditor, [{
    key: "triggerTouchStart",
    value: function triggerTouchStart(platform) {
      if (!(platform === Platform.iosMobile && this.isComposing)) {
        // ios 中，在拼音输入过程中，点击切换了光标位置，清空 inputDomRef 内容后输入法的中间状态没有变化，而且接着输入不会触发任何输入事件，导致无法输入文字
        // 所以在 ios 拼音状态下的话就不清空了
        this.clearInput();
      }
      // 清除合成输入的中间状态，避免切换光标后接着输入会误删除前面的文字
      // 例如：安卓搜狗输入法输入英文会走合成输入的逻辑，在合成输入中点击切换光标接着输入就会删除掉光标前的文字
      this.clearCompositionState();
    }
  }, {
    key: "clearInput",
    value: function clearInput() {
      this.cacheInputValue = '';
      if (this.inputDomRef) {
        this.inputDomRef.value = '';
      }
    }
  }, {
    key: "getInputClass",
    value: function getInputClass() {
      return style$2.hiddenEditorInputMobile;
    }
    /**
     * 获取两次 input 之间的差异
     * @param newValue
     * @returns
     */
  }, {
    key: "findDiff",
    value: function findDiff(newValue) {
      var cacheInputValue = this.cacheInputValue;
      var pos = 0;
      while (pos < cacheInputValue.length && pos < newValue.length) {
        if (cacheInputValue[pos] !== newValue[pos]) {
          break;
        }
        pos += 1;
      }
      return {
        // 上次输入中需要删除的长度
        toDeleteLength: cacheInputValue.length - pos,
        // 需要往后添加的文字
        toInputValue: newValue.substring(pos, newValue.length)
      };
    }
  }]);
}(BaseHiddenEditor);

function _callSuper$e(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$e() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$e() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$e = function _isNativeReflectConstruct() { return !!t; })(); }
var PCHiddenEditor = /*#__PURE__*/function (_BaseHiddenEditor) {
  function PCHiddenEditor() {
    var _this;
    _classCallCheck(this, PCHiddenEditor);
    _this = _callSuper$e(this, PCHiddenEditor, arguments);
    _this.processTextContent = function () {
      var value = _this.inputDomRef.value || '';
      _this.clearInput();
      return value;
    };
    return _this;
  }
  _inherits(PCHiddenEditor, _BaseHiddenEditor);
  return _createClass(PCHiddenEditor, [{
    key: "clearInput",
    value: function clearInput() {
      if (this.inputDomRef) {
        this.inputDomRef.value = '';
      }
    }
  }, {
    key: "getInputClass",
    value: function getInputClass() {
      return style$2.hiddenEditorInputPc;
    }
  }]);
}(BaseHiddenEditor);

var EDITOR_INPUT_CLASS_NAME = style$2.hiddenEditorInput;
function createHiddenEditor(platform, option) {
  if (platform === Platform.pc) {
    return new PCHiddenEditor(option);
  }
  return new MobileHiddenEditor(option);
}
function isMobileHiddenEditor(hiddenEditor) {
  return hiddenEditor instanceof MobileHiddenEditor;
}

/**
 * 可以绑定 editor 实例的基础类
 */
var EditorAttachable = /*#__PURE__*/function () {
  function EditorAttachable() {
    _classCallCheck(this, EditorAttachable);
  }
  return _createClass(EditorAttachable, [{
    key: "coordinate",
    get: function get() {
      var _a;
      return ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.coordinate) || CoordinateZero.LEFT_TOP;
    }
  }, {
    key: "lineExpandDirection",
    get: function get() {
      var _a;
      return ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.lineExpandDirection) || LineExpandDirection.VERTICAL;
    }
    // 当前编辑区域应用的 transform 缩放，有时候为了保证大小不受缩放影响，需要逆向计算一下
  }, {
    key: "transformScale",
    get: function get() {
      var _a;
      return ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.transformScale) || 1;
    }
  }, {
    key: "scale",
    get: function get() {
      var _a;
      return ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.scale) || 1;
    }
  }, {
    key: "blockRect",
    get: function get() {
      var _a;
      return ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.blockRect) || {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    }
  }, {
    key: "textRect",
    get: function get() {
      var _a;
      return ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.textRect) || {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    }
  }, {
    key: "appPosition",
    get: function get() {
      var _a;
      return ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.appPosition) || {
        x: 0,
        y: 0
      };
    }
    /**
     * 绑定当前正在编辑的 editor 实例
     * @param editor Editor
     */
  }, {
    key: "attachEditor",
    value: function attachEditor(editor) {
      if (this.editor === editor) {
        return;
      }
      this.editor = editor;
      this.afterEditorAttached();
    }
    /**
     * 解绑当前正在编辑的 editor 实例
     * @param editor Editor
     */
  }, {
    key: "detachEditor",
    value: function detachEditor(editor) {
      if (this.editor === editor) {
        this.beforeEditorDetached();
        this.editor = null;
      }
    }
  }, {
    key: "afterEditorAttached",
    value: function afterEditorAttached() {}
  }, {
    key: "beforeEditorDetached",
    value: function beforeEditorDetached() {}
  }]);
}();

function _createForOfIteratorHelper$2(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$2(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$2(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$2(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0; } }
function _arrayLikeToArray$2(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper$d(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$d() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$d() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$d = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 获取 editor 可被选中的区域的 rect
 * @param editor
 */
function getEditorSelectableAreaRect(editor) {
  // 获取所有行的layoutBox
  var allLines = editor.layoutManager.layoutBox.children.map(function (e) {
    return e.children;
  }).reduce(function (acc, curr) {
    return acc.concat(curr);
  }, []);
  // 获取当前editor的基础信息
  var editorAttachableInstance = new (/*#__PURE__*/function (_EditorAttachable) {
    function _class() {
      _classCallCheck(this, _class);
      return _callSuper$d(this, _class, arguments);
    }
    _inherits(_class, _EditorAttachable);
    return _createClass(_class);
  }(EditorAttachable))();
  editorAttachableInstance.attachEditor(editor);
  var coordinate = editorAttachableInstance.coordinate,
    lineExpandDirection = editorAttachableInstance.lineExpandDirection,
    blockRect = editorAttachableInstance.blockRect;
  // 获取当前editor可选中的区域坐标
  var editorSelectableRect = {
    x: Infinity,
    y: Infinity,
    x1: -Infinity,
    y1: -Infinity
  };
  allLines.forEach(function (lineBox) {
    var _getLineSelectionRect = getLineSelectionRect(lineBox, coordinate, lineExpandDirection, blockRect),
      x = _getLineSelectionRect.x,
      y = _getLineSelectionRect.y,
      width = _getLineSelectionRect.width,
      height = _getLineSelectionRect.height;
    var rect = getSecondHalfRect({
      x: x,
      y: y
    }, {
      x: x,
      y: y,
      width: width,
      height: height
    }, coordinate, lineExpandDirection);
    editorSelectableRect.x = Math.min(editorSelectableRect.x, rect.x);
    editorSelectableRect.y = Math.min(editorSelectableRect.y, rect.y);
    editorSelectableRect.x1 = Math.max(editorSelectableRect.x1, rect.x + rect.width);
    editorSelectableRect.y1 = Math.max(editorSelectableRect.y1, rect.y + rect.height);
  });
  // 从相对于editor自身的坐标系转换为相对于画布的坐标系
  var _editor$positionOfEdi = editor.positionOfEditorToPositionOfApp(editorSelectableRect.x, editorSelectableRect.y),
    x1 = _editor$positionOfEdi.x,
    y1 = _editor$positionOfEdi.y;
  var _editor$positionOfEdi2 = editor.positionOfEditorToPositionOfApp(editorSelectableRect.x1, editorSelectableRect.y),
    x2 = _editor$positionOfEdi2.x,
    y2 = _editor$positionOfEdi2.y;
  var _editor$positionOfEdi3 = editor.positionOfEditorToPositionOfApp(editorSelectableRect.x1, editorSelectableRect.y1),
    x3 = _editor$positionOfEdi3.x,
    y3 = _editor$positionOfEdi3.y;
  var _editor$positionOfEdi4 = editor.positionOfEditorToPositionOfApp(editorSelectableRect.x, editorSelectableRect.y1),
    x4 = _editor$positionOfEdi4.x,
    y4 = _editor$positionOfEdi4.y;
  var minX = Math.min(x1, x2, x3, x4);
  var maxX = Math.max(x1, x2, x3, x4);
  var minY = Math.min(y1, y2, y3, y4);
  var maxY = Math.max(y1, y2, y3, y4);
  return {
    x: minX,
    y: minY,
    left: minX,
    right: maxX,
    top: minY,
    bottom: maxY,
    width: maxX - minX,
    height: maxY - minY
  };
}
/**
 * 获取行选中区域的的 rect
 * 需要去除行首的项目符号
 * 总宽度为当前行实际文字的宽度
 * @param lineBox
 * @param coordinate
 * @param lineExpandDirection
 * @param blockRect
 */
function getLineSelectionRect(lineBox, coordinate, lineExpandDirection, blockRect) {
  var logicOffset = getLogicOffsetOfAncestorBox(lineBox, undefined);
  var measure = twipsToPx(lineBox.measure);
  if (lineBox.children.length) {
    var lastTextBox = lineBox.children[lineBox.children.length - 1];
    // 算出当前行实际文字的宽度，去除右侧的冗余
    measure = twipsToPx(lastTextBox.measure + lastTextBox.logicPoint.start);
  }
  var extent = twipsToPx(lineBox.extent);
  var _iterator = _createForOfIteratorHelper$2(lineBox.children),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var box = _step.value;
      // 过滤掉项目符号
      if (!box.isListMark) {
        var boxStart = twipsToPx(box.logicPoint.start);
        logicOffset.start += boxStart;
        measure -= boxStart;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var linePosition = logicOffsetToRealOffset(coordinate, lineExpandDirection, logicOffset, blockRect);
  var realSize = logicSizeToRealSize(coordinate, lineExpandDirection, {
    measure: measure,
    extent: extent
  });
  return Object.assign(Object.assign({}, linePosition), realSize);
}
/**
 * 根据点的位置和当前行的 rect，计算从当前行起始位置到该点位置之间的矩形
 * 点的位置相对于左上角
 * 行的 xy 为行的左上角相对于左上角坐标
 * @param pointPosition
 * @param lineRect
 * @param coordinate
 * @param lineExpandDirection
 * @returns
 */
function getFirstHalfRect(pointPosition, lineRect, coordinate, lineExpandDirection) {
  var pointX = pointPosition.x,
    pointY = pointPosition.y;
  var x = lineRect.x,
    y = lineRect.y,
    width = lineRect.width,
    height = lineRect.height;
  switch (coordinate) {
    case CoordinateZero.LEFT_BOTTOM:
      {
        return {
          x: x,
          y: pointY,
          width: width,
          height: y - pointY
        };
      }
    case CoordinateZero.RIGHT_TOP:
      {
        return {
          x: x - width,
          y: y,
          width: width,
          height: pointY - y
        };
      }
    case CoordinateZero.LEFT_TOP:
      if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
        return {
          x: x,
          y: y,
          width: width,
          height: pointY - y
        };
      }
    default:
      {
        return {
          x: x,
          y: y,
          width: pointX - x,
          height: height
        };
      }
  }
}
/**
 * 根据点的位置和当前行的 rect，计算出从该点到当前行结束位置的矩形
 * 点的位置相对于左上角
 * 行的 xy 为行的左上角相对于左上角坐标
 * @param pointPosition
 * @param lineRect
 * @param coordinate
 * @param lineExpandDirection
 * @returns
 */
function getSecondHalfRect(pointPosition, lineRect, coordinate, lineExpandDirection) {
  var pointX = pointPosition.x,
    pointY = pointPosition.y;
  var x = lineRect.x,
    y = lineRect.y,
    width = lineRect.width,
    height = lineRect.height;
  switch (coordinate) {
    case CoordinateZero.LEFT_BOTTOM:
      {
        return {
          x: x,
          y: y - height,
          width: width,
          height: pointY - (y - height)
        };
      }
    case CoordinateZero.RIGHT_TOP:
      {
        return {
          x: x - width,
          y: pointY,
          width: width,
          height: height + y - pointY
        };
      }
    case CoordinateZero.LEFT_TOP:
      if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
        return {
          x: x,
          y: pointY,
          width: width,
          height: height + y - pointY
        };
      }
    default:
      {
        return {
          x: pointX,
          y: y,
          width: width + x - pointX,
          height: height
        };
      }
  }
}
/**
 * 根据给定的起始点和结束点的位置以及当前行的 rect，计算出两点之间的矩形
 * 点的位置相对于左上角
 * 行的 xy 为行的左上角相对于左上角坐标
 * @param startPosition
 * @param endPosition
 * @param lineRect
 * @param coordinate
 * @param lineExpandDirection
 * @returns
 */
function getPartRect(startPosition, endPosition, lineRect, coordinate, lineExpandDirection) {
  var startX = startPosition.x,
    startY = startPosition.y;
  var endX = endPosition.x,
    endY = endPosition.y;
  var x = lineRect.x,
    y = lineRect.y,
    width = lineRect.width,
    height = lineRect.height;
  switch (coordinate) {
    case CoordinateZero.LEFT_BOTTOM:
      {
        return {
          x: x,
          y: endY,
          width: width,
          height: startY - endY
        };
      }
    case CoordinateZero.RIGHT_TOP:
      {
        return {
          x: x - width,
          y: startY,
          width: width,
          height: endY - startY
        };
      }
    case CoordinateZero.LEFT_TOP:
      if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
        return {
          x: x,
          y: startY,
          width: width,
          height: endY - startY
        };
      }
    default:
      {
        return {
          x: startX,
          y: y,
          width: endX - startX,
          height: height
        };
      }
  }
}

function _createForOfIteratorHelper$1(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$1(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$1(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0; } }
function _arrayLikeToArray$1(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper$c(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$c() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$c() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$c = function _isNativeReflectConstruct() { return !!t; })(); }
var SELECTION_COLOR = 'rgba(187, 225, 255, 0.7)';
var SelectionOverlay = /*#__PURE__*/function (_EditorAttachable) {
  function SelectionOverlay() {
    var _this;
    _classCallCheck(this, SelectionOverlay);
    _this = _callSuper$c(this, SelectionOverlay, arguments);
    _this.selectionRects = [];
    return _this;
  }
  _inherits(SelectionOverlay, _EditorAttachable);
  return _createClass(SelectionOverlay, [{
    key: "detach",
    value: function detach() {
      this.selectionContainer = null;
      this.editor = null;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "attachControlBar",
    value: function attachControlBar(surface) {}
  }, {
    key: "detachControlBar",
    value: function detachControlBar() {}
  }, {
    key: "selection",
    get: function get() {
      var _a;
      return ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.selection) || null;
    }
  }, {
    key: "drawContext",
    get: function get() {
      var _a;
      return (_a = this.editor) === null || _a === void 0 ? void 0 : _a.drawContext;
    }
  }, {
    key: "slatePathToBox",
    get: function get() {
      var _a;
      return (_a = this.editor) === null || _a === void 0 ? void 0 : _a.slatePathToBox;
    }
    /**
     * 获取所有选区的包围盒子
     */
  }, {
    key: "selectionBlockRect",
    get: function get() {
      var _this2 = this;
      var allRects = this.getSelectionRects();
      if (!(allRects === null || allRects === void 0 ? void 0 : allRects.length)) {
        return {
          x: 0,
          y: 0,
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          width: 0,
          height: 0
        };
      }
      var minX = Infinity;
      var minY = Infinity;
      var maxX = -Infinity;
      var maxY = -Infinity;
      allRects.forEach(function (rect) {
        var x = rect.x,
          y = rect.y,
          width = rect.width,
          height = rect.height;
        // 每个点需要应用当前 matrix 之后，再进行比较，找到当前 rect 的边界点
        var _this2$editor$positio = _this2.editor.positionOfEditorToPositionOfApp(x, y),
          x1 = _this2$editor$positio.x,
          y1 = _this2$editor$positio.y;
        var _this2$editor$positio2 = _this2.editor.positionOfEditorToPositionOfApp(x + width, y),
          x2 = _this2$editor$positio2.x,
          y2 = _this2$editor$positio2.y;
        var _this2$editor$positio3 = _this2.editor.positionOfEditorToPositionOfApp(x + width, y + height),
          x3 = _this2$editor$positio3.x,
          y3 = _this2$editor$positio3.y;
        var _this2$editor$positio4 = _this2.editor.positionOfEditorToPositionOfApp(x, y + height),
          x4 = _this2$editor$positio4.x,
          y4 = _this2$editor$positio4.y;
        minX = Math.min(x1, x2, x3, x4, minX);
        maxX = Math.max(x1, x2, x3, x4, maxX);
        minY = Math.min(y1, y2, y3, y4, minY);
        maxY = Math.max(y1, y2, y3, y4, maxY);
      });
      return {
        x: minX,
        y: minY,
        left: minX,
        right: maxX,
        top: minY,
        bottom: maxY,
        width: maxX - minX,
        height: maxY - minY
      };
    }
    /**
     * 获取光标相关数据
     */
  }, {
    key: "caretInfo",
    get: function get() {
      var selection = this.selection,
        caretPosition = this.caretPosition,
        caretBox = this.caretBox;
      if (selection && caretPosition) {
        return {
          caretPosition: caretPosition,
          caretBox: caretBox
        };
      }
      return null;
    }
  }, {
    key: "update",
    value: function update() {
      this.clear();
      this.updateCaretInfo();
      this.render();
    }
  }, {
    key: "clear",
    value: function clear() {
      var _a;
      if (this.selectionContainer) {
        (_a = this.drawContext) === null || _a === void 0 ? void 0 : _a.clearRect(this.selectionContainer);
      }
      this.selectionRects = [];
      this.caretPosition = null;
      this.caretBox = null;
    }
  }, {
    key: "beforeEditorDetached",
    value: function beforeEditorDetached() {
      var _a;
      this.clear();
      if (this.selectionContainer) {
        (_a = this.drawContext) === null || _a === void 0 ? void 0 : _a.removeContainer(this.selectionContainer, {
          type: ContainerType.selection
        });
        this.selectionContainer = null;
      }
    }
  }, {
    key: "getStartPoint",
    value: function getStartPoint() {
      var _a;
      var startPoint = Range.start(this.selection);
      return (_a = this.editor) === null || _a === void 0 ? void 0 : _a.normalizePoint(startPoint);
    }
  }, {
    key: "getEndPoint",
    value: function getEndPoint() {
      var _a;
      var endPoint = Range.end(this.selection);
      return (_a = this.editor) === null || _a === void 0 ? void 0 : _a.normalizePoint(endPoint);
    }
  }, {
    key: "getSelectionRects",
    value: function getSelectionRects() {
      return this.selectionRects;
    }
    // eslint-disable-next-line complexity
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      this.startPosition = null;
      this.endPosition = null;
      this.startLine = null;
      this.endLine = null;
      if (!this.selection) {
        return;
      }
      if (Range.isCollapsed(this.selection)) {
        // 如果没有选区，就不绘制了
        return;
      }
      var startPoint = this.getStartPoint();
      var endPoint = this.getEndPoint();
      var startBoxAndOffset = this.getBoxAndOffset(startPoint);
      var endBoxAndOffset = this.getBoxAndOffset(endPoint);
      // 如果没有获取到起始 box 和结束 box，说明数据出问题了，直接返回，避免报错
      if (!startBoxAndOffset || !endBoxAndOffset) {
        return;
      }
      var _this$normalizeBoxAnd = this.normalizeBoxAndOffset(startBoxAndOffset),
        startBox = _this$normalizeBoxAnd.box,
        startOffset = _this$normalizeBoxAnd.offset;
      var endBox = endBoxAndOffset.box,
        endOffset = endBoxAndOffset.offset;
      var startPosition = this.getPointPosition(startBox, startOffset);
      var endPosition = this.getPointPosition(endBox, endOffset);
      var startLine = this.getPointLine(startBox);
      var endLine = this.getPointLine(endBox);
      var betweenLines = this.getLinesBetween(startLine, endLine);
      this.startPosition = startPosition;
      this.endPosition = endPosition;
      this.startLine = startLine;
      this.endLine = endLine;
      var _getLineSelectionRect = getLineSelectionRect(startLine, this.coordinate, this.lineExpandDirection, this.blockRect),
        startLineX = _getLineSelectionRect.x,
        startLineY = _getLineSelectionRect.y,
        startLineWidth = _getLineSelectionRect.width,
        startLineHeight = _getLineSelectionRect.height;
      var _getLineSelectionRect2 = getLineSelectionRect(endLine, this.coordinate, this.lineExpandDirection, this.blockRect),
        endLineX = _getLineSelectionRect2.x,
        endLineY = _getLineSelectionRect2.y,
        endLineWidth = _getLineSelectionRect2.width,
        endLineHeight = _getLineSelectionRect2.height;
      if (startLine === endLine) {
        // 绘制起点和终点中间区域
        var rect = getPartRect(startPosition, endPosition, {
          x: startLineX,
          y: startLineY,
          width: startLineWidth,
          height: startLineHeight
        }, this.coordinate, this.lineExpandDirection);
        this.fillRect(Object.assign(Object.assign({}, rect), {
          color: SELECTION_COLOR
        }));
        this.selectionRects = [rect];
        return;
      }
      this.selectionRects = [];
      // 绘制起点到行结尾的区域
      var startLineRect = getSecondHalfRect(startPosition, {
        x: startLineX,
        y: startLineY,
        width: startLineWidth,
        height: startLineHeight
      }, this.coordinate, this.lineExpandDirection);
      this.selectionRects.push(startLineRect);
      this.fillRect(Object.assign(Object.assign({}, startLineRect), {
        color: SELECTION_COLOR
      }));
      // 绘制行开始到终点的区域
      var endLineRect = getFirstHalfRect(endPosition, {
        x: endLineX,
        y: endLineY,
        width: endLineWidth,
        height: endLineHeight
      }, this.coordinate, this.lineExpandDirection);
      this.selectionRects.push(endLineRect);
      this.fillRect(Object.assign(Object.assign({}, endLineRect), {
        color: SELECTION_COLOR
      }));
      // 绘制整行的区域
      // 可以看做起始点是行的起始点，计算起始点到行结尾的矩形区域
      betweenLines.forEach(function (lineBox) {
        var _getLineSelectionRect3 = getLineSelectionRect(lineBox, _this3.coordinate, _this3.lineExpandDirection, _this3.blockRect),
          x = _getLineSelectionRect3.x,
          y = _getLineSelectionRect3.y,
          width = _getLineSelectionRect3.width,
          height = _getLineSelectionRect3.height;
        var rect = getSecondHalfRect({
          x: x,
          y: y
        }, {
          x: x,
          y: y,
          width: width,
          height: height
        }, _this3.coordinate, _this3.lineExpandDirection);
        _this3.selectionRects.push(rect);
        _this3.fillRect(Object.assign(Object.assign({}, rect), {
          color: SELECTION_COLOR
        }));
      });
    }
    /**
     * 计算光标位置，也就是 focus 点的位置
     * @returns
     */
  }, {
    key: "updateCaretInfo",
    value: function updateCaretInfo() {
      if (!this.selection) {
        return;
      }
      var focusPoint = this.selection.focus;
      var focusBoxAndOffset = this.getBoxAndOffset(focusPoint);
      if (!focusBoxAndOffset) {
        return;
      }
      var focusBox = focusBoxAndOffset.box,
        focusOffset = focusBoxAndOffset.offset;
      var focusPosition = this.getPointPosition(focusBox, focusOffset);
      this.caretPosition = focusPosition;
      this.caretBox = focusBox;
    }
    /**
     * 绘制选区
     * 绘制的时候需要加上当前编辑器的偏移
     * @param option
     */
  }, {
    key: "fillRect",
    value: function fillRect(option) {
      var _a, _b;
      if (!this.selectionContainer) {
        this.selectionContainer = (_a = this.drawContext) === null || _a === void 0 ? void 0 : _a.createContainer(TEXT_SELECTION_INDEX, {
          type: ContainerType.selection
        });
      }
      (_b = this.drawContext) === null || _b === void 0 ? void 0 : _b.fillRect(this.selectionContainer, Object.assign(Object.assign({}, option), {
        x: option.x + this.blockRect.x,
        y: option.y + this.blockRect.y
      }));
    }
  }, {
    key: "getLinesBetween",
    value: function getLinesBetween(startLine, endLine) {
      if (startLine === endLine) {
        return [];
      }
      var lines = [];
      var current = startLine;
      while (true) {
        var nextLine = getNextBox(current);
        if (nextLine === endLine) {
          break;
        }
        lines.push(nextLine);
        current = nextLine;
      }
      return lines;
    }
  }, {
    key: "getPointLine",
    value: function getPointLine(box) {
      return getAncestorBox(box, BoxKind.TextLine);
    }
    /**
     * 获取当前文字在整个文档中的位置
     */
  }, {
    key: "getPointPosition",
    value: function getPointPosition(box, offset) {
      if (!box) {
        return;
      }
      var logicOffset = getCharacterLogicOffsetOfDocument(box, offset);
      return logicOffsetToRealOffset(this.coordinate, this.lineExpandDirection, logicOffset, this.blockRect);
    }
    /**
     * 获取当前文字对应的 box 以及在 box 中的偏移
     * @param point
     * @returns 表示在当前 box 索引为 offset 文字之后的位置
     */
  }, {
    key: "getBoxAndOffset",
    value: function getBoxAndOffset(point) {
      var _a, _b, _c;
      if (!point) {
        return null;
      }
      var leafBoxes = (_a = this.slatePathToBox) === null || _a === void 0 ? void 0 : _a.getBox(point.path);
      if (!leafBoxes) {
        return null;
      }
      var indexOfRun = point.offset - 1;
      var _iterator = _createForOfIteratorHelper$1(leafBoxes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var box = _step.value;
          if (((_b = box === null || box === void 0 ? void 0 : box.runRange) === null || _b === void 0 ? void 0 : _b.gcpBegin) + box.text.length >= indexOfRun) {
            var offset = indexOfRun - ((_c = box === null || box === void 0 ? void 0 : box.runRange) === null || _c === void 0 ? void 0 : _c.gcpBegin);
            var resBox = box;
            if (offset >= box.text.length) {
              resBox = getNextBox(box);
              offset = 0;
            }
            return {
              box: resBox,
              offset: offset
            };
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }
    /**
     * 如果当前位置在 box 的最后一个位置，那就用下一个 box 来表示
     * 比如选区起始点在行尾时，把这个点直接移到下一行开头，避免移动端选区控制条显示不好看
     */
  }, {
    key: "normalizeBoxAndOffset",
    value: function normalizeBoxAndOffset(_ref) {
      var box = _ref.box,
        offset = _ref.offset;
      if (offset === box.text.length - 1) {
        // 当前位置在 box 的最后一个位置
        // 找到下一个同级的非项目符号 box
        var nextBox = getNextBox(box);
        while (nextBox.isListMark) {
          nextBox = getNextBox(nextBox);
        }
        return {
          box: nextBox,
          offset: -1
        };
      }
      return {
        box: box,
        offset: offset
      };
    }
  }]);
}(EditorAttachable);

var css_248z$1 = ".style_selection-control-bar__RJ6cD {\n  background-color: rgb(30, 111, 255);\n  position: absolute;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n}\n.style_selection-control-bar__RJ6cD .style_selection-control-hot-spot__SYM0n {\n  position: absolute;\n  touch-action: none;\n}\n.style_selection-control-bar__RJ6cD .style_selection-control-symbol__pTxKX {\n  position: absolute;\n  touch-action: none;\n}\n\n.style_ios-selection-control-bar__v-9Ha .style_selection-control-symbol__pTxKX .style_inner-symbol__JxLWR {\n  transform-origin: center center;\n  border-radius: 50%;\n  width: 100%;\n  height: 100%;\n  background: #1e6fff;\n  transition: transform 300ms;\n}\n\n.style_ios-start-selection-control-bar__SJAHV .style_selection-control-symbol__pTxKX.style_left-top-symbol__sRVHr {\n  left: 50%;\n  top: 0;\n  transform: translate(-50%, -100%);\n}\n.style_ios-start-selection-control-bar__SJAHV .style_selection-control-symbol__pTxKX.style_right-top-symbol__1Tpxy {\n  left: 100%;\n  top: 50%;\n  transform: translate(0, -50%);\n}\n.style_ios-start-selection-control-bar__SJAHV .style_selection-control-symbol__pTxKX.style_left-bottom-symbol__Wr-Q3 {\n  left: 0;\n  top: 50%;\n  transform: translate(-100%, -50%);\n}\n.style_ios-start-selection-control-bar__SJAHV .style_selection-control-symbol__pTxKX.style_left-top-horizontal-symbol__kJx1u {\n  left: 0;\n  top: 0;\n  transform: translate(-100%, -50%);\n}\n.style_ios-start-selection-control-bar__SJAHV .style_selection-control-hot-spot__SYM0n.style_left-top-hot-spot__bLSRD {\n  top: 100%;\n  left: 50%;\n  transform: translate(-50%, -100%);\n}\n.style_ios-start-selection-control-bar__SJAHV .style_selection-control-hot-spot__SYM0n.style_right-top-hot-spot__hKSLx {\n  top: 50%;\n  left: 0;\n  transform: translate(0, -50%);\n}\n.style_ios-start-selection-control-bar__SJAHV .style_selection-control-hot-spot__SYM0n.style_left-bottom-hot-spot__zz-WE {\n  left: 100%;\n  top: 50%;\n  transform: translate(-100%, -50%);\n}\n\n.style_ios-end-selection-control-bar__KmL5N .style_selection-control-symbol__pTxKX.style_left-top-symbol__sRVHr {\n  left: 50%;\n  top: 100%;\n  transform: translate(-50%, 0);\n}\n.style_ios-end-selection-control-bar__KmL5N .style_selection-control-symbol__pTxKX.style_right-top-symbol__1Tpxy {\n  left: 0;\n  top: 50%;\n  transform: translate(-100%, -50%);\n}\n.style_ios-end-selection-control-bar__KmL5N .style_selection-control-symbol__pTxKX.style_left-bottom-symbol__Wr-Q3 {\n  left: 100%;\n  top: 50%;\n  transform: translate(0, -50%);\n}\n.style_ios-end-selection-control-bar__KmL5N .style_selection-control-symbol__pTxKX.style_left-top-horizontal-symbol__kJx1u {\n  left: 100%;\n  top: 0;\n  transform: translate(0, -50%);\n}\n.style_ios-end-selection-control-bar__KmL5N .style_selection-control-hot-spot__SYM0n.style_left-top-hot-spot__bLSRD {\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n}\n.style_ios-end-selection-control-bar__KmL5N .style_selection-control-hot-spot__SYM0n.style_right-top-hot-spot__hKSLx {\n  left: 100%;\n  top: 50%;\n  transform: translate(-100%, -50%);\n}\n.style_ios-end-selection-control-bar__KmL5N .style_selection-control-hot-spot__SYM0n.style_left-bottom-hot-spot__zz-WE {\n  top: 50%;\n  left: 0;\n  transform: translate(0, -50%);\n}\n\n.style_android-selection-control-bar__0bLxg .style_selection-control-symbol__pTxKX {\n  position: absolute;\n  transform-origin: center center;\n}\n.style_android-selection-control-bar__0bLxg .style_selection-control-symbol__pTxKX .style_inner-symbol__JxLWR {\n  width: 100%;\n  height: 100%;\n  background-size: contain;\n  background-repeat: no-repeat;\n  transition: transform 300ms;\n}\n\n.style_android-start-selection-control-bar__ENhyk .style_selection-control-symbol__pTxKX .style_inner-symbol__JxLWR {\n  background-image: url(data:image/png;base64,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);\n  transform-origin: 100% 0;\n}\n.style_android-start-selection-control-bar__ENhyk .style_selection-control-symbol__pTxKX.style_left-top-symbol__sRVHr {\n  left: 100%;\n  top: 100%;\n  transform: translate(-100%, -5%);\n}\n.style_android-start-selection-control-bar__ENhyk .style_selection-control-symbol__pTxKX.style_right-top-symbol__1Tpxy {\n  left: 0;\n  top: 100%;\n  transform: rotate(90deg) translate(-100%, 95%);\n}\n.style_android-start-selection-control-bar__ENhyk .style_selection-control-symbol__pTxKX.style_left-bottom-symbol__Wr-Q3 {\n  left: 100%;\n  top: 0%;\n  transform: rotate(-90deg) translate(0, -5%);\n}\n.style_android-start-selection-control-bar__ENhyk .style_selection-control-symbol__pTxKX.style_left-top-horizontal-symbol__kJx1u {\n  left: 100%;\n  top: 0%;\n  transform: rotate(180deg) translate(0, 90%);\n}\n.style_android-start-selection-control-bar__ENhyk .style_selection-control-hot-spot__SYM0n.style_left-top-hot-spot__bLSRD {\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n}\n.style_android-start-selection-control-bar__ENhyk .style_selection-control-hot-spot__SYM0n.style_right-top-hot-spot__hKSLx {\n  left: 100%;\n  top: 50%;\n  transform: translate(-100%, -50%);\n}\n.style_android-start-selection-control-bar__ENhyk .style_selection-control-hot-spot__SYM0n.style_left-bottom-hot-spot__zz-WE {\n  top: 50%;\n  left: 0;\n  transform: translate(0, -50%);\n}\n\n.style_android-end-selection-control-bar__l9rqD .style_selection-control-symbol__pTxKX .style_inner-symbol__JxLWR {\n  background-image: url(data:image/png;base64,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);\n  transform-origin: 0 0;\n}\n.style_android-end-selection-control-bar__l9rqD .style_selection-control-symbol__pTxKX.style_left-top-symbol__sRVHr {\n  top: 100%;\n  left: 0;\n}\n.style_android-end-selection-control-bar__l9rqD .style_selection-control-symbol__pTxKX.style_right-top-symbol__1Tpxy {\n  top: 0;\n  left: 0;\n  transform: rotate(90deg) translate(0, 95%);\n}\n.style_android-end-selection-control-bar__l9rqD .style_selection-control-symbol__pTxKX.style_left-bottom-symbol__Wr-Q3 {\n  left: 100%;\n  top: 100%;\n  transform: rotate(-90deg) translate(100%, -5%);\n}\n.style_android-end-selection-control-bar__l9rqD .style_selection-control-symbol__pTxKX.style_left-top-horizontal-symbol__kJx1u {\n  left: 100%;\n  top: 100%;\n  transform: rotate(0deg) translate(0, -10%);\n}\n.style_android-end-selection-control-bar__l9rqD .style_selection-control-hot-spot__SYM0n.style_left-top-hot-spot__bLSRD {\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n}\n.style_android-end-selection-control-bar__l9rqD .style_selection-control-hot-spot__SYM0n.style_right-top-hot-spot__hKSLx {\n  left: 100%;\n  top: 50%;\n  transform: translate(-100%, -50%);\n}\n.style_android-end-selection-control-bar__l9rqD .style_selection-control-hot-spot__SYM0n.style_left-bottom-hot-spot__zz-WE {\n  top: 50%;\n  left: 0;\n  transform: translate(0, -50%);\n}";
var style$1 = {"selection-control-bar":"style_selection-control-bar__RJ6cD","selection-control-hot-spot":"style_selection-control-hot-spot__SYM0n","selection-control-symbol":"style_selection-control-symbol__pTxKX","ios-selection-control-bar":"style_ios-selection-control-bar__v-9Ha","inner-symbol":"style_inner-symbol__JxLWR","ios-start-selection-control-bar":"style_ios-start-selection-control-bar__SJAHV","left-top-symbol":"style_left-top-symbol__sRVHr","right-top-symbol":"style_right-top-symbol__1Tpxy","left-bottom-symbol":"style_left-bottom-symbol__Wr-Q3","left-top-horizontal-symbol":"style_left-top-horizontal-symbol__kJx1u","left-top-hot-spot":"style_left-top-hot-spot__bLSRD","right-top-hot-spot":"style_right-top-hot-spot__hKSLx","left-bottom-hot-spot":"style_left-bottom-hot-spot__zz-WE","ios-end-selection-control-bar":"style_ios-end-selection-control-bar__KmL5N","android-selection-control-bar":"style_android-selection-control-bar__0bLxg","android-start-selection-control-bar":"style_android-start-selection-control-bar__ENhyk","android-end-selection-control-bar":"style_android-end-selection-control-bar__l9rqD","selectionControlBar":"style_selection-control-bar__RJ6cD","selectionControlHotSpot":"style_selection-control-hot-spot__SYM0n","selectionControlSymbol":"style_selection-control-symbol__pTxKX","iosSelectionControlBar":"style_ios-selection-control-bar__v-9Ha","innerSymbol":"style_inner-symbol__JxLWR","iosStartSelectionControlBar":"style_ios-start-selection-control-bar__SJAHV","leftTopSymbol":"style_left-top-symbol__sRVHr","rightTopSymbol":"style_right-top-symbol__1Tpxy","leftBottomSymbol":"style_left-bottom-symbol__Wr-Q3","leftTopHorizontalSymbol":"style_left-top-horizontal-symbol__kJx1u","leftTopHotSpot":"style_left-top-hot-spot__bLSRD","rightTopHotSpot":"style_right-top-hot-spot__hKSLx","leftBottomHotSpot":"style_left-bottom-hot-spot__zz-WE","iosEndSelectionControlBar":"style_ios-end-selection-control-bar__KmL5N","androidSelectionControlBar":"style_android-selection-control-bar__0bLxg","androidStartSelectionControlBar":"style_android-start-selection-control-bar__ENhyk","androidEndSelectionControlBar":"style_android-end-selection-control-bar__l9rqD"};
styleInject(css_248z$1);

/**
 * 获取触摸点或鼠标点的信息
 * 如果传入的是 touch 事件，返回第一个触摸点的信息
 * 否则返回事件对象，其中包含鼠标的信息
 * @param event
 * @returns
 */
function getTouchOrMouseInfo(event) {
  if (isTouchEvent(event)) {
    return event.changedTouches[0];
  }
  return event;
}
function isTouchEvent(event) {
  return 'changedTouches' in event;
}

function _callSuper$b(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$b() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$b() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$b = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 抽象类，主要处理了 touch 时的位置偏移，在计算当前 touch 点对应的 point 时会把这部分偏移减去
 */
var TouchController = /*#__PURE__*/function (_EditorAttachable) {
  function TouchController() {
    var _this;
    _classCallCheck(this, TouchController);
    _this = _callSuper$b(this, TouchController, arguments);
    /**
     * 在 touchstart 时记录的触摸位置和当前行 extent 方向的偏移量
     * 在后续 touchmove 时，根据触摸位置计算 point 时都需要减去这个偏移量
     * 因为触摸热区比较大，可能会跨行，touchmove 时不考虑这个偏移的话，可能一开始 move 就会使选区到另一行
     */
    _this.touchstartExtentOffset = 0;
    return _this;
  }
  /**
   * 更新当前控制器所在行
   * @param lineBox
   */
  _inherits(TouchController, _EditorAttachable);
  return _createClass(TouchController, [{
    key: "updateCurrentLine",
    value: function updateCurrentLine(lineBox) {
      this.currentLine = lineBox;
    }
    /**
     * 在 touchstart 时更新触摸位置和当前行 extent 方向的偏移量
     * @param event
     */
  }, {
    key: "updateTouchstartExtentOffset",
    value: function updateTouchstartExtentOffset(event) {
      var currentLineExtentOffset = this.getCurrentLineExtentOffset();
      var _this$getPositionFrom = this.getPositionFromTouch(event),
        x = _this$getPositionFrom.x,
        y = _this$getPositionFrom.y;
      var coordinate = this.coordinate,
        lineExpandDirection = this.lineExpandDirection;
      switch (coordinate) {
        case CoordinateZero.LEFT_BOTTOM:
          {
            this.touchstartExtentOffset = x - currentLineExtentOffset;
            break;
          }
        case CoordinateZero.RIGHT_TOP:
          {
            this.touchstartExtentOffset = x - currentLineExtentOffset;
            break;
          }
        case CoordinateZero.LEFT_TOP:
          if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
            this.touchstartExtentOffset = x - currentLineExtentOffset;
            break;
          }
        default:
          {
            this.touchstartExtentOffset = y - currentLineExtentOffset;
            break;
          }
      }
    }
  }, {
    key: "clearTouchstartExtentOffset",
    value: function clearTouchstartExtentOffset() {
      this.touchstartExtentOffset = 0;
    }
    /**
     * 根据触摸位置获取对应的 point
     * @param event
     * @returns
     */
  }, {
    key: "getPointFromTouch",
    value: function getPointFromTouch(event) {
      if (!this.editor) {
        return;
      }
      var position = this.getPositionFromTouch(event);
      var _this$processPosition = this.processPosition(position),
        x = _this$processPosition.x,
        y = _this$processPosition.y;
      var pointInfo = this.editor.layoutManager.getPointFromViewPoint(x, y);
      return pointInfo === null || pointInfo === void 0 ? void 0 : pointInfo.point;
    }
    /**
     * 根据当前 touch 事件获取到触摸点相对于 editor 的位置
     * @param event
     * @returns
     */
  }, {
    key: "getPositionFromTouch",
    value: function getPositionFromTouch(event) {
      if (!this.editor) {
        return {
          x: 0,
          y: 0
        };
      }
      var _getTouchOrMouseInfo = getTouchOrMouseInfo(event),
        pageX = _getTouchOrMouseInfo.pageX,
        pageY = _getTouchOrMouseInfo.pageY;
      var _this$appPosition = this.appPosition,
        appX = _this$appPosition.x,
        appY = _this$appPosition.y;
      return this.editor.positionOfAppToPositionOfEditor(pageX - appX, pageY - appY);
    }
    /**
     * 获取当前行 extent 方向中心点的偏移，用于计算 touchstartExtentOffset
     */
  }, {
    key: "getCurrentLineExtentOffset",
    value: function getCurrentLineExtentOffset() {
      var _getLogicOffsetOfAnce = getLogicOffsetOfAncestorBox(this.currentLine, undefined),
        before = _getLogicOffsetOfAnce.before;
      var extent = twipsToPx(this.currentLine.extent);
      var logicOffset = before + extent / 2;
      switch (this.coordinate) {
        case CoordinateZero.RIGHT_TOP:
          {
            return this.blockRect.width - logicOffset;
          }
        case CoordinateZero.LEFT_TOP:
        case CoordinateZero.LEFT_BOTTOM:
        default:
          {
            return logicOffset;
          }
      }
    }
    /**
     * 根据 touchstartExtentOffset 重新计算下当前触摸的位置，减去 touchstartExtentOffset 这部分偏移
     * @param position
     * @returns
     */
  }, {
    key: "processPosition",
    value: function processPosition(position) {
      var x = position.x,
        y = position.y;
      var coordinate = this.coordinate,
        touchstartExtentOffset = this.touchstartExtentOffset,
        lineExpandDirection = this.lineExpandDirection;
      switch (coordinate) {
        case CoordinateZero.LEFT_BOTTOM:
          {
            return {
              x: x - touchstartExtentOffset,
              y: y
            };
          }
        case CoordinateZero.RIGHT_TOP:
          {
            return {
              x: x - touchstartExtentOffset,
              y: y
            };
          }
        case CoordinateZero.LEFT_TOP:
          if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
            return {
              x: x - touchstartExtentOffset,
              y: y
            };
          }
        default:
          {
            return {
              x: x,
              y: y - touchstartExtentOffset
            };
          }
      }
    }
  }]);
}(EditorAttachable);

function _callSuper$a(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$a() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$a() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$a = function _isNativeReflectConstruct() { return !!t; })(); }
var SelectionControlBar = /*#__PURE__*/function (_TouchController) {
  function SelectionControlBar(_ref) {
    var _this;
    var startDragCallback = _ref.startDragCallback,
      stopDragCallback = _ref.stopDragCallback;
    _classCallCheck(this, SelectionControlBar);
    _this = _callSuper$a(this, SelectionControlBar);
    _this.isStartDrag = false;
    _this.handleMouseDown = function (event) {
      if (Editor.supportMouseOnTouchScreen) {
        // 触发点击之后再绑定 mousemove 和 mouseup 事件，降低对外界的影响
        // mousemove 绑定在 document 上，否则拖动过程中超出元素本身的话响应不到事件
        document.addEventListener('mousemove', _this.handleTouchMove);
        document.addEventListener('mouseup', _this.handleMouseUp);
        _this.handleTouchStart(event);
      } else {
        event.preventDefault();
        event.stopPropagation();
      }
    };
    _this.handleMouseUp = function (event) {
      _this.unregisterDocumentMouseEvent();
      _this.handleTouchEnd(event);
    };
    _this.handleTouchStart = function (event) {
      // 阻止下默认事件，避免长按出现右键菜单以及导致输入框失焦
      event.preventDefault();
      event.stopPropagation();
      _this.startDrag();
      _this.initOtherPoint();
      _this.updateTouchstartExtentOffset(event);
    };
    _this.handleTouchMove = function (event) {
      event.preventDefault();
      if (!_this.isStartDrag) {
        return;
      }
      if (!_this.editor) {
        return;
      }
      _this.updateSelectionFromTouch(event);
    };
    // eslint-disable-next-line @typescript-eslint/member-ordering
    _this.updateSelectionFromTouch = throttle_1(function (event) {
      var _a;
      var point = _this.getPointFromTouch(event);
      if (!point) {
        return;
      }
      // 保证在拖动过程中不会出现光标状态
      if (_this.isSamePoint(_this.otherPoint, point)) {
        return;
      }
      (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.model.setSelectionPoints(_this.otherPoint, point);
    }, 50);
    _this.handleTouchEnd = function (event) {
      // 避免 touchend 事件冒泡到上面，导致一些不可控的逻辑（比如失焦）
      event.stopPropagation();
      _this.stopDrag();
      _this.clearTouchstartExtentOffset();
    };
    _this.startDragCallback = startDragCallback;
    _this.stopDragCallback = stopDragCallback;
    _this.initControlBar();
    _this.initControlSymbol();
    _this.initHotSpot();
    _this.registerEvent();
    return _this;
  }
  _inherits(SelectionControlBar, _TouchController);
  return _createClass(SelectionControlBar, [{
    key: "controlBarLineWidth",
    get:
    // 为了保证控制条的各个尺寸不受缩放影响，需要使用 transformScale 逆向计算一下
    // 控制条线条粗细
    function get() {
      return 2 / this.transformScale;
    }
    // 为了扩大热区，给触摸区域增加的额外逻辑高度
  }, {
    key: "hotSpotExtraExtent",
    get: function get() {
      return this.hotSpotExtraExtentRealSize / this.transformScale;
    }
    // 触摸区域逻辑宽度
  }, {
    key: "hotSpotMeasure",
    get: function get() {
      return this.hotSpotMeasureRealSize / this.transformScale;
    }
    // 拖拽标志逻辑宽度
  }, {
    key: "controlSymbolMeasure",
    get: function get() {
      return this.controlSymbolMeasureRealSize / this.transformScale;
    }
    // 拖拽标志逻辑高度
  }, {
    key: "controlSymbolExtent",
    get: function get() {
      return this.controlSymbolExtentRealSize / this.transformScale;
    }
  }, {
    key: "hide",
    value: function hide() {
      // 重置位置，避免影响外面容器的滚动条位置
      this.controlBar.style.cssText += 'left: 0px; top: 0px; visibility: hidden;';
    }
  }, {
    key: "show",
    value: function show(rect) {
      this.updateHotSpot(rect);
      this.updateControlSymbol();
      this.updateControlBar(rect);
      this.controlBar.style.visibility = 'visible';
      this.delayEnableEvent();
    }
  }, {
    key: "attach",
    value: function attach(surface) {
      this.surfaceDom = surface;
      this.surfaceDom.appendChild(this.controlBar);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.surfaceDom.removeChild(this.controlBar);
      this.unregisterEvent();
    }
    /**
     * 注意：这里计算的值是错误的！
     *
     * 理论上来说，这里应该是获取 hotpot 的 rect
     * 但是由于 getBoundingClientRect 获取到的位置不一定是元素左上角的位置（如果元素有旋转、翻转之类的）
     * 导致计算出来的位置不符合预期
     * 所以改为了计算 controlSymbol 的 rect，因为 controlSymbol 的大小比较小，计算出来偏差会小一点
     * 暂时没想到更好的办法
     */
  }, {
    key: "rect",
    get: function get() {
      // 获取 symbol 相对于屏幕视口的位置
      var _this$controlSymbol$g = this.controlSymbol.getBoundingClientRect(),
        controlSymbolX = _this$controlSymbol$g.x,
        controlSymbolY = _this$controlSymbol$g.y;
      var width = parseFloat(this.controlSymbol.style.width);
      var height = parseFloat(this.controlSymbol.style.height);
      // 获取 editor 所在 app 相对于屏幕的位置
      var _this$editor$appPosit = this.editor.appPosition,
        appX = _this$editor$appPosit.x,
        appY = _this$editor$appPosit.y;
      // 计算出 symbol 相对于 editor 所在 app 的位置
      var positionXOfApp = controlSymbolX - appX;
      var positionYOfApp = controlSymbolY - appY;
      // 计算出 symbol 相对于 editor 的位置
      var _this$editor$position = this.editor.positionOfAppToPositionOfEditor(positionXOfApp, positionYOfApp),
        positionXOfEditor = _this$editor$position.x,
        positionYOfEditor = _this$editor$position.y;
      return {
        width: width * this.scale,
        height: height * this.scale,
        x: positionXOfEditor,
        y: positionYOfEditor
      };
    }
    /**
     * 外界调用，切换正在更新的方向（视觉上），具体可以见 openDragMark 的注释
     * 切换过程中去掉 transform 的渐变动画
     * @param direction
     */
  }, {
    key: "changeDirection",
    value: function changeDirection(direction) {
      var _this2 = this;
      this.innerSymbol.style.transition = 'none';
      if (direction === this.direction) {
        this.openDragMark();
      } else {
        this.closeDragMark();
      }
      requestAnimationFrame(function () {
        _this2.innerSymbol.style.transition = 'transform 300ms';
      });
    }
  }, {
    key: "closeDragMark",
    value: function closeDragMark() {
      this.innerSymbol.style.transform = 'none';
    }
    /**
     * 标识当前正在拖动的控制点（视觉上）
     * 这个和实际拖动的控制点可能不一样，实际拖动事件永远是 touchstart 是触摸的那个控制点触发的
     * 可能会有这种情况：
     *  拖动的是 start 控制条，视觉上是 start 点在移动，但是在当前 start 点和 end 点位置切换之后，视觉上变为 end 点在移动
     *  此时，拖动事件还是由初始 start 点触发，所以此时就需要切换下两个控制点的拖动 mark，保持和视觉统一
     */
  }, {
    key: "openDragMark",
    value: function openDragMark() {
      this.innerSymbol.style.transform = 'scale(1.3)';
    }
  }, {
    key: "initControlBar",
    value: function initControlBar() {
      var controlBar = document.createElement('div');
      controlBar.classList.add(style$1.selectionControlBar);
      this.controlBar = controlBar;
    }
    /**
     * 延迟打开 controlBar 事件，否则影响业务中三击选中段落的功能
     */
  }, {
    key: "delayEnableEvent",
    value: function delayEnableEvent() {
      var _this3 = this;
      clearTimeout(this.timer);
      this.controlBar.style.pointerEvents = 'none';
      this.timer = setTimeout(function () {
        _this3.controlBar.style.pointerEvents = 'auto';
      }, 350);
    }
  }, {
    key: "initControlSymbol",
    value: function initControlSymbol() {
      var controlSymbol = document.createElement('div');
      controlSymbol.classList.add(style$1.selectionControlSymbol);
      this.controlSymbol = controlSymbol;
      var innerSymbol = document.createElement('div');
      innerSymbol.classList.add(style$1.innerSymbol);
      controlSymbol.appendChild(innerSymbol);
      this.innerSymbol = innerSymbol;
      this.controlBar.appendChild(controlSymbol);
    }
  }, {
    key: "initHotSpot",
    value: function initHotSpot() {
      var hotSpot = document.createElement('div');
      hotSpot.classList.add(style$1.selectionControlHotSpot);
      this.hotSpot = hotSpot;
      this.controlBar.appendChild(hotSpot);
    }
  }, {
    key: "registerEvent",
    value: function registerEvent() {
      this.hotSpot.addEventListener('mousedown', this.handleMouseDown);
      this.hotSpot.addEventListener('touchstart', this.handleTouchStart);
      this.hotSpot.addEventListener('touchmove', this.handleTouchMove);
      this.hotSpot.addEventListener('touchend', this.handleTouchEnd);
      this.hotSpot.addEventListener('touchcancel', this.handleTouchEnd);
    }
  }, {
    key: "unregisterEvent",
    value: function unregisterEvent() {
      this.unregisterDocumentMouseEvent();
      this.hotSpot.removeEventListener('mousedown', this.handleMouseDown);
      this.hotSpot.removeEventListener('touchstart', this.handleTouchStart);
      this.hotSpot.removeEventListener('touchmove', this.handleTouchMove);
      this.hotSpot.removeEventListener('touchend', this.handleTouchEnd);
      this.hotSpot.removeEventListener('touchcancel', this.handleTouchEnd);
    }
  }, {
    key: "unregisterDocumentMouseEvent",
    value: function unregisterDocumentMouseEvent() {
      document.removeEventListener('mousemove', this.handleTouchMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: "isSamePoint",
    value: function isSamePoint(point1, point2) {
      var _a;
      var slate = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.model.slate;
      if (!slate) {
        return false;
      }
      return slate.isSamePoint(point1, point2);
    }
  }, {
    key: "startDrag",
    value: function startDrag() {
      this.isStartDrag = true;
      this.openDragMark();
      this.startDragCallback();
    }
  }, {
    key: "stopDrag",
    value: function stopDrag() {
      this.isStartDrag = false;
      this.closeDragMark();
      this.stopDragCallback();
    }
  }, {
    key: "updateControlBar",
    value: function updateControlBar(rect) {
      var x = rect.x,
        y = rect.y,
        width = rect.width,
        height = rect.height;
      this.controlBar.style.cssText = "left: ".concat(x, "px; top: ").concat(y, "px; width: ").concat(width, "px; height: ").concat(height, "px");
    }
    /**
     * 更新控制标识的大小和 class 类名
     */
  }, {
    key: "updateControlSymbol",
    value: function updateControlSymbol() {
      this.controlSymbol.classList.remove(style$1.leftBottomSymbol);
      this.controlSymbol.classList.remove(style$1.rightTopSymbol);
      this.controlSymbol.classList.remove(style$1.leftTopSymbol);
      this.controlSymbol.classList.remove(style$1.leftTopHorizontalSymbol);
      var controlSymbolMeasure = this.controlSymbolMeasure,
        controlSymbolExtent = this.controlSymbolExtent,
        coordinate = this.coordinate,
        lineExpandDirection = this.lineExpandDirection;
      var controlSymbolWidth;
      var controlSymbolHeight;
      switch (coordinate) {
        case CoordinateZero.LEFT_BOTTOM:
          {
            this.controlSymbol.classList.add(style$1.leftBottomSymbol);
            controlSymbolWidth = controlSymbolExtent;
            controlSymbolHeight = controlSymbolMeasure;
            break;
          }
        case CoordinateZero.RIGHT_TOP:
          {
            this.controlSymbol.classList.add(style$1.rightTopSymbol);
            controlSymbolWidth = controlSymbolExtent;
            controlSymbolHeight = controlSymbolMeasure;
            break;
          }
        case CoordinateZero.LEFT_TOP:
          if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
            this.controlSymbol.classList.add(style$1.leftTopHorizontalSymbol);
            controlSymbolWidth = controlSymbolExtent;
            controlSymbolHeight = controlSymbolMeasure;
            break;
          }
        default:
          {
            this.controlSymbol.classList.add(style$1.leftTopSymbol);
            controlSymbolWidth = controlSymbolMeasure;
            controlSymbolHeight = controlSymbolExtent;
            break;
          }
      }
      this.controlSymbol.style.cssText += "width: ".concat(controlSymbolWidth, "px; height: ").concat(controlSymbolHeight, "px;");
    }
    /**
     * 更新控制条的大小和 class 类名
     * rect 参数是【控制条那条线】相对于画布的位置
     * hotSpot 逻辑高度方向需要在控制条基础上往外延伸出 hotSpotExtraExtent 的距离，用于覆盖住拖拽标志
     * @param rect
     */
  }, {
    key: "updateHotSpot",
    value: function updateHotSpot(rect) {
      this.hotSpot.classList.remove(style$1.leftBottomHotSpot);
      this.hotSpot.classList.remove(style$1.rightTopHotSpot);
      this.hotSpot.classList.remove(style$1.leftTopHotSpot);
      var hotSpotMeasure = this.hotSpotMeasure,
        hotSpotExtraExtent = this.hotSpotExtraExtent,
        coordinate = this.coordinate,
        lineExpandDirection = this.lineExpandDirection;
      var width = rect.width,
        height = rect.height;
      var hotSpotWidth;
      var hotSpotHeight;
      switch (coordinate) {
        case CoordinateZero.LEFT_BOTTOM:
          {
            this.hotSpot.classList.add(style$1.leftBottomHotSpot);
            hotSpotWidth = width + hotSpotExtraExtent;
            hotSpotHeight = hotSpotMeasure;
            break;
          }
        case CoordinateZero.RIGHT_TOP:
          {
            this.hotSpot.classList.add(style$1.rightTopHotSpot);
            hotSpotWidth = width + hotSpotExtraExtent;
            hotSpotHeight = hotSpotMeasure;
            break;
          }
        case CoordinateZero.LEFT_TOP:
          if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
            this.hotSpot.classList.add(style$1.leftBottomHotSpot);
            hotSpotWidth = width + hotSpotExtraExtent;
            hotSpotHeight = hotSpotMeasure;
            break;
          }
        default:
          {
            this.hotSpot.classList.add(style$1.leftTopHotSpot);
            hotSpotWidth = hotSpotMeasure;
            hotSpotHeight = height + hotSpotExtraExtent;
            break;
          }
      }
      this.hotSpot.style.cssText += "width: ".concat(hotSpotWidth, "px; height: ").concat(hotSpotHeight, "px;");
    }
  }]);
}(TouchController);

function _callSuper$9(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$9() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$9() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$9 = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet$4(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
var AndroidSelectionControlBar = /*#__PURE__*/function (_SelectionControlBar) {
  function AndroidSelectionControlBar() {
    var _this;
    _classCallCheck(this, AndroidSelectionControlBar);
    _this = _callSuper$9(this, AndroidSelectionControlBar, arguments);
    _this.hotSpotExtraExtentRealSize = 20;
    _this.hotSpotMeasureRealSize = 30;
    _this.controlSymbolMeasureRealSize = 18;
    _this.controlSymbolExtentRealSize = 18;
    return _this;
  }
  _inherits(AndroidSelectionControlBar, _SelectionControlBar);
  return _createClass(AndroidSelectionControlBar, [{
    key: "initControlBar",
    value: function initControlBar() {
      _superPropGet$4(AndroidSelectionControlBar, "initControlBar", this, 3)([]);
      this.controlBar.classList.add(style$1.androidSelectionControlBar);
    }
  }]);
}(SelectionControlBar);
var AndroidStartSelectionControlBar = /*#__PURE__*/function (_AndroidSelectionCont) {
  function AndroidStartSelectionControlBar() {
    var _this2;
    _classCallCheck(this, AndroidStartSelectionControlBar);
    _this2 = _callSuper$9(this, AndroidStartSelectionControlBar, arguments);
    _this2.direction = "start" /* Direction.start */;
    return _this2;
  }
  _inherits(AndroidStartSelectionControlBar, _AndroidSelectionCont);
  return _createClass(AndroidStartSelectionControlBar, [{
    key: "initControlBar",
    value: function initControlBar() {
      _superPropGet$4(AndroidStartSelectionControlBar, "initControlBar", this, 3)([]);
      this.controlBar.classList.add(style$1.androidStartSelectionControlBar);
    }
  }, {
    key: "initOtherPoint",
    value: function initOtherPoint() {
      var _a;
      var selection = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.selection;
      if (!selection) {
        return;
      }
      this.otherPoint = Range.end(selection);
    }
  }]);
}(AndroidSelectionControlBar);
var AndroidEndSelectionControlBar = /*#__PURE__*/function (_AndroidSelectionCont2) {
  function AndroidEndSelectionControlBar() {
    var _this3;
    _classCallCheck(this, AndroidEndSelectionControlBar);
    _this3 = _callSuper$9(this, AndroidEndSelectionControlBar, arguments);
    _this3.direction = "end" /* Direction.end */;
    return _this3;
  }
  _inherits(AndroidEndSelectionControlBar, _AndroidSelectionCont2);
  return _createClass(AndroidEndSelectionControlBar, [{
    key: "initControlBar",
    value: function initControlBar() {
      _superPropGet$4(AndroidEndSelectionControlBar, "initControlBar", this, 3)([]);
      this.controlBar.classList.add(style$1.androidEndSelectionControlBar);
    }
  }, {
    key: "initOtherPoint",
    value: function initOtherPoint() {
      var _a;
      var selection = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.selection;
      if (!selection) {
        return;
      }
      this.otherPoint = Range.start(selection);
    }
  }]);
}(AndroidSelectionControlBar);

function _callSuper$8(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$8() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$8() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$8 = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet$3(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
var IosSelectionControlBar = /*#__PURE__*/function (_SelectionControlBar) {
  function IosSelectionControlBar() {
    var _this;
    _classCallCheck(this, IosSelectionControlBar);
    _this = _callSuper$8(this, IosSelectionControlBar, arguments);
    _this.hotSpotExtraExtentRealSize = 20;
    _this.hotSpotMeasureRealSize = 20;
    _this.controlSymbolMeasureRealSize = 12;
    _this.controlSymbolExtentRealSize = 12;
    return _this;
  }
  _inherits(IosSelectionControlBar, _SelectionControlBar);
  return _createClass(IosSelectionControlBar, [{
    key: "initControlBar",
    value: function initControlBar() {
      _superPropGet$3(IosSelectionControlBar, "initControlBar", this, 3)([]);
      this.controlBar.classList.add(style$1.iosSelectionControlBar);
    }
  }]);
}(SelectionControlBar);
var IosStartSelectionControlBar = /*#__PURE__*/function (_IosSelectionControlB) {
  function IosStartSelectionControlBar() {
    var _this2;
    _classCallCheck(this, IosStartSelectionControlBar);
    _this2 = _callSuper$8(this, IosStartSelectionControlBar, arguments);
    _this2.direction = "start" /* Direction.start */;
    return _this2;
  }
  _inherits(IosStartSelectionControlBar, _IosSelectionControlB);
  return _createClass(IosStartSelectionControlBar, [{
    key: "initControlBar",
    value: function initControlBar() {
      _superPropGet$3(IosStartSelectionControlBar, "initControlBar", this, 3)([]);
      this.controlBar.classList.add(style$1.iosStartSelectionControlBar);
    }
  }, {
    key: "initOtherPoint",
    value: function initOtherPoint() {
      var _a;
      var selection = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.selection;
      if (!selection) {
        return;
      }
      this.otherPoint = Range.end(selection);
    }
  }]);
}(IosSelectionControlBar);
var IosEndSelectionControlBar = /*#__PURE__*/function (_IosSelectionControlB2) {
  function IosEndSelectionControlBar() {
    var _this3;
    _classCallCheck(this, IosEndSelectionControlBar);
    _this3 = _callSuper$8(this, IosEndSelectionControlBar, arguments);
    _this3.direction = "end" /* Direction.end */;
    return _this3;
  }
  _inherits(IosEndSelectionControlBar, _IosSelectionControlB2);
  return _createClass(IosEndSelectionControlBar, [{
    key: "initControlBar",
    value: function initControlBar() {
      _superPropGet$3(IosEndSelectionControlBar, "initControlBar", this, 3)([]);
      this.controlBar.classList.add(style$1.iosEndSelectionControlBar);
    }
  }, {
    key: "initOtherPoint",
    value: function initOtherPoint() {
      var _a;
      var selection = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.selection;
      if (!selection) {
        return;
      }
      this.otherPoint = Range.start(selection);
    }
  }]);
}(IosSelectionControlBar);

function createStartSelectionControlBar(platform, option) {
  if (platform === Platform.androidMobile) {
    return new AndroidStartSelectionControlBar(option);
  }
  if (platform === Platform.iosMobile) {
    return new IosStartSelectionControlBar(option);
  }
  return null;
}
function createEndSelectionControlBar(platform, option) {
  if (platform === Platform.androidMobile) {
    return new AndroidEndSelectionControlBar(option);
  }
  if (platform === Platform.iosMobile) {
    return new IosEndSelectionControlBar(option);
  }
  return null;
}

function _callSuper$7(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$7() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$7() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$7 = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet$2(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
var MobileSelectionOverlay = /*#__PURE__*/function (_SelectionOverlay) {
  function MobileSelectionOverlay(platform) {
    var _this;
    _classCallCheck(this, MobileSelectionOverlay);
    _this = _callSuper$7(this, MobileSelectionOverlay);
    /**
     * 开始拖动时，初始化和拖动方向相关的属性
     * @param direction 当前拖动的方向
     */
    _this.handleStartDrag = function (direction) {
      var _a, _b;
      var startPoint = _this.getStartPoint();
      var endPoint = _this.getEndPoint();
      _this.prevStartPoint = startPoint;
      _this.prevEndPoint = endPoint;
      _this.direction = direction;
      (_b = (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.onSelectionDragStart) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    /**
     * 拖动完成之后，清理和拖动方向相关的属性
     */
    _this.handleStopDrag = function () {
      var _a, _b, _c, _d;
      _this.direction = null;
      _this.prevStartPoint = null;
      _this.prevEndPoint = null;
      (_a = _this.startSelectionControlBar) === null || _a === void 0 ? void 0 : _a.closeDragMark();
      (_b = _this.endSelectionControlBar) === null || _b === void 0 ? void 0 : _b.closeDragMark();
      (_d = (_c = _this.editor) === null || _c === void 0 ? void 0 : _c.onSelectionDragEnd) === null || _d === void 0 ? void 0 : _d.call(_c);
    };
    _this.startSelectionControlBar = createStartSelectionControlBar(platform, {
      startDragCallback: function startDragCallback() {
        _this.handleStartDrag("start" /* Direction.start */);
      },
      stopDragCallback: _this.handleStopDrag
    });
    _this.endSelectionControlBar = createEndSelectionControlBar(platform, {
      startDragCallback: function startDragCallback() {
        _this.handleStartDrag("end" /* Direction.end */);
      },
      stopDragCallback: _this.handleStopDrag
    });
    return _this;
  }
  _inherits(MobileSelectionOverlay, _SelectionOverlay);
  return _createClass(MobileSelectionOverlay, [{
    key: "attachControlBar",
    value: function attachControlBar(surface) {
      var _a, _b;
      (_a = this.startSelectionControlBar) === null || _a === void 0 ? void 0 : _a.attach(surface);
      (_b = this.endSelectionControlBar) === null || _b === void 0 ? void 0 : _b.attach(surface);
    }
  }, {
    key: "detachControlBar",
    value: function detachControlBar() {
      var _a, _b;
      (_a = this.startSelectionControlBar) === null || _a === void 0 ? void 0 : _a.detach();
      (_b = this.endSelectionControlBar) === null || _b === void 0 ? void 0 : _b.detach();
    }
    /**
     * 重载父类的 attachEditor 方法
     * 用于触发 selectionControlBar 的对应方法
     * @param editor
     */
  }, {
    key: "attachEditor",
    value: function attachEditor(editor) {
      var _a, _b;
      _superPropGet$2(MobileSelectionOverlay, "attachEditor", this, 3)([editor]);
      (_a = this.startSelectionControlBar) === null || _a === void 0 ? void 0 : _a.attachEditor(editor);
      (_b = this.endSelectionControlBar) === null || _b === void 0 ? void 0 : _b.attachEditor(editor);
    }
    /**
     * 重载父类的 attachEditor 方法
     * 用于触发 selectionControlBar 的对应方法
     * @param editor
     */
  }, {
    key: "detachEditor",
    value: function detachEditor(editor) {
      var _a, _b;
      _superPropGet$2(MobileSelectionOverlay, "detachEditor", this, 3)([editor]);
      (_a = this.startSelectionControlBar) === null || _a === void 0 ? void 0 : _a.detachEditor(editor);
      (_b = this.endSelectionControlBar) === null || _b === void 0 ? void 0 : _b.detachEditor(editor);
    }
  }, {
    key: "update",
    value: function update() {
      _superPropGet$2(MobileSelectionOverlay, "update", this, 3)([]);
      this.updateDirection();
      this.renderControlBar();
    }
  }, {
    key: "clear",
    value: function clear() {
      _superPropGet$2(MobileSelectionOverlay, "clear", this, 3)([]);
      this.clearControlBar();
    }
    /**
     * 移动端需要考虑上左右拖拽的水滴
     * @returns
     */
  }, {
    key: "getSelectionRects",
    value: function getSelectionRects() {
      var rects = _toConsumableArray(this.selectionRects);
      var startSelectionControlBar = this.startSelectionControlBar,
        endSelectionControlBar = this.endSelectionControlBar;
      if (startSelectionControlBar) {
        rects.push(startSelectionControlBar.rect);
      }
      if (endSelectionControlBar) {
        rects.push(endSelectionControlBar.rect);
      }
      return rects;
    }
    /**
     * 更新当前视觉上正在移动的控制条方向
     * @returns
     */
    // eslint-disable-next-line complexity
  }, {
    key: "updateDirection",
    value: function updateDirection() {
      var _a, _b;
      if (!this.selection) {
        return;
      }
      if (!this.direction) {
        return;
      }
      var prevStartPoint = this.prevStartPoint,
        prevEndPoint = this.prevEndPoint;
      if (!prevStartPoint || !prevEndPoint) {
        return;
      }
      var startPoint = this.getStartPoint();
      var endPoint = this.getEndPoint();
      var isStartChange = !this.isSamePoint(startPoint, prevStartPoint);
      var isEndChange = !this.isSamePoint(endPoint, prevEndPoint);
      var lastDirection = this.direction;
      if (isStartChange && isEndChange) {
        // 说明是位置交换
        if (lastDirection === "end" /* Direction.end */) {
          this.direction = "start" /* Direction.start */;
        } else {
          this.direction = "end" /* Direction.end */;
        }
      } else if (isStartChange) {
        // 当前变更的是 start 方向
        this.direction = "start" /* Direction.start */;
      } else if (isEndChange) {
        // 当前变更的是 end 方向
        this.direction = "end" /* Direction.end */;
      }
      this.prevStartPoint = startPoint;
      this.prevEndPoint = endPoint;
      if (this.direction && this.direction !== lastDirection) {
        // 视觉上移动的点变化了
        (_a = this.startSelectionControlBar) === null || _a === void 0 ? void 0 : _a.changeDirection(this.direction);
        (_b = this.endSelectionControlBar) === null || _b === void 0 ? void 0 : _b.changeDirection(this.direction);
      }
    }
  }, {
    key: "isSamePoint",
    value: function isSamePoint(point1, point2) {
      var _a;
      var slate = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.model.slate;
      if (!slate) {
        return false;
      }
      return slate.isSamePoint(point1, point2);
    }
    /**
     * 渲染控制条
     * @returns
     */
    // eslint-disable-next-line complexity
  }, {
    key: "renderControlBar",
    value: function renderControlBar() {
      var _a;
      if (!this.startSelectionControlBar || !this.endSelectionControlBar) {
        return;
      }
      var startPosition = this.startPosition,
        endPosition = this.endPosition,
        startLine = this.startLine,
        endLine = this.endLine;
      if (!(startPosition && endPosition && startLine && endLine)) {
        // 如果数据不合法，直接清空控制条不显示
        this.clearControlBar();
        return;
      }
      var _getLineSelectionRect = getLineSelectionRect(startLine, this.coordinate, this.lineExpandDirection, this.blockRect),
        startLineX = _getLineSelectionRect.x,
        startLineY = _getLineSelectionRect.y,
        startLineWidth = _getLineSelectionRect.width,
        startLineHeight = _getLineSelectionRect.height;
      var _getLineSelectionRect2 = getLineSelectionRect(endLine, this.coordinate, this.lineExpandDirection, this.blockRect),
        endLineX = _getLineSelectionRect2.x,
        endLineY = _getLineSelectionRect2.y,
        endLineWidth = _getLineSelectionRect2.width,
        endLineHeight = _getLineSelectionRect2.height;
      var scale = ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.scale) || 1;
      var startControlBarRect;
      var endControlBarRect;
      // 根据横排竖排对应的坐标系计算控制条大小和位置
      switch (this.coordinate) {
        case CoordinateZero.LEFT_BOTTOM:
          {
            startControlBarRect = {
              x: startLineX / scale,
              y: startPosition.y / scale,
              width: startLineWidth / scale,
              height: this.startSelectionControlBar.controlBarLineWidth
            };
            endControlBarRect = {
              x: endLineX / scale,
              y: endPosition.y / scale,
              width: endLineWidth / scale,
              height: this.endSelectionControlBar.controlBarLineWidth
            };
            break;
          }
        case CoordinateZero.RIGHT_TOP:
          {
            startControlBarRect = {
              x: (startLineX - startLineWidth) / scale,
              y: startPosition.y / scale,
              width: startLineWidth / scale,
              height: this.startSelectionControlBar.controlBarLineWidth
            };
            endControlBarRect = {
              x: (endLineX - endLineWidth) / scale,
              y: endPosition.y / scale,
              width: endLineWidth / scale,
              height: this.endSelectionControlBar.controlBarLineWidth
            };
            break;
          }
        case CoordinateZero.LEFT_TOP:
          if (this.lineExpandDirection === LineExpandDirection.HORIZONTAL) {
            startControlBarRect = {
              x: startLineX / scale,
              y: startPosition.y / scale,
              width: startLineWidth / scale,
              height: this.startSelectionControlBar.controlBarLineWidth
            };
            endControlBarRect = {
              x: endLineX / scale,
              y: endPosition.y / scale,
              width: endLineWidth / scale,
              height: this.endSelectionControlBar.controlBarLineWidth
            };
            break;
          }
        default:
          {
            startControlBarRect = {
              x: startPosition.x / scale,
              y: startLineY / scale,
              width: this.startSelectionControlBar.controlBarLineWidth,
              height: startLineHeight / scale
            };
            endControlBarRect = {
              x: endPosition.x / scale,
              y: endLineY / scale,
              width: this.endSelectionControlBar.controlBarLineWidth,
              height: endLineHeight / scale
            };
          }
      }
      this.startSelectionControlBar.updateCurrentLine(startLine);
      this.startSelectionControlBar.show(startControlBarRect);
      this.endSelectionControlBar.updateCurrentLine(endLine);
      this.endSelectionControlBar.show(endControlBarRect);
    }
    /**
     * 清除控制条
     */
  }, {
    key: "clearControlBar",
    value: function clearControlBar() {
      var _a, _b;
      (_a = this.startSelectionControlBar) === null || _a === void 0 ? void 0 : _a.hide();
      (_b = this.endSelectionControlBar) === null || _b === void 0 ? void 0 : _b.hide();
    }
  }]);
}(SelectionOverlay);

function createSelectionOverlay(platform) {
  if (isMobile(platform)) {
    return new MobileSelectionOverlay(platform);
  }
  return new SelectionOverlay();
}

function _callSuper$6(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$6() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$6() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$6 = function _isNativeReflectConstruct() { return !!t; })(); }
var CaretManager = /*#__PURE__*/function (_EditorAttachable) {
  function CaretManager() {
    _classCallCheck(this, CaretManager);
    return _callSuper$6(this, CaretManager, arguments);
  }
  _inherits(CaretManager, _EditorAttachable);
  return _createClass(CaretManager, [{
    key: "caretRect",
    get:
    /**
     * 光标相对于整个 app，也就是 transform 原点的位置
     */
    function get() {
      if (!this.caretRectOfEditor) {
        return {
          x: 0,
          y: 0,
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          width: 0,
          height: 0
        };
      }
      var _this$caretRectOfEdit = this.caretRectOfEditor,
        x = _this$caretRectOfEdit.x,
        y = _this$caretRectOfEdit.y,
        width = _this$caretRectOfEdit.width,
        height = _this$caretRectOfEdit.height;
      var _this$editor$position = this.editor.positionOfEditorToPositionOfApp(x, y),
        x1 = _this$editor$position.x,
        y1 = _this$editor$position.y;
      var _this$editor$position2 = this.editor.positionOfEditorToPositionOfApp(x + width, y),
        x2 = _this$editor$position2.x,
        y2 = _this$editor$position2.y;
      var _this$editor$position3 = this.editor.positionOfEditorToPositionOfApp(x + width, y + height),
        x3 = _this$editor$position3.x,
        y3 = _this$editor$position3.y;
      var _this$editor$position4 = this.editor.positionOfEditorToPositionOfApp(x, y + height),
        x4 = _this$editor$position4.x,
        y4 = _this$editor$position4.y;
      var minX = Math.min(x1, x2, x3, x4);
      var maxX = Math.max(x1, x2, x3, x4);
      var minY = Math.min(y1, y2, y3, y4);
      var maxY = Math.max(y1, y2, y3, y4);
      return {
        x: minX,
        y: minY,
        left: minX,
        right: maxX,
        top: minY,
        bottom: maxY,
        width: maxX - minX,
        height: maxY - minY
      };
    }
  }, {
    key: "deprecateLayoutCaretRect",
    value: function deprecateLayoutCaretRect() {
      this.caretRectFromLayout = null;
    }
    /**
     * 根据指定位置计算出光标的 point
     * @param mousePosition
     * @returns
     */
  }, {
    key: "updatePointByPointPosition",
    value: function updatePointByPointPosition(mousePosition) {
      var _this = this;
      var _a, _b;
      var x = mousePosition.x,
        y = mousePosition.y;
      var pointInfo = (_b = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.layoutManager) === null || _b === void 0 ? void 0 : _b.getPointFromViewPoint(x, y);
      // 兼容查找不到的情况
      if (!pointInfo) {
        return null;
      }
      var point = pointInfo.point,
        caretRect = pointInfo.caretRect,
        box = pointInfo.box;
      // 优先使用排版层计算的光标位置
      this.caretRectFromLayout = {
        x: twipsToPx(caretRect.x),
        y: twipsToPx(caretRect.y),
        height: caretRect.height > caretRect.width ? twipsToPx(caretRect.height) : 0,
        width: caretRect.width > caretRect.height ? twipsToPx(caretRect.width) : 0
      };
      this.updateLineBox(box);
      this.updateLastCaretLogicPosition(this.caretRectFromLayout, box);
      // 临时解决方案：解决触发 mousemove 时，selection 可能不会变化，所以不会触发 getCaretRectOfWindow 函数，
      // 导致下次调用 getCaretRectOfWindow 时 caretRectFromLayout 还保留了值，光标位置就错了
      // 触发情况举例：选中一部分文字，点击删除键，光标位置就错了
      setTimeout(function () {
        _this.caretRectFromLayout = null;
      }, 50);
      return point;
    }
  }, {
    key: "getCaretRectOfWindow",
    value: function getCaretRectOfWindow(caretBox, caretPosition) {
      var _ref = this.caretRectFromLayout || this.pointToCaretRect(caretBox, caretPosition),
        x = _ref.x,
        y = _ref.y,
        height = _ref.height,
        width = _ref.width;
      this.caretRectOfEditor = {
        x: x,
        y: y,
        height: height,
        width: width
      };
      var isCaretFromLayout = !!this.caretRectFromLayout;
      if (!this.caretRectFromLayout) {
        this.updateLineBox(caretBox);
        this.updateLastCaretLogicPosition({
          x: x,
          y: y,
          height: height,
          width: width
        }, caretBox);
      }
      this.caretRectFromLayout = null;
      var scale = this.scale;
      var _this$getCaretRealSiz = this.getCaretRealSize(width, height),
        realWidth = _this$getCaretRealSiz.width,
        realHeight = _this$getCaretRealSiz.height;
      return {
        x: x / scale,
        y: y / scale,
        width: realWidth,
        height: realHeight,
        isCaretFromLayout: isCaretFromLayout
      };
    }
    /**
     * 判断当前光标是否在当前行最后
     * @returns
     */
  }, {
    key: "isCaretInLineEnd",
    value: function isCaretInLineEnd() {
      var caretLineBox = this.caretLineBox,
        caretBox = this.caretBox;
      var children = caretLineBox.children;
      return caretBox === children[children.length - 1];
    }
  }, {
    key: "moveToPrevLine",
    value: function moveToPrevLine() {
      var prevLine = getPrevBox(this.caretLineBox);
      if (!prevLine) {
        return;
      }
      var _this$lastCaretLogicP = this.lastCaretLogicPosition,
        start = _this$lastCaretLogicP.start,
        before = _this$lastCaretLogicP.before;
      var prevLineColumn = getAncestorBox(prevLine, BoxKind.Column);
      var currentLineColumn = getAncestorBox(this.caretLineBox, BoxKind.Column);
      // 模拟的鼠标位置
      var logicPosition;
      if (prevLineColumn !== currentLineColumn) {
        // 跨栏了，到上一栏
        var _getLogicOffsetOfAnce = getLogicOffsetOfAncestorBox(currentLineColumn, undefined),
          currentLineColumnStart = _getLogicOffsetOfAnce.start;
        var _getLogicOffsetOfAnce2 = getLogicOffsetOfAncestorBox(prevLineColumn, undefined),
          prevLineColumnStart = _getLogicOffsetOfAnce2.start,
          prevLineColumnBefore = _getLogicOffsetOfAnce2.before;
        // 跨栏后上一行鼠标位置计算
        // start - currentLineColumnStart 表示当前光标位置在当前栏中的横向偏移，prevLineColumnStart 加上这个偏移就是上一行鼠标的横向位置
        // before 位置就是上一栏的结束位置
        logicPosition = {
          start: prevLineColumnStart + (start - currentLineColumnStart),
          before: prevLineColumnBefore + twipsToPx(prevLineColumn.extent)
        };
      } else {
        // 同一栏
        var lineSize = twipsToPx(prevLine.extent);
        var paragraphGap = this.getParagraphGapBetweenLines(prevLine, this.caretLineBox);
        // 模拟的鼠标位置计算：lastCaretLogicPosition 本来就在当前行 before 方向的顶部，减去段落间距和 lineSize / 2 后，就到了上一行 before 方向的中心
        logicPosition = {
          start: start,
          before: before - paragraphGap - lineSize / 2
        };
      }
      var mousePosition = logicOffsetToRealOffset(this.coordinate, this.lineExpandDirection, logicPosition, this.blockRect);
      return this.updatePointByPointPosition(mousePosition);
    }
  }, {
    key: "moveToNextLine",
    value: function moveToNextLine() {
      var nextLine = getNextBox(this.caretLineBox);
      if (!nextLine) {
        return;
      }
      var _this$lastCaretLogicP2 = this.lastCaretLogicPosition,
        start = _this$lastCaretLogicP2.start,
        before = _this$lastCaretLogicP2.before;
      var nextLineColumn = getAncestorBox(nextLine, BoxKind.Column);
      var currentLineColumn = getAncestorBox(this.caretLineBox, BoxKind.Column);
      // 模拟的鼠标位置
      var logicPosition;
      if (nextLineColumn !== currentLineColumn) {
        // 跨栏了，到下一栏
        var _getLogicOffsetOfAnce3 = getLogicOffsetOfAncestorBox(currentLineColumn, undefined),
          currentLineColumnStart = _getLogicOffsetOfAnce3.start;
        var _getLogicOffsetOfAnce4 = getLogicOffsetOfAncestorBox(nextLineColumn, undefined),
          nextLineColumnStart = _getLogicOffsetOfAnce4.start,
          nextLineColumnBefore = _getLogicOffsetOfAnce4.before;
        // 跨栏后下一行的鼠标位置计算
        // start - currentLineColumnStart 表示当前光标位置在当前栏中的横向偏移，nextLineColumnStart 加上这个偏移就是下一行鼠标的横向位置
        // before 位置就是下一栏的起始位置
        logicPosition = {
          start: nextLineColumnStart + (start - currentLineColumnStart),
          before: nextLineColumnBefore
        };
      } else {
        // 同一栏
        var lineSize = twipsToPx(nextLine.extent);
        var currentLineSize = twipsToPx(this.caretLineBox.extent);
        var paragraphGap = this.getParagraphGapBetweenLines(this.caretLineBox, nextLine);
        // 模拟的鼠标位置计算：before + currentLineSize 到了当前行 before 方向的底部，加上段落间距和 lineSize / 2 后，就到了下一行 before 方向的中心
        logicPosition = {
          start: start,
          before: before + currentLineSize + paragraphGap + lineSize / 2
        };
      }
      var mousePosition = logicOffsetToRealOffset(this.coordinate, this.lineExpandDirection, logicPosition, this.blockRect);
      return this.updatePointByPointPosition(mousePosition);
    }
    /**
     * 移动到下一行行首
     * @returns
     */
  }, {
    key: "moveToNextLineStart",
    value: function moveToNextLineStart() {
      var nextLine = getNextBox(this.caretLineBox);
      if (!nextLine) {
        return;
      }
      var before = this.lastCaretLogicPosition.before;
      var lineSize = twipsToPx(nextLine.extent);
      var currentLineSize = twipsToPx(this.caretLineBox.extent);
      var paragraphGap = this.getParagraphGapBetweenLines(this.caretLineBox, nextLine);
      var _getLogicOffsetOfAnce5 = getLogicOffsetOfAncestorBox(nextLine, undefined),
        nextLineStart = _getLogicOffsetOfAnce5.start;
      var logicPosition = {
        start: nextLineStart,
        before: before + currentLineSize + paragraphGap + lineSize / 2
      };
      var mousePosition = logicOffsetToRealOffset(this.coordinate, this.lineExpandDirection, logicPosition, this.blockRect);
      return this.updatePointByPointPosition(mousePosition);
    }
    /**
     * 移动到当前行行首
     * @returns
     */
  }, {
    key: "moveToLineStart",
    value: function moveToLineStart() {
      var before = this.lastCaretLogicPosition.before;
      var lineExtent = twipsToPx(this.caretLineBox.extent);
      // 获取到当前行 start 方向的偏移
      var _getLogicOffsetOfAnce6 = getLogicOffsetOfAncestorBox(this.caretLineBox, undefined),
        currentLineStart = _getLogicOffsetOfAnce6.start;
      var logicPosition = {
        start: currentLineStart,
        before: before + lineExtent / 2
      };
      var mousePosition = logicOffsetToRealOffset(this.coordinate, this.lineExpandDirection, logicPosition, this.blockRect);
      return this.updatePointByPointPosition(mousePosition);
    }
    /**
     * 移动到当前行行尾
     * @returns
     */
  }, {
    key: "moveToLineEnd",
    value: function moveToLineEnd() {
      var before = this.lastCaretLogicPosition.before;
      // 获取到当前行 start 方向的偏移
      var _getLogicOffsetOfAnce7 = getLogicOffsetOfAncestorBox(this.caretLineBox, undefined),
        currentLineStart = _getLogicOffsetOfAnce7.start;
      var lineMeasure = twipsToPx(this.caretLineBox.measure);
      var lineExtent = twipsToPx(this.caretLineBox.extent);
      // 模拟的鼠标位置计算：currentLineStart + lineMeasure 表示到了当前行的末尾位置
      var logicPosition = {
        start: currentLineStart + lineMeasure,
        before: before + lineExtent / 2
      };
      var mousePosition = logicOffsetToRealOffset(this.coordinate, this.lineExpandDirection, logicPosition, this.blockRect);
      return this.updatePointByPointPosition(mousePosition);
    }
  }, {
    key: "updateLineBox",
    value: function updateLineBox(box) {
      this.caretBox = box;
      var lineBox = getAncestorBox(box, BoxKind.TextLine);
      this.caretLineBox = lineBox;
    }
    /**
     * 根据光标所在 box 和 光标位置，计算出真正的光标位置和大小
     * @param caretBox
     * @param caretPosition
     * @returns
     */
  }, {
    key: "pointToCaretRect",
    value: function pointToCaretRect(caretBox, caretPosition) {
      var _caretBox$rect = caretBox.rect,
        width = _caretBox$rect.width,
        height = _caretBox$rect.height;
      var x = caretPosition.x,
        y = caretPosition.y;
      switch (this.coordinate) {
        case CoordinateZero.RIGHT_TOP:
          {
            return {
              x: x - twipsToPx(width),
              y: y,
              width: twipsToPx(width),
              height: 0
            };
          }
        case CoordinateZero.LEFT_BOTTOM:
          {
            return {
              x: x,
              y: y,
              width: twipsToPx(width),
              height: 0
            };
          }
        case CoordinateZero.LEFT_TOP:
          if (this.lineExpandDirection === LineExpandDirection.HORIZONTAL) {
            return {
              x: x,
              y: y,
              width: twipsToPx(width),
              height: 0
            };
          }
        default:
          {
            return {
              x: x,
              y: y,
              width: 0,
              height: twipsToPx(height)
            };
          }
      }
    }
  }, {
    key: "updateLastCaretLogicPosition",
    value: function updateLastCaretLogicPosition(caretRect, caretBox) {
      var x = caretRect.x,
        y = caretRect.y,
        width = caretRect.width;
      // 光标所在 box 相对于当前行的 before 偏移
      var caretBoxBefore = twipsToPx(caretBox.logicPoint.before);
      switch (this.coordinate) {
        case CoordinateZero.RIGHT_TOP:
          {
            this.lastCaretLogicPosition = {
              start: y,
              before: this.blockRect.width - x - width - caretBoxBefore
            };
            return;
          }
        case CoordinateZero.LEFT_BOTTOM:
          {
            this.lastCaretLogicPosition = {
              start: this.blockRect.height - y,
              before: x - caretBoxBefore
            };
            return;
          }
        case CoordinateZero.LEFT_TOP:
          {
            if (this.lineExpandDirection === LineExpandDirection.HORIZONTAL) {
              this.lastCaretLogicPosition = {
                start: y,
                before: x - caretBoxBefore
              };
              return;
            }
            this.lastCaretLogicPosition = {
              start: x,
              before: y - caretBoxBefore
            };
            return;
          }
      }
    }
    /**
     * 获取两行之间的段落间距
     * beforeLineBox 要在 lineBox 的前面
     * @param beforeLineBox
     * @param lineBox
     * @returns
     */
  }, {
    key: "getParagraphGapBetweenLines",
    value: function getParagraphGapBetweenLines(beforeLineBox, lineBox) {
      var lineParagraph = getAncestorBox(lineBox, BoxKind.Paragraph);
      var beforeLineParagraph = getAncestorBox(beforeLineBox, BoxKind.Paragraph);
      if (!lineParagraph || !beforeLineParagraph || lineParagraph === beforeLineParagraph) {
        return 0;
      }
      // 当前段的段前间距+上一段的段后间距
      return twipsToPx(lineParagraph.paraProps.spaceBefore + beforeLineParagraph.paraProps.spaceAfter);
    }
    /**
     * 计算光标的实际大小
     * @param width
     * @param height
     * @returns
     */
  }, {
    key: "getCaretRealSize",
    value: function getCaretRealSize(width, height) {
      // 为了保证光标粗细不受缩放影响，需要根据 transformScale 逆向计算一下
      var scale = this.scale,
        transformScale = this.transformScale;
      var isVerticalCaret = width < height;
      // 光标粗细取整一下，解决 windows 上偶现的光标残影问题
      var lineThickness = Math.ceil(1 / transformScale);
      if (isVerticalCaret) {
        return {
          width: lineThickness,
          height: height / scale
        };
      }
      return {
        height: lineThickness,
        width: width / scale
      };
    }
  }]);
}(EditorAttachable);

function isObject(param) {
  return Object.prototype.toString.call(param) === '[object Object]';
}

/**
 * 浅比较两个值
 * 只针对对象做一层浅比较，其余值直接 === 比较
 * @param value
 * @param other
 */
function shallowEquals(value, other) {
  if (value === other) {
    return true;
  }
  // 非对象直接进行比对
  if (!isObject(value) || !isObject(other)) {
    return value === other;
  }
  var valueObj = value;
  var otherObj = other;
  var valueKeys = Object.keys(valueObj);
  var otherKeys = Object.keys(otherObj);
  if (valueKeys.length !== otherKeys.length) {
    return false;
  }
  for (var _i = 0, _valueKeys = valueKeys; _i < _valueKeys.length; _i++) {
    var key = _valueKeys[_i];
    if (valueObj[key] !== otherObj[key]) {
      return false;
    }
  }
  return true;
}

function _callSuper$5(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$5() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$5() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$5 = function _isNativeReflectConstruct() { return !!t; })(); }
var Direction;
(function (Direction) {
  Direction["backward"] = "backward";
  Direction["forward"] = "forward";
})(Direction || (Direction = {}));
var SelectionHandler = /*#__PURE__*/function (_EditorAttachable) {
  function SelectionHandler(_ref) {
    var _this;
    var deprecateLayoutCaretRect = _ref.deprecateLayoutCaretRect,
      getPrevLinePoint = _ref.getPrevLinePoint,
      getNextLinePoint = _ref.getNextLinePoint,
      getLineStartPoint = _ref.getLineStartPoint,
      getLineEndPoint = _ref.getLineEndPoint,
      getNextLineStartPoint = _ref.getNextLineStartPoint,
      updateCaretInfo = _ref.updateCaretInfo;
    _classCallCheck(this, SelectionHandler);
    _this = _callSuper$5(this, SelectionHandler);
    _this.movingDirection = null;
    _this.deprecateLayoutCaretRect = deprecateLayoutCaretRect;
    _this.getPrevLinePoint = getPrevLinePoint;
    _this.getNextLinePoint = getNextLinePoint;
    _this.getLineStartPoint = getLineStartPoint;
    _this.getLineEndPoint = getLineEndPoint;
    _this.getNextLineStartPoint = getNextLineStartPoint;
    _this.updateCaretInfo = updateCaretInfo;
    return _this;
  }
  _inherits(SelectionHandler, _EditorAttachable);
  return _createClass(SelectionHandler, [{
    key: "backDeleteTextProps",
    get: function get() {
      var _a, _b;
      return (_b = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.getBackDeleteTextProps) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
  }, {
    key: "editorModel",
    get: function get() {
      var _a;
      return (_a = this.editor) === null || _a === void 0 ? void 0 : _a.model;
    }
  }, {
    key: "slate",
    get: function get() {
      var _a;
      return (_a = this.editorModel) === null || _a === void 0 ? void 0 : _a.slate;
    }
  }, {
    key: "selection",
    get: function get() {
      var _a;
      return (_a = this.slate) === null || _a === void 0 ? void 0 : _a.selection;
    }
  }, {
    key: "selectionStartPoint",
    get: function get() {
      if (!this.selection) {
        return null;
      }
      return Range.start(this.selection);
    }
  }, {
    key: "selectionEndPoint",
    get: function get() {
      if (!this.selection) {
        return null;
      }
      return Range.end(this.selection);
    }
  }, {
    key: "onSelectionChange",
    value: function onSelectionChange() {
      var _a;
      if (!this.selection) {
        return;
      }
      if ((_a = this.slate) === null || _a === void 0 ? void 0 : _a.isRangeCollapsed(this.selection)) {
        // 选区变为光标的时候清除 movingDirection 标记
        this.movingDirection = null;
      }
    }
    // ---- 选区相关处理
  }, {
    key: "moveBackward",
    value: function moveBackward() {
      var selection = this.selection,
        slate = this.slate;
      if (selection && Range.isCollapsed(selection)) {
        var prePoint = this.getBeforePoint(this.selectionStartPoint);
        this.setSelectionByPoint(prePoint, Direction.backward);
      } else {
        Transforms.collapse(slate, {
          edge: 'start'
        });
        var normalizedPoint = this.slate.normalizePoint(this.selection.anchor);
        this.editorModel.setSelectionPoints(normalizedPoint, normalizedPoint);
      }
      /**
       * 光标移动之后，跳过 \n
       * 先调用 updateCaretInfo 是为了保证 caret-manager 中记录的光标位置已经换行符这一行
       * 那么再调用 getNextLineStartPoint 才能确保光标是到当前换行符下一行的行首
       * 正常来说，选区变化本身就会触发 updateCaretInfo 的逻辑，但是由于目前这个逻辑是在 onSelectionChange 里面执行，而 onSelectionChange 是异步的，
       * 所以需要手动调用 updateCaretInfo
       */
      this.updateCaretInfo();
    }
  }, {
    key: "moveForward",
    value: function moveForward() {
      var selection = this.selection,
        slate = this.slate;
      if (selection && Range.isCollapsed(selection)) {
        var nextPoint = this.getAfterPoint(this.selectionEndPoint);
        this.setSelectionByPoint(nextPoint, Direction.forward);
      } else {
        Transforms.collapse(slate, {
          edge: 'end'
        });
        var normalizedPoint = this.slate.normalizePoint(this.selection.anchor);
        this.editorModel.setSelectionPoints(normalizedPoint, normalizedPoint);
      }
    }
  }, {
    key: "moveLineBackward",
    value: function moveLineBackward() {
      var point = this.getPrevLinePoint();
      if (!point) {
        return;
      }
      this.setSelectionByPoint(point, Direction.backward);
    }
  }, {
    key: "moveLineForward",
    value: function moveLineForward() {
      var point = this.getNextLinePoint();
      if (!point) {
        return;
      }
      this.setSelectionByPoint(point, Direction.forward);
    }
    // 移动到上一个单词
  }, {
    key: "moveWordBackward",
    value: function moveWordBackward() {
      var selection = this.selection,
        slate = this.slate;
      if (!selection) {
        return;
      }
      if (slate === null || slate === void 0 ? void 0 : slate.isRangeExpanded(selection)) {
        Transforms.collapse(slate, {
          edge: 'focus'
        });
      }
      var prevWordPoint = slate === null || slate === void 0 ? void 0 : slate.getPrevWordPoint(Range.start(selection));
      if (!prevWordPoint) {
        return;
      }
      this.setSelectionByPoint(prevWordPoint, Direction.backward, true);
    }
    // 移动到下一个单词
  }, {
    key: "moveWordForward",
    value: function moveWordForward() {
      var selection = this.selection,
        slate = this.slate;
      if (!selection) {
        return;
      }
      if (slate === null || slate === void 0 ? void 0 : slate.isRangeExpanded(selection)) {
        Transforms.collapse(slate, {
          edge: 'focus'
        });
      }
      var nextWordPoint = slate === null || slate === void 0 ? void 0 : slate.getNextWordPoint(Range.start(selection));
      if (!nextWordPoint) {
        return;
      }
      this.setSelectionByPoint(nextWordPoint, Direction.forward, true);
    }
    // 移动到行首
  }, {
    key: "moveToLineStart",
    value: function moveToLineStart() {
      var point = this.getLineStartPoint();
      if (!point) {
        return;
      }
      this.setSelectionByPoint(point, Direction.backward);
    }
    // 移动到行尾
  }, {
    key: "moveToLineEnd",
    value: function moveToLineEnd() {
      var point = this.getLineEndPoint();
      if (!point) {
        return;
      }
      this.setSelectionByPoint(point, Direction.forward);
    }
    // 移动到段首
  }, {
    key: "moveToParagraphStart",
    value: function moveToParagraphStart() {
      var selection = this.selection,
        slate = this.slate;
      if (!selection || !slate) {
        return;
      }
      var paragraphPath = Editor$1.path(slate, selection, {
        edge: 'start',
        depth: 1
      });
      var startPoint = Editor$1.start(slate, paragraphPath);
      this.editorModel.setSelectionPoints(startPoint, startPoint);
    }
    // 移动到段尾
  }, {
    key: "moveToParagraphEnd",
    value: function moveToParagraphEnd() {
      var selection = this.selection,
        slate = this.slate;
      if (!selection || !slate) {
        return;
      }
      var paragraphPath = Editor$1.path(slate, selection, {
        edge: 'end',
        depth: 1
      });
      var endPoint = Editor$1.end(slate, paragraphPath);
      this.editorModel.setSelectionPoints(endPoint, endPoint);
    }
    // 移动到文档开头
  }, {
    key: "moveToDocStart",
    value: function moveToDocStart() {
      var _a;
      (_a = this.slate) === null || _a === void 0 ? void 0 : _a.selectStart();
    }
    // 移动到文档结尾
  }, {
    key: "moveToDocEnd",
    value: function moveToDocEnd() {
      var _a;
      (_a = this.slate) === null || _a === void 0 ? void 0 : _a.selectEnd();
    }
    // 扩张到文档开头
  }, {
    key: "extendToDocStart",
    value: function extendToDocStart() {
      var docStartPoint = this.slate.getStartPoint();
      Transforms.setPoint(this.slate, docStartPoint, {
        edge: 'focus'
      });
    }
    // 扩张到文档结尾
  }, {
    key: "extendToDocEnd",
    value: function extendToDocEnd() {
      var docEndPoint = this.slate.getEndPoint();
      Transforms.setPoint(this.slate, docEndPoint, {
        edge: 'focus'
      });
    }
    // 向左扩张
  }, {
    key: "extendBackward",
    value: function extendBackward() {
      this.extendCharacterSelection(Direction.backward);
    }
    // 向右扩张
  }, {
    key: "extendForward",
    value: function extendForward() {
      this.extendCharacterSelection(Direction.forward);
    }
    // 向上扩张
  }, {
    key: "extendLineBackward",
    value: function extendLineBackward() {
      var point = this.getPrevLinePoint();
      if (!point) {
        return;
      }
      point = this.walkPointWithCaretEffect(point, Direction.backward);
      Transforms.setPoint(this.slate, point, {
        edge: 'focus'
      });
    }
    // 向下扩张
  }, {
    key: "extendLineForward",
    value: function extendLineForward() {
      var point = this.getNextLinePoint();
      if (!point) {
        return;
      }
      point = this.walkPointWithCaretEffect(point, Direction.forward);
      Transforms.setPoint(this.slate, point, {
        edge: 'focus'
      });
    }
    // 选中前一个单词
  }, {
    key: "extendWordBackward",
    value: function extendWordBackward() {
      this.extendWordSelection(Direction.backward);
    }
    // 选中后一个单词
  }, {
    key: "extendWordForward",
    value: function extendWordForward() {
      this.extendWordSelection(Direction.forward);
    }
    // 扩张到行首
  }, {
    key: "extendToLineStart",
    value: function extendToLineStart() {
      var point = this.getLineStartPoint();
      if (!point) {
        return;
      }
      point = this.walkPointWithCaretEffect(point, Direction.backward);
      Transforms.setPoint(this.slate, point, {
        edge: 'focus'
      });
    }
    // 扩张到行尾
  }, {
    key: "extendToLineEnd",
    value: function extendToLineEnd() {
      var point = this.getLineEndPoint();
      if (!point) {
        return;
      }
      point = this.walkPointWithCaretEffect(point, Direction.forward);
      Transforms.setPoint(this.slate, point, {
        edge: 'focus'
      });
    }
    // 扩张到段落开始
  }, {
    key: "extendToParagraphStart",
    value: function extendToParagraphStart() {
      Transforms.move(this.slate, {
        unit: 'line',
        edge: 'anchor',
        reverse: true
      });
      // moveLine在跨段的时候，会到段落的结尾，其实我们的预期是到开头
      // 所以合理在如果跳了之后如果offset不为0，则说明没有按预期到段落开头，则再跳一次
      // 不用distance来控制的原因是，如果是一个空段，move line会只算一个点，会增加很多额外的逻辑
      var currentSelectionFocus = this.selectionStartPoint;
      if ((currentSelectionFocus === null || currentSelectionFocus === void 0 ? void 0 : currentSelectionFocus.offset) !== 0) {
        Transforms.move(this.slate, {
          unit: 'line',
          edge: 'anchor',
          reverse: true
        });
      }
    }
    // 扩张到段落结束
  }, {
    key: "extendToParagraphEnd",
    value: function extendToParagraphEnd() {
      var _a;
      Transforms.move(this.slate, {
        unit: 'line',
        edge: 'anchor'
      });
      // 同extendToParagraphStart的逻辑，有个不同点是，offset为0可能节点本身为空。这种情况不处理
      var currentSelectionFocus = this.selectionEndPoint;
      var currentNode = (_a = this.editorModel) === null || _a === void 0 ? void 0 : _a.getNodeByPath(currentSelectionFocus.path);
      if ((currentSelectionFocus === null || currentSelectionFocus === void 0 ? void 0 : currentSelectionFocus.offset) === 0 && currentNode.text.length !== 0) {
        Transforms.move(this.slate, {
          unit: 'line',
          edge: 'anchor'
        });
      }
    }
    // ------ 编辑相关处理
    // 退格删除
  }, {
    key: "deleteBackward",
    value: function deleteBackward() {
      var _a;
      var preventDeleteBackward = this.handleBackDeleteTextProps();
      if (preventDeleteBackward) {
        return;
      }
      if (this.selection && ((_a = this.slate) === null || _a === void 0 ? void 0 : _a.isRangeExpanded(this.selection))) {
        this.slate.deleteFragment({
          direction: 'backward'
        });
        return;
      }
      var deleteAnchor = this.selectionStartPoint;
      var prePoint = this.getBeforePoint(this.selectionStartPoint);
      var walkedPrePoint = this.walkPoint(prePoint, Direction.backward);
      if (!Point.equals(prePoint, walkedPrePoint)) {
        Transforms["delete"](this.slate, {
          at: {
            anchor: deleteAnchor,
            focus: walkedPrePoint
          },
          reverse: true
        });
      } else {
        this.slate.deleteBackward('character');
      }
    }
    // 向前删除
  }, {
    key: "deleteForward",
    value: function deleteForward() {
      var _a;
      if (this.selection && ((_a = this.slate) === null || _a === void 0 ? void 0 : _a.isRangeExpanded(this.selection))) {
        this.slate.deleteFragment({
          direction: 'forward'
        });
        return;
      }
      var deleteAnchor = this.selectionStartPoint;
      var afterPoint = this.getAfterPoint(this.selectionStartPoint);
      var walkedAfterPoint = this.walkPoint(afterPoint, Direction.forward);
      if (!Point.equals(afterPoint, walkedAfterPoint)) {
        Transforms["delete"](this.slate, {
          at: {
            anchor: deleteAnchor,
            focus: walkedAfterPoint
          },
          reverse: false
        });
      } else {
        this.slate.deleteForward('character');
      }
    }
    // 删除一个单词
  }, {
    key: "deleteWordBackward",
    value: function deleteWordBackward() {
      var selection = this.selection,
        slate = this.slate;
      if (!selection) {
        return;
      }
      if (slate === null || slate === void 0 ? void 0 : slate.isRangeExpanded(selection)) {
        slate.deleteFragment({
          direction: 'forward'
        });
        return;
      }
      var point = selection.anchor;
      var prevWordPoint = slate.getPrevWordPoint(point);
      if (!prevWordPoint) {
        return;
      }
      prevWordPoint = this.walkPoint(prevWordPoint, Direction.backward);
      Transforms["delete"](slate, {
        at: {
          anchor: prevWordPoint,
          focus: point
        }
      });
    }
    // 向前删除一个单词
  }, {
    key: "deleteWordForward",
    value: function deleteWordForward() {
      var selection = this.selection,
        slate = this.slate;
      if (!selection) {
        return;
      }
      if (slate === null || slate === void 0 ? void 0 : slate.isRangeExpanded(selection)) {
        slate.deleteFragment({
          direction: 'forward'
        });
        return;
      }
      var point = selection.anchor;
      var nextWordPoint = slate.getNextWordPoint(point);
      if (!nextWordPoint) {
        return;
      }
      nextWordPoint = this.walkPoint(nextWordPoint, Direction.forward);
      Transforms["delete"](slate, {
        at: {
          anchor: nextWordPoint,
          focus: point
        }
      });
    }
    // 删除到行首
    // 这里 melo 是删除到行首，但是 vscode 和 dom 版本是删除到段首，目前对齐 vscode 和 dom 版本逻辑
  }, {
    key: "deleteToLineStart",
    value: function deleteToLineStart() {
      var selection = this.selection,
        slate = this.slate;
      if (!selection) {
        return;
      }
      if (slate === null || slate === void 0 ? void 0 : slate.isRangeExpanded(selection)) {
        slate.deleteFragment({
          direction: 'forward'
        });
        return;
      }
      this.slate.deleteBackward('line');
    }
    // 删除到行尾
    // 这里 melo 没实现，vscode 和 dom 版本是删除到段落尾部，目前对齐 vscode 和 dom 版本逻辑
  }, {
    key: "deleteToLineEnd",
    value: function deleteToLineEnd() {
      var selection = this.selection,
        slate = this.slate;
      if (!selection) {
        return;
      }
      if (slate === null || slate === void 0 ? void 0 : slate.isRangeExpanded(selection)) {
        slate.deleteFragment({
          direction: 'forward'
        });
        return;
      }
      this.slate.deleteForward('line');
    }
    // 回车
  }, {
    key: "insertBreak",
    value: function insertBreak() {
      var _a;
      (_a = this.editor) === null || _a === void 0 ? void 0 : _a.insertBreak();
    }
    // 软回车
  }, {
    key: "insertSoftBreak",
    value: function insertSoftBreak() {
      var _a;
      (_a = this.editor) === null || _a === void 0 ? void 0 : _a.insertSoftBreak();
    }
    // 选中所有文字
  }, {
    key: "selectAll",
    value: function selectAll() {
      this.slate.selectAll();
    }
    /**
     * 判断给定光标是否在 \n 换行符后面
     * @param selection
     */
  }, {
    key: "isAfterSoftEnter",
    value: function isAfterSoftEnter() {
      var selection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selection;
      if (!selection) {
        return false;
      }
      if (Range.isExpanded(selection)) {
        return false;
      }
      return this.isBeforeTextEqualWith(selection.anchor, '\n');
    }
    /**
     * 左右选中逻辑，选中单位取决于 getPrevPoint 和 getNextPoint
     * @param defaultDirection
     * @param getPrevPoint
     * @param getNextPoint
     */
  }, {
    key: "extendSelection",
    value: function extendSelection(defaultDirection, getPrevPoint, getNextPoint) {
      var _a, _b, _c, _d;
      if (defaultDirection === Direction.backward) {
        // 左键
        if (this.movingDirection === Direction.forward) {
          // 移动选区结尾
          var endPoint = getPrevPoint(this.selectionEndPoint);
          endPoint = this.walkPoint(endPoint, Direction.backward);
          (_a = this.editorModel) === null || _a === void 0 ? void 0 : _a.setSelectionPoints(this.selectionStartPoint, endPoint);
        } else {
          // 移动选区开始
          this.movingDirection = defaultDirection;
          var startPoint = getPrevPoint(this.selectionStartPoint);
          startPoint = this.walkPoint(startPoint, Direction.backward);
          (_b = this.editorModel) === null || _b === void 0 ? void 0 : _b.setSelectionPoints(startPoint, this.selectionEndPoint);
        }
      } else {
        // 右键
        if (this.movingDirection === Direction.backward) {
          // 移动选区开始
          var _startPoint = getNextPoint(this.selectionStartPoint);
          _startPoint = this.walkPoint(_startPoint, Direction.forward);
          (_c = this.editorModel) === null || _c === void 0 ? void 0 : _c.setSelectionPoints(_startPoint, this.selectionEndPoint);
        } else {
          // 移动选区结尾
          this.movingDirection = defaultDirection;
          var _endPoint = getNextPoint(this.selectionEndPoint);
          _endPoint = this.walkPoint(_endPoint, Direction.forward);
          (_d = this.editorModel) === null || _d === void 0 ? void 0 : _d.setSelectionPoints(this.selectionStartPoint, _endPoint);
        }
      }
    }
    /**
     * 左右选中逻辑，选中单位为字符
     * @param defaultDirection
     * @returns
     */
  }, {
    key: "extendCharacterSelection",
    value: function extendCharacterSelection(defaultDirection) {
      var _this2 = this;
      return this.extendSelection(defaultDirection, function (point) {
        return _this2.getBeforePoint(point);
      }, function (point) {
        return _this2.getAfterPoint(point);
      });
    }
    /**
     * 左右选中逻辑，选中单位为单词
     * @param defaultDirection
     * @returns
     */
  }, {
    key: "extendWordSelection",
    value: function extendWordSelection(defaultDirection) {
      var _this3 = this;
      return this.extendSelection(defaultDirection, function (point) {
        return _this3.slate.getPrevWordPoint(point);
      }, function (point) {
        return _this3.slate.getNextWordPoint(point);
      });
    }
    /**
     * 获取给定位置的上一个位置，如果没有上一个位置，则返回给定位置
     */
  }, {
    key: "getBeforePoint",
    value: function getBeforePoint(point) {
      if (!point) {
        return point;
      }
      return Editor$1.before(this.slate, point, {
        distance: 1,
        unit: 'character'
      }) || point;
    }
    /**
     * 获取给定位置的下一个位置，如果没有下一个位置，则返回给定位置
     */
  }, {
    key: "getAfterPoint",
    value: function getAfterPoint(point) {
      if (!point) {
        return point;
      }
      return Editor$1.after(this.slate, point, {
        distance: 1,
        unit: 'character'
      }) || point;
    }
    /**
     * 回退时处理 backDeleteTextProps
     * 返回值为 true 表示阻止默认的删除逻辑
     * @returns boolean
     */
  }, {
    key: "handleBackDeleteTextProps",
    value: function handleBackDeleteTextProps() {
      var _this4 = this;
      var _a, _b;
      if (!this.selection) {
        return false;
      }
      if ((_a = this.slate) === null || _a === void 0 ? void 0 : _a.isRangeExpanded(this.selection)) {
        return false;
      }
      var selection = this.selection,
        slate = this.slate,
        backDeleteTextProps = this.backDeleteTextProps;
      if (!slate || !backDeleteTextProps) {
        return false;
      }
      // 保证光标使用左边节点定位
      var normalizedSelectionAnchor = slate.normalizePoint(selection.anchor);
      var _SlateEditor$node = Editor$1.node(slate, normalizedSelectionAnchor),
        _SlateEditor$node2 = _slicedToArray(_SlateEditor$node, 2),
        node = _SlateEditor$node2[0],
        nodePath = _SlateEditor$node2[1];
      // 如果光标不在当前节点末尾，直接返回
      if (!slate.isSamePoint(Editor$1.end(slate, nodePath), normalizedSelectionAnchor)) {
        return false;
      }
      // 获取当前光标右侧的节点
      var nextTextElement = (_b = Editor$1.next(slate, {
        at: normalizedSelectionAnchor,
        mode: 'lowest'
      })) === null || _b === void 0 ? void 0 : _b[0];
      // 获取 backDeleteTextProps 中在当前位置满足条件需要先删除的属性列表
      var deleteProps = this.filterBackDeleteTextProps(node, nextTextElement);
      // 如果当前节点没有需要删除的属性，或者当前节点为空，直接返回
      if (!deleteProps.length || node.text === '') {
        return false;
      }
      // 如果有需要处理的 backDeleteTextProps，那么就先删除满足条件的属性，不删除文字
      Editor$1.withoutNormalizing(slate, function () {
        deleteProps.forEach(function (propKey) {
          _this4.editorModel.removeTextProps(propKey, Editor$1.range(slate, nodePath));
        });
      });
      return true;
    }
    /**
     * 过滤当前位置需要处理的 backDeleteTextProps
     */
  }, {
    key: "filterBackDeleteTextProps",
    value: function filterBackDeleteTextProps(currentNode, nextNode) {
      var _this$backDeleteTextP = this.backDeleteTextProps,
        backDeleteTextProps = _this$backDeleteTextP === void 0 ? [] : _this$backDeleteTextP;
      return backDeleteTextProps.filter(function (key) {
        // 如果当前节点没有 [key] 属性，那么返回 false
        if (!Object.prototype.hasOwnProperty.call(currentNode, key)) {
          return false;
        }
        // 如果当前节点和右侧节点的 [key] 属性值一致，则该属性不需要删除，也就是对这个属性来说，当前位置并不是边界
        if (shallowEquals(nextNode === null || nextNode === void 0 ? void 0 : nextNode[key], currentNode[key])) {
          return false;
        }
        return true;
      });
    }
    /**
     * 判断给定点的前一个字符是否等于给定文字
     * @param point
     * @param text
     * @returns
     */
  }, {
    key: "isBeforeTextEqualWith",
    value: function isBeforeTextEqualWith(point, text) {
      var _a;
      if (!point || !text) {
        return false;
      }
      var beforePoint = this.getBeforePoint(point);
      var beforeString = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.getString({
        anchor: point,
        focus: beforePoint
      });
      return beforeString === text;
    }
    // 通过点设置选区，包含对void元素的处理
  }, {
    key: "setSelectionByPoint",
    value: function setSelectionByPoint(point, direction) {
      var skip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (this.editorModel) {
        var _this$editorModel$get = this.editorModel.getVoidInfoByPoint(point),
          range = _this$editorModel$get.range,
          isInsideVoid = _this$editorModel$get.isInsideVoid;
        if (isInsideVoid) {
          var anchor = range.anchor,
            focus = range.focus;
          // 非skip就选中void range
          // 如果skip，就跳过选区（光标移动到上/下单词会跳过void，不会选中）
          if (direction === Direction.forward) {
            this.editorModel.setSelectionPoints(skip ? focus : anchor, focus);
          } else {
            this.editorModel.setSelectionPoints(anchor, skip ? anchor : focus);
          }
        } else {
          var normalizedPoint = this.slate.normalizePoint(point);
          this.editorModel.setSelectionPoints(normalizedPoint, normalizedPoint);
        }
      }
    }
    /**
     * 在一定情况下，转换point的位置
     * @param originPoint 当前处理的点
     * @param direction 光标移动的方向
     *
     * walk意为"从原点推进/后撤"的意思，transform不能很好的表达
     */
  }, {
    key: "walkPoint",
    value: function walkPoint(originPoint, direction) {
      var _this5 = this;
      // 目前walkPoint只会在扩张选区的时候使用，而移动光标没有使用，原因是移动光标，希望自动选中void，行为和这个不是特别一致。
      // walkPoint是希望能够收敛"单点在业务逻辑下的位置移动"。如果把 光标移动的选中复用这个，会增加复杂度，现在光标移动自动选中使用setSelectionByPoint比较合适
      // 光标对换行符的处理没有写成walker原因是，只需要在光标移动的时候执行，而且直接写会更方便一些。
      // 暂时先这样，后面还有其他可以写成walker的逻辑，再看看这块是否有更合适的组织方式
      var walkers = [this.pointVoidWalker];
      return walkers.reduce(function (currentPoint, walker) {
        return walker.call(_this5, currentPoint, direction);
      }, originPoint);
    }
  }, {
    key: "walkPointWithCaretEffect",
    value: function walkPointWithCaretEffect(originPoint, direction) {
      var point = this.walkPoint(originPoint, direction);
      if (!Point.equals(point, originPoint)) {
        // 需要废弃排版层光标位置的原因：
        // 在执行"选区扩张到行尾"等逻辑时，会使用排版层光标位置来获取对应的目标点。但是此位置有可能不是"最终选区生效的位置"。
        // 比如如果行尾是一个跨行的void，当选区扩张到结尾时，会先获取一个layoutCaret来获取结尾的point，
        // 如果判定在void内，需要手动将selection继续扩张到void结束的point
        // 这个时候setSelection预期的focus是selection.focus而不是layoutCaret
        // 如果不清除layoutCaret，update光标的时候，将会优先使用layoutCaret而不是实际的focus
        // 从而导致后续的逻辑判断异常
        // e.g 将selection继续扩张到void结束，再继续按扩张到行尾，将会没反应，因为优先使用排版层光标，在上一行
        this.deprecateLayoutCaretRect();
      }
      return point;
    }
    /**
     * 接受一个Point，如果point在void内，根据方向将点移动到void的anchor/focus
     * @param originPoint
     * @param direction
     * @private
     */
  }, {
    key: "pointVoidWalker",
    value: function pointVoidWalker(originPoint, direction) {
      var _a;
      var _ref2 = ((_a = this.editorModel) === null || _a === void 0 ? void 0 : _a.getVoidInfoByPoint(originPoint)) || {},
        range = _ref2.range,
        isInsideVoid = _ref2.isInsideVoid;
      if (isInsideVoid) {
        var anchor = range.anchor,
          focus = range.focus;
        return direction === Direction.forward ? focus : anchor;
      }
      return originPoint;
    }
  }]);
}(EditorAttachable);

var css_248z = ".style_ios-caret-dragger-container__DlqSc {\n  visibility: hidden;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n}\n.style_ios-caret-dragger-container__DlqSc .style_follow-finger-caret__o7rB4 {\n  position: absolute;\n  background-color: #1e6fff;\n  transform-origin: center center;\n  transition: transform 200ms;\n}\n.style_ios-caret-dragger-container__DlqSc .style_fake-caret__1y5ML {\n  position: absolute;\n  background-color: #cccccc;\n  transform-origin: center center;\n  transition: transform 200ms;\n}\n\n.style_android-caret-dragger-container__Nev0H {\n  visibility: hidden;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n}\n.style_android-caret-dragger-container__Nev0H .style_fake-caret__1y5ML {\n  position: absolute;\n  background-color: #1e6fff;\n  transition: transform 300ms;\n}\n.style_android-caret-dragger-container__Nev0H .style_fake-caret__1y5ML .style_caret-hot-spot__rKrAO {\n  position: absolute;\n}\n.style_android-caret-dragger-container__Nev0H .style_fake-caret__1y5ML .style_caret-symbol__0P4aQ {\n  position: absolute;\n  width: 22px;\n  height: 22px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-image: url(data:image/png;base64,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);\n  transform-origin: center;\n  touch-action: none;\n}\n.style_android-caret-dragger-container__Nev0H .style_fake-caret__1y5ML.style_left-top__C-Uav {\n  transform-origin: center 100%;\n}\n.style_android-caret-dragger-container__Nev0H .style_fake-caret__1y5ML.style_left-top__C-Uav .style_caret-symbol__0P4aQ {\n  top: 100%;\n  left: 50%;\n  transform: translate(-50%, -10%);\n}\n.style_android-caret-dragger-container__Nev0H .style_fake-caret__1y5ML.style_right-top__QjgXN {\n  transform-origin: 0 center;\n}\n.style_android-caret-dragger-container__Nev0H .style_fake-caret__1y5ML.style_right-top__QjgXN .style_caret-symbol__0P4aQ {\n  top: 50%;\n  left: 0;\n  transform: translate(-90%, -50%) rotate(90deg);\n}\n.style_android-caret-dragger-container__Nev0H .style_fake-caret__1y5ML.style_left-bottom__1B6Th {\n  transform-origin: 100% center;\n}\n.style_android-caret-dragger-container__Nev0H .style_fake-caret__1y5ML.style_left-bottom__1B6Th .style_caret-symbol__0P4aQ {\n  top: 50%;\n  left: 100%;\n  transform: translate(-10%, -50%) rotate(-90deg);\n}";
var style = {"ios-caret-dragger-container":"style_ios-caret-dragger-container__DlqSc","follow-finger-caret":"style_follow-finger-caret__o7rB4","fake-caret":"style_fake-caret__1y5ML","android-caret-dragger-container":"style_android-caret-dragger-container__Nev0H","caret-hot-spot":"style_caret-hot-spot__rKrAO","caret-symbol":"style_caret-symbol__0P4aQ","left-top":"style_left-top__C-Uav","right-top":"style_right-top__QjgXN","left-bottom":"style_left-bottom__1B6Th","iosCaretDraggerContainer":"style_ios-caret-dragger-container__DlqSc","followFingerCaret":"style_follow-finger-caret__o7rB4","fakeCaret":"style_fake-caret__1y5ML","androidCaretDraggerContainer":"style_android-caret-dragger-container__Nev0H","caretHotSpot":"style_caret-hot-spot__rKrAO","caretSymbol":"style_caret-symbol__0P4aQ","leftTop":"style_left-top__C-Uav","rightTop":"style_right-top__QjgXN","leftBottom":"style_left-bottom__1B6Th"};
styleInject(css_248z);

function _callSuper$4(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$4() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$4() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$4 = function _isNativeReflectConstruct() { return !!t; })(); }
var BaseCaretDragger = /*#__PURE__*/function (_TouchController) {
  function BaseCaretDragger() {
    var _this;
    _classCallCheck(this, BaseCaretDragger);
    _this = _callSuper$4(this, BaseCaretDragger);
    _this.initContainer();
    _this.initFakeCaret();
    return _this;
  }
  _inherits(BaseCaretDragger, _TouchController);
  return _createClass(BaseCaretDragger, [{
    key: "caretThickness",
    get:
    // 为了保证光标的粗细不受缩放影响，需要逆向计算一下
    function get() {
      return 2 / this.transformScale;
    }
  }, {
    key: "attach",
    value: function attach(surface) {
      this.surfaceDom = surface;
      this.surfaceDom.appendChild(this.container);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.surfaceDom.removeChild(this.container);
      this.clear();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.container.style.visibility = 'hidden';
      // 重置位置，避免影响外面容器的滚动条位置
      this.fakeCaret.style.cssText += 'left: 0px; top: 0px;';
    }
  }, {
    key: "show",
    value: function show() {
      this.container.style.visibility = 'visible';
    }
  }, {
    key: "update",
    value: function update(x, y, width, height, _caretLine) {
      this.updateFakeCaret(x, y, width, height);
    }
  }, {
    key: "triggerTouchStart",
    value: function triggerTouchStart(_position) {}
  }, {
    key: "triggerTouchMove",
    value: function triggerTouchMove(_position) {}
  }, {
    key: "triggerTouchEnd",
    value: function triggerTouchEnd(_position, _isLongTouched) {}
  }, {
    key: "triggerLongTouch",
    value: function triggerLongTouch(position) {
      var needSelectWord = this.onLongTouch(position);
      if (needSelectWord) {
        this.selectWord(position);
      }
    }
  }, {
    key: "onLongTouch",
    value: function onLongTouch(_position) {
      return true;
    }
  }, {
    key: "selectWord",
    value: function selectWord(position) {
      var _a, _b;
      var point = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.getPointByPosition(position);
      if (!point) {
        return;
      }
      (_b = this.editor) === null || _b === void 0 ? void 0 : _b.model.selectCurrentWord(point);
    }
  }, {
    key: "initContainer",
    value: function initContainer() {
      this.container = document.createElement('div');
    }
  }, {
    key: "clear",
    value: function clear() {}
  }, {
    key: "initFakeCaret",
    value: function initFakeCaret() {
      this.fakeCaret = document.createElement('div');
      this.fakeCaret.classList.add(style.fakeCaret);
      this.container.appendChild(this.fakeCaret);
    }
  }, {
    key: "updateFakeCaret",
    value: function updateFakeCaret(x, y, width, height) {
      var fakeCaretWidth;
      var fakeCaretHeight;
      if (width < height) {
        // 正常横排文字，光标是竖着的
        fakeCaretWidth = this.caretThickness;
        fakeCaretHeight = height;
      } else {
        // 竖排文字，光标是横着的
        fakeCaretWidth = width;
        fakeCaretHeight = this.caretThickness;
      }
      this.fakeCaret.style.cssText += "left: ".concat(x, "px; top: ").concat(y, "px; width: ").concat(fakeCaretWidth, "px; height: ").concat(fakeCaretHeight, "px;");
      this.fakeCaretX = x;
      this.fakeCaretY = y;
      this.fakeCaretWidth = fakeCaretWidth;
      this.fakeCaretHeight = fakeCaretHeight;
    }
  }]);
}(TouchController);

function _callSuper$3(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$3() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$3() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$3 = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet$1(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
var autoHideTime = 2800;
var AndroidCaretDragger = /*#__PURE__*/function (_BaseCaretDragger) {
  function AndroidCaretDragger() {
    var _this;
    _classCallCheck(this, AndroidCaretDragger);
    _this = _callSuper$3(this, AndroidCaretDragger);
    _this.isStartDrag = false;
    _this.handleMouseDown = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    _this.handleTouchStart = function (event) {
      // 阻止下默认事件，避免长按出现右键菜单以及导致输入框失焦
      event.preventDefault();
      event.stopPropagation();
      _this.startDrag();
      _this.updateTouchstartExtentOffset(event);
      _this.handleTouchPoint(event);
    };
    _this.handleTouchMove = function (event) {
      event.preventDefault();
      if (!_this.isStartDrag) {
        return;
      }
      if (!_this.editor) {
        return;
      }
      _this.updateSelectionFromTouch(event);
      _this.show();
    };
    _this.handleTouchEnd = function (event) {
      // 避免 touchend 事件冒泡到上面，导致一些不可控的逻辑（比如失焦）
      event.stopPropagation();
      _this.stopDrag();
    };
    // eslint-disable-next-line @typescript-eslint/member-ordering
    _this.updateSelectionFromTouch = throttle_1(function (event) {
      var _a;
      var point = _this.getPointFromTouch(event);
      if (!point) {
        return;
      }
      (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.model.setSelectionPoints(point, point);
    }, 50);
    _this.initCaretSymbol();
    _this.initHotSpot();
    _this.registerEvent();
    return _this;
  }
  _inherits(AndroidCaretDragger, _BaseCaretDragger);
  return _createClass(AndroidCaretDragger, [{
    key: "caretSymbolWidth",
    get: function get() {
      return 22 / this.transformScale;
    }
  }, {
    key: "caretSymbolHeight",
    get: function get() {
      return 22 / this.transformScale;
    }
    // 触摸区域逻辑宽度
  }, {
    key: "hotSpotMeasure",
    get: function get() {
      return 30 / this.transformScale;
    }
  }, {
    key: "update",
    value: function update(x, y, width, height, caretLine) {
      _superPropGet$1(AndroidCaretDragger, "update", this, 3)([x, y, width, height, caretLine]);
      this.updateFakeCaretClass();
      this.updateCaretSymbol();
      this.updateCurrentLine(caretLine);
      this.updateHotSpot();
    }
  }, {
    key: "show",
    value: function show() {
      var _this2 = this;
      _superPropGet$1(AndroidCaretDragger, "show", this, 3)([]);
      clearTimeout(this.autoHideTimer);
      // 一段时间后没操作就自动隐藏
      this.autoHideTimer = setTimeout(function () {
        _this2.hide();
      }, autoHideTime);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.unregisterEvent();
    }
  }, {
    key: "triggerTouchEnd",
    value: function triggerTouchEnd(_position) {
      var isLongTouched = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _a;
      // 只有当光标态时才显示
      if (!isLongTouched && ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.isSelectionCollapsed())) {
        this.show();
      }
    }
  }, {
    key: "isCaretDragging",
    value: function isCaretDragging() {
      return this.isStartDrag;
    }
  }, {
    key: "initContainer",
    value: function initContainer() {
      _superPropGet$1(AndroidCaretDragger, "initContainer", this, 3)([]);
      this.container.classList.add(style.androidCaretDraggerContainer);
    }
  }, {
    key: "initCaretSymbol",
    value: function initCaretSymbol() {
      this.caretSymbol = document.createElement('div');
      this.caretSymbol.classList.add(style.caretSymbol);
      this.fakeCaret.appendChild(this.caretSymbol);
    }
  }, {
    key: "initHotSpot",
    value: function initHotSpot() {
      this.hotSpot = document.createElement('div');
      this.hotSpot.classList.add(style.caretHotSpot);
      this.fakeCaret.appendChild(this.hotSpot);
    }
  }, {
    key: "registerEvent",
    value: function registerEvent() {
      this.hotSpot.addEventListener('mousedown', this.handleMouseDown);
      this.hotSpot.addEventListener('touchstart', this.handleTouchStart);
      this.hotSpot.addEventListener('touchmove', this.handleTouchMove);
      this.hotSpot.addEventListener('touchend', this.handleTouchEnd);
      this.hotSpot.addEventListener('touchcancel', this.handleTouchEnd);
    }
  }, {
    key: "unregisterEvent",
    value: function unregisterEvent() {
      this.hotSpot.removeEventListener('mousedown', this.handleMouseDown);
      this.hotSpot.removeEventListener('touchstart', this.handleTouchStart);
      this.hotSpot.removeEventListener('touchmove', this.handleTouchMove);
      this.hotSpot.removeEventListener('touchend', this.handleTouchEnd);
      this.hotSpot.removeEventListener('touchcancel', this.handleTouchEnd);
    }
    /**
     * touchstart 时处理下单击双击三击逻辑
     * 因为出现这个光标拖拽条的时候，在这里再怎么点击也不会触发外面原有的单击双击三击逻辑
     * 所以需要在这里手动处理下这部分逻辑
     */
  }, {
    key: "handleTouchPoint",
    value: function handleTouchPoint(event) {
      var _a;
      var point = this.getPointFromTouch(event);
      if (!point) {
        return;
      }
      (_a = this.editor) === null || _a === void 0 ? void 0 : _a.handleTouchPoint(point);
    }
  }, {
    key: "startDrag",
    value: function startDrag() {
      this.isStartDrag = true;
      this.fakeCaret.style.transform = 'scale(1.3)';
    }
  }, {
    key: "stopDrag",
    value: function stopDrag() {
      this.isStartDrag = false;
      this.fakeCaret.style.transform = 'none';
    }
    /**
     * 更新光标 class，不同文字排列方式有不同的 class，主要用于 symbol 的位置
     */
  }, {
    key: "updateFakeCaretClass",
    value: function updateFakeCaretClass() {
      this.fakeCaret.classList.remove(style.leftBottom);
      this.fakeCaret.classList.remove(style.rightTop);
      this.fakeCaret.classList.remove(style.leftTop);
      switch (this.coordinate) {
        case CoordinateZero.LEFT_BOTTOM:
          {
            this.fakeCaret.classList.add(style.leftBottom);
            break;
          }
        case CoordinateZero.RIGHT_TOP:
          {
            this.fakeCaret.classList.add(style.rightTop);
            break;
          }
        case CoordinateZero.LEFT_TOP:
          if (this.lineExpandDirection === LineExpandDirection.HORIZONTAL) {
            this.fakeCaret.classList.add(style.leftBottom);
            break;
          }
        default:
          {
            this.fakeCaret.classList.add(style.leftTop);
            break;
          }
      }
    }
    /**
     * 更新触摸热区大小位置
     */
  }, {
    key: "updateHotSpot",
    value: function updateHotSpot() {
      var fakeCaretWidth = this.fakeCaretWidth,
        fakeCaretHeight = this.fakeCaretHeight,
        caretSymbolWidth = this.caretSymbolWidth,
        caretSymbolHeight = this.caretSymbolHeight,
        hotSpotMeasure = this.hotSpotMeasure;
      var hotSpotWidth;
      var hotSpotHeight;
      var hotSpotLeft;
      var hotSpotTop;
      switch (this.coordinate) {
        case CoordinateZero.LEFT_BOTTOM:
          {
            hotSpotWidth = fakeCaretWidth + caretSymbolWidth;
            hotSpotHeight = hotSpotMeasure;
            hotSpotLeft = 0;
            hotSpotTop = -hotSpotMeasure / 2;
            break;
          }
        case CoordinateZero.RIGHT_TOP:
          {
            hotSpotWidth = fakeCaretWidth + caretSymbolWidth;
            hotSpotHeight = hotSpotMeasure;
            hotSpotLeft = -caretSymbolWidth;
            hotSpotTop = -hotSpotMeasure / 2;
            break;
          }
        case CoordinateZero.LEFT_TOP:
          if (this.lineExpandDirection === LineExpandDirection.HORIZONTAL) {
            hotSpotWidth = fakeCaretWidth + caretSymbolWidth;
            hotSpotHeight = hotSpotMeasure;
            hotSpotLeft = 0;
            hotSpotTop = -hotSpotMeasure / 2;
            break;
          }
        default:
          {
            hotSpotWidth = hotSpotMeasure;
            hotSpotHeight = fakeCaretHeight + caretSymbolHeight;
            hotSpotLeft = -hotSpotMeasure / 2;
            hotSpotTop = 0;
            break;
          }
      }
      this.hotSpot.style.cssText += "\n      width: ".concat(hotSpotWidth, "px; height: ").concat(hotSpotHeight, "px;\n      left: ").concat(hotSpotLeft, "px; top: ").concat(hotSpotTop, "px;\n    ");
    }
    /**
     * 更新光标 symbol 的位置和大小
     */
  }, {
    key: "updateCaretSymbol",
    value: function updateCaretSymbol() {
      this.caretSymbol.style.cssText += "\n      width: ".concat(this.caretSymbolWidth, "px;\n      height: ").concat(this.caretSymbolHeight, "px;\n    ");
    }
  }]);
}(BaseCaretDragger);

function _callSuper$2(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$2() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
var IosCaretDragger = /*#__PURE__*/function (_BaseCaretDragger) {
  function IosCaretDragger() {
    var _this;
    _classCallCheck(this, IosCaretDragger);
    _this = _callSuper$2(this, IosCaretDragger);
    _this.isStartDrag = false;
    // eslint-disable-next-line @typescript-eslint/member-ordering
    _this.updateCaretFromTouch = throttle_1(function (position) {
      var _a;
      if (!_this.editor) {
        return;
      }
      var point = _this.editor.getPointByPosition(position);
      if (!point) {
        return;
      }
      (_a = _this.editor) === null || _a === void 0 ? void 0 : _a.model.setSelectionPoints(point, point);
    }, 50);
    _this.initFollowFingerCaret();
    return _this;
  }
  _inherits(IosCaretDragger, _BaseCaretDragger);
  return _createClass(IosCaretDragger, [{
    key: "detach",
    value: function detach() {
      _superPropGet(IosCaretDragger, "detach", this, 3)([]);
    }
  }, {
    key: "onLongTouch",
    value: function onLongTouch(position) {
      var _a, _b;
      var point = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.getPointByPosition(position);
      if (!point) {
        return false;
      }
      // 当前是光标态且在光标附近长按
      if (((_b = this.editor) === null || _b === void 0 ? void 0 : _b.isSelectionCollapsed()) && Point.equals(this.editor.selection.focus, point)) {
        this.startDrag();
        // 更新 surface，从而更新 fakeCaret
        this.editor.updateSurface();
        this.updateFollowFingerCaret(position);
        return false;
      }
      return true;
    }
  }, {
    key: "triggerTouchMove",
    value: function triggerTouchMove(position) {
      if (!this.isStartDrag) {
        return;
      }
      if (!this.editor) {
        return;
      }
      this.updateCaretFromTouch(position);
      this.updateFollowFingerCaret(position);
    }
  }, {
    key: "triggerTouchEnd",
    value: function triggerTouchEnd() {
      this.stopDrag();
    }
  }, {
    key: "show",
    value: function show() {
      _superPropGet(IosCaretDragger, "show", this, 3)([]);
      this.followFingerCaret.style.cssText += 'transform: scale(1.3);';
    }
  }, {
    key: "hide",
    value: function hide() {
      _superPropGet(IosCaretDragger, "hide", this, 3)([]);
      this.followFingerCaret.style.cssText += 'transform: scale(1); left: 0px; top: 0px;';
    }
  }, {
    key: "isCaretDragging",
    value: function isCaretDragging() {
      return this.isStartDrag;
    }
  }, {
    key: "initContainer",
    value: function initContainer() {
      _superPropGet(IosCaretDragger, "initContainer", this, 3)([]);
      this.container.classList.add(style.iosCaretDraggerContainer);
    }
  }, {
    key: "initFollowFingerCaret",
    value: function initFollowFingerCaret() {
      this.followFingerCaret = document.createElement('div');
      this.followFingerCaret.classList.add(style.followFingerCaret);
      this.container.appendChild(this.followFingerCaret);
    }
  }, {
    key: "startDrag",
    value: function startDrag() {
      this.isStartDrag = true;
      this.show();
    }
  }, {
    key: "stopDrag",
    value: function stopDrag() {
      this.isStartDrag = false;
      this.hide();
    }
  }, {
    key: "updateFollowFingerCaret",
    value: function updateFollowFingerCaret(_ref) {
      var posXOfWorld = _ref.posXOfWorld,
        posYOfWorld = _ref.posYOfWorld;
      var _a;
      if (!this.editor) {
        return;
      }
      /**
       * 这里获取到了触摸点相对于 editor 的位置
       * 由于 followFingerCaret 是相对于 transform 上下文定位，所以需要考虑到 scale
       */
      var _this$editor$position = this.editor.positionOfAppToPositionOfEditor(posXOfWorld, posYOfWorld),
        x = _this$editor$position.x,
        y = _this$editor$position.y;
      var scale = ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.scale) || 1;
      var fakeCaretWidth = this.fakeCaretWidth,
        fakeCaretHeight = this.fakeCaretHeight;
      var left;
      var top;
      if (fakeCaretWidth < fakeCaretHeight) {
        // 正常横排文字，光标是竖着的
        left = x / scale;
        top = y / scale - fakeCaretHeight / 2;
      } else {
        // 竖排文字，光标是横着的
        left = x / scale - fakeCaretWidth / 2;
        top = y / scale;
      }
      var _this$legalizeFollowF = this.legalizeFollowFingerCaretOffset(left, top);
      var _this$legalizeFollowF2 = _slicedToArray(_this$legalizeFollowF, 2);
      left = _this$legalizeFollowF2[0];
      top = _this$legalizeFollowF2[1];
      this.followFingerCaret.style.cssText += "\n      left: ".concat(left, "px; top: ").concat(top, "px; width: ").concat(fakeCaretWidth, "px; height: ").concat(fakeCaretHeight, "px;\n    ");
    }
    /**
     * 合法化光标位置，不能超出文字范围
     * 这里 left top 都是相对于 editor blockRect 偏移之后的的
     * @param left
     * @param top
     * @returns
     */
  }, {
    key: "legalizeFollowFingerCaretOffset",
    value: function legalizeFollowFingerCaretOffset(left, top) {
      var _a;
      var fakeCaretWidth = this.fakeCaretWidth,
        fakeCaretHeight = this.fakeCaretHeight,
        textRect = this.textRect,
        blockRect = this.blockRect;
      var scale = ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.scale) || 1;
      var blockX = blockRect.x,
        blockY = blockRect.y;
      // textRect 是相对于 blockRect 偏移之前的，所以需要计算下偏移之后的位置，和 left top 统一坐标系
      var textRectXOfEditor = textRect.x - blockX;
      var textRectYOfEditor = textRect.y - blockY;
      var newLeft = left;
      var newTop = top;
      // 下面四个计算逻辑都是把 left 或 top 计算为相对于 textRect 的原点位置然后进行比对
      // left 最小不能超出文字范围左侧
      if (left - textRectXOfEditor / scale < 0) {
        newLeft = textRectXOfEditor / scale;
      }
      // top 最小不能超出文字范围顶部
      if (top - textRectYOfEditor / scale < 0) {
        newTop = textRectYOfEditor / scale;
      }
      // left 最大不能超出右侧
      if (left + fakeCaretWidth - textRectXOfEditor / scale > textRect.width / scale) {
        newLeft = (textRectXOfEditor + textRect.width) / scale - fakeCaretWidth;
      }
      // top 最大不能超出底部
      if (top + fakeCaretHeight - textRectYOfEditor / scale > textRect.height / scale) {
        newTop = (textRectYOfEditor + textRect.height) / scale - fakeCaretHeight;
      }
      return [newLeft, newTop];
    }
  }]);
}(BaseCaretDragger);

function createCaretDragger(platform) {
  if (platform === Platform.iosMobile) {
    return new IosCaretDragger();
  }
  if (platform === Platform.androidMobile) {
    return new AndroidCaretDragger();
  }
  return null;
}

/**
 * Hotkey mappings for each platform.
 */
var HOTKEYS = {
  bold: 'mod+b',
  compose: ['down', 'left', 'right', 'up', 'backspace', 'enter'],
  moveWordBackward: 'ctrl+left',
  moveWordForward: 'ctrl+right',
  moveToLineStart: 'home',
  moveToLineEnd: 'end',
  deleteBackward: 'shift?+backspace',
  deleteForward: 'shift?+delete',
  extendBackward: 'shift+left',
  extendForward: 'shift+right',
  extendLineBackward: 'shift+up',
  extendLineForward: 'shift+down',
  italic: 'mod+i',
  splitBlock: 'enter',
  insertSoftBreak: 'shift?+enter',
  undo: 'mod+z',
  selectAll: 'mod+a',
  left: 'left',
  right: 'right',
  up: 'up',
  down: 'down'
};
var APPLE_HOTKEYS = {
  // moveLineBackward: 'opt+up',
  // moveLineForward: 'opt+down',
  moveWordBackward: 'opt+left',
  moveWordForward: 'opt+right',
  moveToLineStart: 'cmd+left',
  moveToLineEnd: 'cmd+right',
  moveToParagraphStart: 'ctrl+a',
  moveToParagraphEnd: 'ctrl+e',
  moveToDocStart: 'cmd+up',
  moveToDocEnd: 'cmd+down',
  extendWordBackward: 'shift+left+opt',
  extendWordForward: 'shift+right+opt',
  extendLineStart: 'shift+cmd+left',
  extendLineEnd: 'shift+cmd+right',
  extendParagraphStart: 'opt+shift+up',
  extendParagraphEnd: 'opt+shift+down',
  extendDocStart: 'cmd+shift+up',
  extendDocEnd: 'cmd+shift+down',
  deleteBackward: ['ctrl+backspace', 'ctrl+h'],
  deleteForward: ['ctrl+delete', 'ctrl+d'],
  deleteLineBackward: 'cmd+shift?+backspace',
  deleteLineForward: 'cmd+shift?+delete',
  deleteWordBackward: 'opt+shift?+backspace',
  deleteWordForward: 'opt+shift?+delete',
  redo: 'cmd+shift+z',
  transposeCharacter: 'ctrl+t'
};
var WINDOWS_HOTKEYS = {
  moveToDocStart: 'pageup',
  moveToDocEnd: 'pagedown',
  extendWordBackward: 'shift+left+ctrl',
  extendWordForward: 'shift+right+ctrl',
  // deleteLineBackward: 'ctrl+shift?+backspace',
  // deleteLineForward: 'ctrl+shift?+delete',
  deleteWordBackward: 'ctrl+shift?+backspace',
  deleteWordForward: 'ctrl+shift?+delete',
  extendLineStart: 'shift+home',
  extendLineEnd: 'shift+end',
  extendParagraphStart: 'ctrl+shift+up',
  extendParagraphEnd: 'ctrl+shift+down',
  extendDocStart: 'shift+pageup',
  extendDocEnd: 'shift+pagedown',
  redo: ['ctrl+y', 'ctrl+shift+z']
};
/**
 * Create a platform-aware hotkey checker.
 */
var create = function create(key) {
  var generic = HOTKEYS[key];
  var apple = APPLE_HOTKEYS[key];
  var windows = WINDOWS_HOTKEYS[key];
  var isGeneric = generic && lib_3(generic);
  var isApple = apple && lib_3(apple);
  var isWindows = windows && lib_3(windows);
  return function (event) {
    if (isGeneric === null || isGeneric === void 0 ? void 0 : isGeneric(event)) return true;
    if (IS_APPLE && isApple && isApple(event)) return true;
    if (!IS_APPLE && isWindows && isWindows(event)) return true;
    return false;
  };
};
var isLeft = create('left');
var isRight = create('right');
var isUp = create('up');
var isDown = create('down');
function isMoveBackward(event, coordinateZero, lineExpandDirection) {
  switch (coordinateZero) {
    case CoordinateZero.LEFT_BOTTOM:
      {
        return isDown(event);
      }
    case CoordinateZero.RIGHT_TOP:
      {
        return isUp(event);
      }
    case CoordinateZero.LEFT_TOP:
      if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
        return isUp(event);
      }
    default:
      {
        return isLeft(event);
      }
  }
}
function isMoveForward(event, coordinateZero, lineExpandDirection) {
  switch (coordinateZero) {
    case CoordinateZero.LEFT_BOTTOM:
      {
        return isUp(event);
      }
    case CoordinateZero.RIGHT_TOP:
      {
        return isDown(event);
      }
    case CoordinateZero.LEFT_TOP:
      if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
        return isDown(event);
      }
    default:
      {
        return isRight(event);
      }
  }
}
function isMoveLineBackward(event, coordinateZero, lineExpandDirection) {
  switch (coordinateZero) {
    case CoordinateZero.LEFT_BOTTOM:
      {
        return isLeft(event);
      }
    case CoordinateZero.RIGHT_TOP:
      {
        return isRight(event);
      }
    case CoordinateZero.LEFT_TOP:
      if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
        return isLeft(event);
      }
    default:
      {
        return isUp(event);
      }
  }
}
function isMoveLineForward(event, coordinateZero, lineExpandDirection) {
  switch (coordinateZero) {
    case CoordinateZero.LEFT_BOTTOM:
      {
        return isRight(event);
      }
    case CoordinateZero.RIGHT_TOP:
      {
        return isLeft(event);
      }
    case CoordinateZero.LEFT_TOP:
      if (lineExpandDirection === LineExpandDirection.HORIZONTAL) {
        return isRight(event);
      }
    default:
      {
        return isDown(event);
      }
  }
}
// 是否按下修饰键
function hasDecoratorKey(event, key) {
  return event === null || event === void 0 ? void 0 : event[key];
}
/**
 * Hotkeys.
 */
var Hotkeys = {
  isBold: create('bold'),
  isCompose: create('compose'),
  isDeleteBackward: create('deleteBackward'),
  isDeleteForward: create('deleteForward'),
  isDeleteLineBackward: create('deleteLineBackward'),
  isDeleteLineForward: create('deleteLineForward'),
  isDeleteWordBackward: create('deleteWordBackward'),
  isDeleteWordForward: create('deleteWordForward'),
  isExtendBackward: create('extendBackward'),
  isExtendForward: create('extendForward'),
  isExtendLineBackward: create('extendLineBackward'),
  isExtendLineForward: create('extendLineForward'),
  isItalic: create('italic'),
  isMoveWordBackward: create('moveWordBackward'),
  isMoveWordForward: create('moveWordForward'),
  isRedo: create('redo'),
  isSplitBlock: create('splitBlock'),
  isInsertSoftBreak: create('insertSoftBreak'),
  isTransposeCharacter: create('transposeCharacter'),
  isUndo: create('undo'),
  isSelectAll: create('selectAll'),
  isMoveBackward: isMoveBackward,
  isMoveForward: isMoveForward,
  isMoveLineBackward: isMoveLineBackward,
  isMoveLineForward: isMoveLineForward,
  isExtendWordBackward: create('extendWordBackward'),
  isExtendWordForward: create('extendWordForward'),
  isExtendLineStart: create('extendLineStart'),
  isExtendLineEnd: create('extendLineEnd'),
  isExtendParagraphStart: create('extendParagraphStart'),
  isExtendParagraphEnd: create('extendParagraphEnd'),
  isMoveToLineStart: create('moveToLineStart'),
  isMoveToLineEnd: create('moveToLineEnd'),
  isMoveToParagraphStart: create('moveToParagraphStart'),
  isMoveToParagraphEnd: create('moveToParagraphEnd'),
  isMoveToDocStart: create('moveToDocStart'),
  isMoveToDocEnd: create('moveToDocEnd'),
  isExtendDocStart: create('extendDocStart'),
  isExtendDocEnd: create('extendDocEnd')
};

/**
 * @file 本文件基于 PIXI 修改而来.
 * @see https://github.com/pixijs/pixijs/blob/66aaf16a/packages/math/src/Matrix.ts
 */
/**
 * 二维齐次变换矩阵.
 *
 * @description
 * Matrix 类表示一个二维齐次坐标下的变换矩阵, 即 3×3 矩阵中的 6 个元素.
 *
 * Matrix 类内部表示矩阵元素时, 使用的是与位置无关的方式, 同时等价于下面的两种矩阵.
 * 图形学中一般把齐次坐标下的点表示为列向量, 所以类一般可以看作是左边的矩阵 1.
 *
 * 齐次坐标下的点 P 表示为列向量时, 先变换 A 再变换 B 的公式为: B × A × P. 所以类函数中的变换都是在左侧相乘.
 *
 * ```plain
 * 1. ┌  a  b tx ┐    2. ┌  a  c  0 ┐
 *    │  c  d ty │       │  b  d  0 │
 *    └  0  0  1 ┘       └ tx ty  1 ┘
 * ```
 *
 * 变换矩阵的入门介绍
 * - https://iwiki.woa.com/pages/viewpage.action?pageId=1083605964
 * - https://www.bilibili.com/video/BV1X7411F744?p=3
 */
var Matrix = /*#__PURE__*/function () {
  function Matrix() {
    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var tx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var ty = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    _classCallCheck(this, Matrix);
    this.a = a;
    this.b = b;
    this.c = c;
    this.d = d;
    this.tx = tx;
    this.ty = ty;
  }
  /** 设置矩阵的值. */
  return _createClass(Matrix, [{
    key: "set",
    value: function set(a, b, c, d, tx, ty) {
      this.a = a;
      this.b = b;
      this.c = c;
      this.d = d;
      this.tx = tx;
      this.ty = ty;
      return this;
    }
    /**
     * 平移.
     * @param x X 轴平移量.
     * @param y Y 轴平移量.
     * @description
     * ```plain
     *        ┌  1  0  x ┐   ┌  a  b tx ┐
     * this = │  0  1  y │ × │  c  d ty │
     *        └  0  0  1 ┘   └  0  0  1 ┘
     * ```
     */
  }, {
    key: "translate",
    value: function translate(x, y) {
      this.tx += x;
      this.ty += y;
      return this;
    }
    /**
     * 基于原点缩放.
     * @param sx X 轴缩放倍率.
     * @param sy Y 轴缩放倍率.
     * @description
     * ```plain
     *        ┌ sx  0  0 ┐   ┌  a  b tx ┐
     * this = │  0 sy  0 │ × │  c  d ty │
     *        └  0  0  1 ┘   └  0  0  1 ┘
     * ```
     */
  }, {
    key: "scale",
    value: function scale(sx, sy) {
      this.a *= sx;
      this.d *= sy;
      this.c *= sx;
      this.b *= sy;
      this.tx *= sx;
      this.ty *= sy;
      return this;
    }
    /**
     * 在当前平移位置缩放.
     * @param sx X 轴缩放倍率.
     * @param sy Y 轴缩放倍率.
     * @description
     * 等价于先平移到原点, 然后缩放, 再平移回原始位置 (`.translate(-tx, -ty).scale(x, y).translate(tx, ty)`).
     *
     * ```plain
     *        ┌  1  0 tx ┐   ┌ sx  0  0 ┐   ┌  1  0 -tx ┐   ┌  a  b tx ┐
     * this = │  0  1 ty │ × │  0 sy  0 │ × │  0  1 -ty │ × │  c  d ty │
     *        └  0  0  1 ┘   └  0  0  1 ┘   └  0  0   1 ┘   └  0  0  1 ┘
     * ```
     */
  }, {
    key: "scaleInSitu",
    value: function scaleInSitu(sx, sy) {
      this.a *= sx;
      this.d *= sy;
      this.c *= sx;
      this.b *= sy;
      return this;
    }
    /**
     * 顺时针旋转.
     * @param theta 旋转量 (弧度).
     * @description
     * ```plain
     *        ┌ cos -cos  0 ┐   ┌  a  b tx ┐
     * this = │ sin -sin  0 │ × │  c  d ty │
     *        └   0    0  1 ┘   └  0  0  1 ┘
     * ```
     */
  }, {
    key: "rotate",
    value: function rotate(theta) {
      if (theta === 0) return this;
      var cos = Math.cos(theta);
      var sin = Math.sin(theta);
      var a = this.a,
        c = this.c,
        tx = this.tx;
      this.a = a * cos - this.b * sin;
      this.b = a * sin + this.b * cos;
      this.c = c * cos - this.d * sin;
      this.d = c * sin + this.d * cos;
      this.tx = tx * cos - this.ty * sin;
      this.ty = tx * sin + this.ty * cos;
      return this;
    }
    /** 在当前变换后追加一个变换, 即先变换 this 再变换 matrix (this = matrix × this). */
  }, {
    key: "append",
    value: function append(matrix) {
      var a = this.a,
        b = this.b,
        c = this.c,
        d = this.d;
      this.a = matrix.a * a + matrix.b * c;
      this.b = matrix.a * b + matrix.b * d;
      this.c = matrix.c * a + matrix.d * c;
      this.d = matrix.c * b + matrix.d * d;
      this.tx = matrix.tx * a + matrix.ty * c + this.tx;
      this.ty = matrix.tx * b + matrix.ty * d + this.ty;
      return this;
    }
    /** 在当前变换前增加一个变换, 即先变换 matrix 再变换 this (this = this × matrix). */
  }, {
    key: "prepend",
    value: function prepend(matrix) {
      var a = this.a,
        c = this.c,
        tx = this.tx;
      if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
        this.a = a * matrix.a + this.b * matrix.c;
        this.b = a * matrix.b + this.b * matrix.d;
        this.c = c * matrix.a + this.d * matrix.c;
        this.d = c * matrix.b + this.d * matrix.d;
      }
      this.tx = tx * matrix.a + this.ty * matrix.c + matrix.tx;
      this.ty = tx * matrix.b + this.ty * matrix.d + matrix.ty;
      return this;
    }
    /**
     * 将矩阵重置为单位矩阵.
     * @description
     * ```plain
     *        ┌  1  0  0 ┐
     * this = │  0  1  0 │
     *        └  0  0  1 ┘
     * ```
     */
  }, {
    key: "identity",
    value: function identity() {
      this.a = 1;
      this.b = 0;
      this.c = 0;
      this.d = 1;
      this.tx = 0;
      this.ty = 0;
      return this;
    }
    /** 将矩阵变为逆矩阵 (this = this ^ -1). */
  }, {
    key: "invert",
    value: function invert() {
      var a = this.a,
        b = this.b,
        c = this.c,
        d = this.d,
        tx = this.tx;
      var n = a * d - b * c;
      this.a = d / n;
      this.b = -b / n;
      this.c = -c / n;
      this.d = a / n;
      this.tx = (c * this.ty - d * tx) / n;
      this.ty = -(a * this.ty - b * tx) / n;
      return this;
    }
    /** 将矩阵的值设置为与传入的矩阵相同 (this = matrix). */
  }, {
    key: "copyFrom",
    value: function copyFrom(matrix) {
      this.a = matrix.a;
      this.b = matrix.b;
      this.c = matrix.c;
      this.d = matrix.d;
      this.tx = matrix.tx;
      this.ty = matrix.ty;
      return this;
    }
    /**
     * 将矩阵对应的变换应用到某个点上, 得到一个新的点.
     * @param point 要变换的点.
     * @param output 输出点. 如果传入一个对象, 结果将写入到该对象上; 不传则会使用一个新的点.
     * @returns 返回同 output.
     */
  }, {
    key: "apply",
    value: function apply(point) {
      var output = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        x: 0,
        y: 0
      };
      var x = point.x,
        y = point.y;
      output.x = this.a * x + this.c * y + this.tx;
      output.y = this.b * x + this.d * y + this.ty;
      return output;
    }
    /**
     * 将矩阵对应的逆变换应用到某个点上, 得到一个新的点.
     * @param point 要变换的点.
     * @param output 输出点. 如果传入一个对象, 结果将写入到该对象上; 不传则会使用一个新的点.
     * @returns 返回同 output.
     */
  }, {
    key: "applyInverse",
    value: function applyInverse(point) {
      var output = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        x: 0,
        y: 0
      };
      var x = point.x,
        y = point.y;
      var id = 1 / (this.a * this.d + this.c * -this.b);
      output.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id;
      output.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id;
      return output;
    }
  }]);
}();
Matrix.Identity = new Matrix();

/**
 * 处理软回车的标记
 */
var SoftEnterFlag = /*#__PURE__*/function () {
  function SoftEnterFlag() {
    _classCallCheck(this, SoftEnterFlag);
  }
  return _createClass(SoftEnterFlag, null, [{
    key: "setFlag",
    value: function setFlag() {
      this.isHandledFlag = true;
    }
  }, {
    key: "resetFlag",
    value: function resetFlag() {
      this.isHandledFlag = false;
    }
  }]);
}();
// 标记当前软回车是否已经处理过
SoftEnterFlag.isHandledFlag = false;

var Surface = /*#__PURE__*/function () {
  function Surface() {
    _classCallCheck(this, Surface);
    this.attached = false;
    /**
     * 是否一直显示光标，这里是指光标是否展示不受输入框焦点影响，只要当前 editor 的选区是光标状态就一直显示
     * 加这个逻辑主要是用于一些场景标识当前光标位置（比如移动端在光标态设置文字样式时）
     */
    this.isKeepCaretShow = false;
    /**
     * 是否一直隐藏光标
     */
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.isKeepCaretHide = false;
  }
  return _createClass(Surface, [{
    key: "attach",
    value: function attach() {
      var _this = this;
      if (this.attached) return;
      this.attachEditingComponent();
      this.caretManager = new CaretManager();
      this.selectionHandler = new SelectionHandler({
        deprecateLayoutCaretRect: function deprecateLayoutCaretRect() {
          var _a;
          return (_a = _this.caretManager) === null || _a === void 0 ? void 0 : _a.deprecateLayoutCaretRect();
        },
        getPrevLinePoint: function getPrevLinePoint() {
          return _this.caretManager.moveToPrevLine();
        },
        getNextLinePoint: function getNextLinePoint() {
          return _this.caretManager.moveToNextLine();
        },
        getLineStartPoint: function getLineStartPoint() {
          return _this.caretManager.moveToLineStart();
        },
        getLineEndPoint: function getLineEndPoint() {
          return _this.caretManager.moveToLineEnd();
        },
        getNextLineStartPoint: function getNextLineStartPoint() {
          return _this.caretManager.moveToNextLineStart();
        },
        updateCaretInfo: function updateCaretInfo() {
          return _this.update();
        }
      });
      this.attached = true;
    }
  }, {
    key: "detach",
    value: function detach() {
      this.detachEditingComponent();
      this.selectionOverlay = null;
      this.caretManager = null;
      this.selectionHandler = null;
      this.attached = false;
    }
    /**
     * 绑定当前正在编辑的 editor 实例
     * @param editor Editor
     */
  }, {
    key: "attachEditor",
    value: function attachEditor(editor) {
      var _a;
      if (this.editor === editor) {
        return;
      }
      // 触发解绑之前的 editor
      this.editor && this.detachEditor(this.editor);
      this.selectionOverlay.attachEditor(editor);
      this.caretManager.attachEditor(editor);
      this.selectionHandler.attachEditor(editor);
      (_a = this.caretDragger) === null || _a === void 0 ? void 0 : _a.attachEditor(editor);
      this.updateSurfaceContainer(editor.container);
      // 这里触发 hook 是最准确的
      editor === null || editor === void 0 ? void 0 : editor.focusHook();
      this.editor = editor;
    }
    /**
     * 解绑当前正在编辑的 editor 实例
     * @param editor Editor
     */
  }, {
    key: "detachEditor",
    value: function detachEditor(editor) {
      var isBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _a, _b;
      // 这里触发 hook 是最准确的
      if (isBlur) {
        editor === null || editor === void 0 ? void 0 : editor.blurHook();
      }
      if (this.editor === editor) {
        this.editor = null;
        this.hideSurfaceDom();
        this.isKeepCaretShow = false;
        this.isKeepCaretHide = false;
      }
      (_a = this.selectionOverlay) === null || _a === void 0 ? void 0 : _a.detachEditor(editor);
      // 只读编辑器不需要光标
      if (this.readonly) {
        return;
      }
      this.caretManager.detachEditor(editor);
      this.selectionHandler.detachEditor(editor);
      (_b = this.caretDragger) === null || _b === void 0 ? void 0 : _b.detachEditor(editor);
    }
  }, {
    key: "isCaretDragging",
    get: function get() {
      var _a;
      return ((_a = this.caretDragger) === null || _a === void 0 ? void 0 : _a.isCaretDragging()) || false;
    }
  }, {
    key: "selection",
    get: function get() {
      var _a;
      return ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.selection) || null;
    }
  }, {
    key: "readonly",
    get: function get() {
      var _a;
      return ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.readonly) || false;
    }
  }, {
    key: "isSelectionCollapsed",
    get: function get() {
      var _a;
      return ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.isSelectionCollapsed()) || false;
    }
  }, {
    key: "preventScrollOnFocus",
    get: function get() {
      var _a;
      return ((_a = this.editor) === null || _a === void 0 ? void 0 : _a.preventScrollOnFocus) || false;
    }
  }, {
    key: "selectionBlockRect",
    get: function get() {
      var _a;
      if (!this.selection) {
        return undefined;
      }
      if (Range.isCollapsed(this.selection)) {
        // 光标，就返回光标的位置
        return this.caretManager.caretRect;
      }
      return (_a = this.selectionOverlay) === null || _a === void 0 ? void 0 : _a.selectionBlockRect;
    }
  }, {
    key: "getPointFromPointPosition",
    value: function getPointFromPointPosition(mousePosition) {
      return this.caretManager.updatePointByPointPosition(mousePosition);
    }
  }, {
    key: "update",
    value: function update() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$needUpdateSelect = _ref.needUpdateSelection,
        needUpdateSelection = _ref$needUpdateSelect === void 0 ? true : _ref$needUpdateSelect,
        _ref$needFocus = _ref.needFocus,
        needFocus = _ref$needFocus === void 0 ? true : _ref$needFocus;
      var _a;
      if (needUpdateSelection) {
        this.selectionOverlay.update();
      }
      if (this.readonly) {
        return;
      }
      this.updateCaretAndHiddenEditor(needFocus);
      (_a = this.selectionHandler) === null || _a === void 0 ? void 0 : _a.onSelectionChange();
    }
  }, {
    key: "triggerTouchStart",
    value: function triggerTouchStart(position) {
      var _a;
      (_a = this.caretDragger) === null || _a === void 0 ? void 0 : _a.triggerTouchStart(position);
      if (isMobileHiddenEditor(this.hiddenEditor)) {
        this.hiddenEditor.triggerTouchStart(Editor.platform);
      }
    }
  }, {
    key: "triggerTouchMove",
    value: function triggerTouchMove(position) {
      var _a;
      (_a = this.caretDragger) === null || _a === void 0 ? void 0 : _a.triggerTouchMove(position);
    }
  }, {
    key: "triggerTouchEnd",
    value: function triggerTouchEnd(position, isLongTouched) {
      var _a;
      (_a = this.caretDragger) === null || _a === void 0 ? void 0 : _a.triggerTouchEnd(position, isLongTouched);
    }
  }, {
    key: "triggerLongTouch",
    value: function triggerLongTouch(position) {
      var _a;
      (_a = this.caretDragger) === null || _a === void 0 ? void 0 : _a.triggerLongTouch(position);
    }
  }, {
    key: "clear",
    value: function clear() {
      var _a;
      (_a = this.selectionOverlay) === null || _a === void 0 ? void 0 : _a.clear();
    }
    /**
     * 保持光标一直显示
     * 如果当前选区是光标状态，直接显示
     */
  }, {
    key: "startKeepCaretShow",
    value: function startKeepCaretShow() {
      this.isKeepCaretShow = true;
      this.isKeepCaretHide = false;
      if (!this.readonly && this.isSelectionCollapsed) {
        this.caret.show();
      }
    }
    /**
     * 停止光标一直显示的状态
     * 隐藏当前光标
     */
  }, {
    key: "stopKeepCaretShow",
    value: function stopKeepCaretShow() {
      if (this.isKeepCaretShow) {
        this.isKeepCaretShow = false;
        this.caret.hide();
      }
    }
    /**
     * 保持光标一直隐藏
     */
  }, {
    key: "startKeepCaretHide",
    value: function startKeepCaretHide() {
      this.isKeepCaretHide = true;
      this.isKeepCaretShow = false;
      this.caret.hide();
    }
    /**
     * 停止光标一直隐藏
     * 如果当前选区是光标状态且输入框在焦点状态，直接显示
     */
  }, {
    key: "stopKeepCaretHide",
    value: function stopKeepCaretHide() {
      if (this.isKeepCaretHide) {
        this.isKeepCaretHide = false;
        if (!this.readonly && this.isSelectionCollapsed && this.isHiddenInputFocus) {
          this.caret.show();
        }
      }
    }
  }, {
    key: "updateCaretAndHiddenEditor",
    value: function updateCaretAndHiddenEditor() {
      var needFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _a, _b, _c;
      this.updateSurfaceMatrix();
      // 只读编辑器不需要光标和编辑框
      if (this.readonly) {
        return;
      }
      if (!this.selection) {
        return;
      }
      var caretInfo = this.selectionOverlay.caretInfo;
      if (!caretInfo) {
        this.caret.hide();
        (_a = this.caretDragger) === null || _a === void 0 ? void 0 : _a.hide();
        return;
      }
      var _this$caretManager$ge = this.caretManager.getCaretRectOfWindow(caretInfo.caretBox, caretInfo.caretPosition),
        x = _this$caretManager$ge.x,
        y = _this$caretManager$ge.y,
        width = _this$caretManager$ge.width,
        height = _this$caretManager$ge.height,
        isCaretFromLayout = _this$caretManager$ge.isCaretFromLayout;
      var _this$caretManager = this.caretManager,
        caretLineBox = _this$caretManager.caretLineBox,
        caretBox = _this$caretManager.caretBox;
      var needStopCaretUpdate = this.dealSoftEnter(isCaretFromLayout);
      if (needStopCaretUpdate) {
        return;
      }
      // 无论是否显示光标，也需要更新正确的位置
      var color = this.getCaretColor(caretBox.textStyle);
      this.caret.update(x, y, width, height, color);
      (_b = this.caretDragger) === null || _b === void 0 ? void 0 : _b.update(x, y, width, height, caretLineBox);
      if (this.isSelectionCollapsed && (needFocus || this.isHiddenInputFocus || this.isKeepCaretShow) && !this.isKeepCaretHide) {
        // 只有在需要手动触发 focus 或者当前输入框就在 focus 状态时再显示光标
        this.caret.show();
      } else {
        // 有选区时不显示光标
        this.caret.hide();
        (_c = this.caretDragger) === null || _c === void 0 ? void 0 : _c.hide();
      }
      // 输入框放在下面，避免中文输入的时候挡住文字
      this.hiddenEditor.show(x, y + height, needFocus, this.preventScrollOnFocus);
    }
    /**
     * 处理软回车附近的光标逻辑，满足以下条件需要重新计算光标位置
     * 1. 当前光标位置不是由排版层计算的，因为排版层已经处理过软回车，所以光标位置是正确的
     * 2. 当前位置已经处理过了
     * 3. 当前光标在当前行的末尾
     * 4. 当前光标在软回车字符后面
     * @param isCaretFromLayout 表示当前光标位置是否是由排版层计算的
     * @returns 表示是否停止当前的光标位置更新逻辑
     */
  }, {
    key: "dealSoftEnter",
    value: function dealSoftEnter(isCaretFromLayout) {
      var _a;
      if (!isCaretFromLayout && !SoftEnterFlag.isHandledFlag && ((_a = this.caretManager) === null || _a === void 0 ? void 0 : _a.isCaretInLineEnd()) && this.selectionHandler.isAfterSoftEnter()) {
        // 满足以上条件的话，需要把光标移动到下一行的开始位置
        var point = this.caretManager.moveToNextLineStart();
        if (!point) {
          return false;
        }
        // 如果下一行的开始位置和当前位置的 point 一致，重新更新下光标位置即可
        // 因为在上面 moveToNextLineStart 逻辑中已经调用了排版层计算了正确的 caretBox 和光标位置
        if (Point.equals(point, this.selection.anchor)) {
          this.updateCaretAndHiddenEditor();
        } else {
          // 添加标记，避免同一个换行符重复计算导致位置出错
          SoftEnterFlag.setFlag();
          this.editor.model.setSelectionPoints(point, point);
        }
        return true;
      }
      return false;
    }
    /**
     * 更新 surfaceDom 的 transform
     * 保证 surfaceDom 的 matrix 和当前编辑器一致，然后应用上编辑器的文字偏移
     * 这样 surfaceDom 内部的元素就只需要考虑相对于当前编辑器的位置偏移即可
     */
  }, {
    key: "updateSurfaceMatrix",
    value: function updateSurfaceMatrix() {
      var _a, _b, _c;
      var matrix = (_a = this.editor) === null || _a === void 0 ? void 0 : _a.matrix;
      if (matrix) {
        // 编辑器的偏移量
        var _ref2 = ((_b = this.editor) === null || _b === void 0 ? void 0 : _b.blockRect) || {},
          _ref2$x = _ref2.x,
          x = _ref2$x === void 0 ? 0 : _ref2$x,
          _ref2$y = _ref2.y,
          y = _ref2$y === void 0 ? 0 : _ref2$y;
        // 当前编辑器和 transform 上下文之间的缩放
        var scale = ((_c = this.editor) === null || _c === void 0 ? void 0 : _c.scale) || 1;
        // 编辑器的偏移是相对于 transform 上下文的，所以在 transform 计算时需要考虑到 scale
        var offsetMatrix = new Matrix().translate(x / scale, y / scale);
        // 先应用上当前编辑器的 matrix，再应用上编辑器本身文字的偏移
        var finalMatrix = matrix.append(offsetMatrix);
        var a = finalMatrix.a,
          b = finalMatrix.b,
          c = finalMatrix.c,
          d = finalMatrix.d,
          tx = finalMatrix.tx,
          ty = finalMatrix.ty;
        this.surfaceDom.style.transform = "matrix(".concat(a, ", ").concat(b, ", ").concat(c, ", ").concat(d, ", ").concat(tx, ", ").concat(ty, ")");
      }
    }
    /**
     * 获取光标颜色
     * 移动端光标跟随原生逻辑，固定显示为蓝色
     * pc端光标颜色使用最终文字渲染时候的颜色
     * @param textStyle
     * @returns
     */
  }, {
    key: "getCaretColor",
    value: function getCaretColor(textStyle) {
      return (textStyle === null || textStyle === void 0 ? void 0 : textStyle.getRenderColor()) || textStyle.textColor;
    }
    /**
     * attach编辑组件
     */
  }, {
    key: "attachEditingComponent",
    value: function attachEditingComponent() {
      var surfaceDom = document.createElement('div');
      surfaceDom.className = 'extended-components';
      surfaceDom.style.cssText = 'position: absolute; left: 0; top: 0; z-index: 2;';
      this.surfaceDom = surfaceDom;
      this.attachCaret();
      this.attachHiddenEditor();
      this.attachSelectionOverlay();
      this.attachCaretDragger();
    }
    /**
     * 更新编辑模块挂载的节点
     * @param container
     * @returns
     */
  }, {
    key: "updateSurfaceContainer",
    value: function updateSurfaceContainer(container) {
      if (container === this.surfaceContainer) {
        return;
      }
      // 从原来位置移除
      if (this.surfaceDom.parentElement) {
        this.surfaceDom.parentElement.removeChild(this.surfaceDom);
      }
      // 添加到新位置
      if (container) {
        container.appendChild(this.surfaceDom);
      }
      this.surfaceContainer = container;
    }
    /**
     * 隐藏编辑模块元素，在 editor 失焦之后调用，类似于卸载逻辑
     * 正常来说，当前 editor 失焦时应该移除 surfaceDom（包含光标和输入框等），在另一个 editor 聚焦时添加上
     * 不过由于目前大部分 editor 都在同一个容器，在同一个容器中频繁得卸载装载 surfaceDom 有点没必要，所以现在是使用重置逻辑
     */
  }, {
    key: "hideSurfaceDom",
    value: function hideSurfaceDom() {
      var _a;
      this.hiddenEditor.hide();
      this.caret.hideAndReset();
      (_a = this.caretDragger) === null || _a === void 0 ? void 0 : _a.hide();
    }
  }, {
    key: "attachCaret",
    value: function attachCaret() {
      this.caret = new Caret();
      this.caret.attach(this.surfaceDom);
    }
  }, {
    key: "attachSelectionOverlay",
    value: function attachSelectionOverlay() {
      var _a;
      this.selectionOverlay = createSelectionOverlay(Editor.platform);
      (_a = this.selectionOverlay) === null || _a === void 0 ? void 0 : _a.attachControlBar(this.surfaceDom);
    }
  }, {
    key: "attachCaretDragger",
    value: function attachCaretDragger() {
      var _a;
      this.caretDragger = createCaretDragger(Editor.platform);
      (_a = this.caretDragger) === null || _a === void 0 ? void 0 : _a.attach(this.surfaceDom);
    }
    /**
     * 输入框失去焦点时隐藏光标
     * 输入框失去焦点时仍然保留选区，可以对选区做操作，只是不能输入
     */
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      var _a, _b;
      if (!this.isKeepCaretShow) {
        this.caret.hide();
      }
      (_a = this.caretDragger) === null || _a === void 0 ? void 0 : _a.hide();
      this.isHiddenInputFocus = false;
      (_b = this.editor) === null || _b === void 0 ? void 0 : _b.handleInputBlur();
    }
    /**
     * 输入框获取焦点时显示光标
     */
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      if (this.readonly) {
        return;
      }
      // 如果当前没有正在编辑的 editor，那么就不应该显示光标了，同时需要隐藏该输入框
      // 有一些外部因素可能导致隐藏输入框获取到焦点
      if (!this.editor) {
        this.hiddenEditor.hide();
        return;
      }
      this.isHiddenInputFocus = true;
      if (this.isSelectionCollapsed && !this.isKeepCaretHide) {
        this.caret.show();
      }
    }
  }, {
    key: "attachHiddenEditor",
    value: function attachHiddenEditor() {
      var _this2 = this;
      this.hiddenEditor = createHiddenEditor(Editor.platform, {
        onTypeText: function onTypeText(text) {
          var _a;
          (_a = _this2.editor) === null || _a === void 0 ? void 0 : _a.insertText(text);
        },
        onBlur: function onBlur() {
          _this2.handleBlur();
        },
        onFocus: function onFocus() {
          _this2.handleFocus();
        },
        onCompositionStart: function onCompositionStart() {
          var _a;
          (_a = _this2.editor) === null || _a === void 0 ? void 0 : _a.handleCompositionStart();
        },
        onCompositionEnd: function onCompositionEnd(text) {
          var _a;
          (_a = _this2.editor) === null || _a === void 0 ? void 0 : _a.handleCompositionEnd(text);
        },
        onCompositionText: function onCompositionText(text) {
          var _a;
          (_a = _this2.editor) === null || _a === void 0 ? void 0 : _a.changeCompositionText(text);
        },
        onKeyDown: function onKeyDown(event) {
          var _a, _b;
          var needBlockDefaultKeyDown = (_b = (_a = _this2.editor) === null || _a === void 0 ? void 0 : _a.handleKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, event);
          if (needBlockDefaultKeyDown) {
            return;
          }
          _this2.handleHotKeys(event);
        },
        onCopy: function onCopy(event) {
          var _a;
          (_a = _this2.editor) === null || _a === void 0 ? void 0 : _a.handleCopy(event);
        },
        onPaste: function onPaste(event) {
          var _a;
          (_a = _this2.editor) === null || _a === void 0 ? void 0 : _a.handlePaste(event);
        },
        onCut: function onCut(event) {
          var _a;
          (_a = _this2.editor) === null || _a === void 0 ? void 0 : _a.handleCut(event);
        },
        deleteCharacterBack: function deleteCharacterBack(length) {
          var _a;
          (_a = _this2.editor) === null || _a === void 0 ? void 0 : _a.deleteCharacterBack(length);
        },
        clearCompositionState: function clearCompositionState() {
          var _a;
          (_a = _this2.editor) === null || _a === void 0 ? void 0 : _a.clearCompositionState();
        }
      });
      this.hiddenEditor.attach(this.surfaceDom);
    }
    // eslint-disable-next-line complexity
  }, {
    key: "handleHotKeys",
    value: function handleHotKeys(event) {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      if (!this.selectionHandler) {
        return;
      }
      // ----- 上下左右 -----
      if (Hotkeys.isMoveBackward(event, (_a = this.editor) === null || _a === void 0 ? void 0 : _a.coordinate, (_b = this.editor) === null || _b === void 0 ? void 0 : _b.lineExpandDirection)) {
        event.preventDefault();
        this.selectionHandler.moveBackward();
        return;
      }
      if (Hotkeys.isMoveForward(event, (_c = this.editor) === null || _c === void 0 ? void 0 : _c.coordinate, (_d = this.editor) === null || _d === void 0 ? void 0 : _d.lineExpandDirection)) {
        event.preventDefault();
        this.selectionHandler.moveForward();
        return;
      }
      if (Hotkeys.isMoveLineBackward(event, (_e = this.editor) === null || _e === void 0 ? void 0 : _e.coordinate, (_f = this.editor) === null || _f === void 0 ? void 0 : _f.lineExpandDirection)) {
        event.preventDefault();
        this.selectionHandler.moveLineBackward();
        return;
      }
      if (Hotkeys.isMoveLineForward(event, (_g = this.editor) === null || _g === void 0 ? void 0 : _g.coordinate, (_h = this.editor) === null || _h === void 0 ? void 0 : _h.lineExpandDirection)) {
        event.preventDefault();
        this.selectionHandler.moveLineForward();
        return;
      }
      // 向左扩张
      if (Hotkeys.isExtendBackward(event)) {
        event.preventDefault();
        this.selectionHandler.extendBackward();
        return;
      }
      // 向右扩张
      if (Hotkeys.isExtendForward(event)) {
        event.preventDefault();
        this.selectionHandler.extendForward();
        return;
      }
      // 向上扩张
      if (Hotkeys.isExtendLineBackward(event)) {
        event.preventDefault();
        this.selectionHandler.extendLineBackward();
        return;
      }
      // 向下扩张
      if (Hotkeys.isExtendLineForward(event)) {
        event.preventDefault();
        this.selectionHandler.extendLineForward();
        return;
      }
      // 向左移动一个单词
      if (Hotkeys.isMoveWordBackward(event)) {
        event.preventDefault();
        this.selectionHandler.moveWordBackward();
        return;
      }
      // 向右移动一个单词
      if (Hotkeys.isMoveWordForward(event)) {
        event.preventDefault();
        this.selectionHandler.moveWordForward();
        return;
      }
      // 移动到行首
      if (Hotkeys.isMoveToLineStart(event)) {
        event.preventDefault();
        this.selectionHandler.moveToLineStart();
        return;
      }
      // 移动到行尾
      if (Hotkeys.isMoveToLineEnd(event)) {
        event.preventDefault();
        this.selectionHandler.moveToLineEnd();
        return;
      }
      // 移动到段首
      if (Hotkeys.isMoveToParagraphStart(event)) {
        event.preventDefault();
        this.selectionHandler.moveToParagraphStart();
        return;
      }
      // 移动到段尾
      if (Hotkeys.isMoveToParagraphEnd(event)) {
        event.preventDefault();
        this.selectionHandler.moveToParagraphEnd();
        return;
      }
      // 移动到文档开头
      if (Hotkeys.isMoveToDocStart(event)) {
        event.preventDefault();
        this.selectionHandler.moveToDocStart();
        return;
      }
      // 移动到文档结尾
      if (Hotkeys.isMoveToDocEnd(event)) {
        event.preventDefault();
        this.selectionHandler.moveToDocEnd();
        return;
      }
      // 向左选中一个单词
      if (Hotkeys.isExtendWordBackward(event)) {
        event.preventDefault();
        this.selectionHandler.extendWordBackward();
        return;
      }
      // 向右选中一个单词
      if (Hotkeys.isExtendWordForward(event)) {
        event.preventDefault();
        this.selectionHandler.extendWordForward();
        return;
      }
      // 扩张到行首
      if (Hotkeys.isExtendLineStart(event)) {
        event.preventDefault();
        this.selectionHandler.extendToLineStart();
        return;
      }
      // 扩张到行尾
      if (Hotkeys.isExtendLineEnd(event)) {
        event.preventDefault();
        this.selectionHandler.extendToLineEnd();
        return;
      }
      // 扩张到段落开始
      if (Hotkeys.isExtendParagraphStart(event)) {
        event.preventDefault();
        this.selectionHandler.extendToParagraphStart();
        return;
      }
      // 扩张到段落结束
      if (Hotkeys.isExtendParagraphEnd(event)) {
        event.preventDefault();
        this.selectionHandler.extendToParagraphEnd();
        return;
      }
      // 扩张到文档开始
      if (Hotkeys.isExtendDocStart(event)) {
        event.preventDefault();
        this.selectionHandler.extendToDocStart();
        return;
      }
      // 扩张到文档结束
      if (Hotkeys.isExtendDocEnd(event)) {
        event.preventDefault();
        this.selectionHandler.extendToDocEnd();
        return;
      }
      // 回车
      if (Hotkeys.isSplitBlock(event)) {
        event.preventDefault();
        this.selectionHandler.insertBreak();
        return;
      }
      // 软回车
      if (Hotkeys.isInsertSoftBreak(event)) {
        event.preventDefault();
        this.selectionHandler.insertSoftBreak();
        return;
      }
      // 退格
      if (Hotkeys.isDeleteBackward(event)) {
        event.preventDefault();
        this.selectionHandler.deleteBackward();
        return;
      }
      // 向前删除
      if (Hotkeys.isDeleteForward(event)) {
        event.preventDefault();
        this.selectionHandler.deleteForward();
        return;
      }
      // 删除一个单词
      if (Hotkeys.isDeleteWordBackward(event)) {
        event.preventDefault();
        this.selectionHandler.deleteWordBackward();
        return;
      }
      // 向前删除一个单词
      if (Hotkeys.isDeleteWordForward(event)) {
        event.preventDefault();
        this.selectionHandler.deleteWordForward();
        return;
      }
      // 删除到行首
      if (Hotkeys.isDeleteLineBackward(event)) {
        event.preventDefault();
        this.selectionHandler.deleteToLineStart();
        return;
      }
      // 删除到行尾
      if (Hotkeys.isDeleteLineForward(event)) {
        event.preventDefault();
        this.selectionHandler.deleteToLineEnd();
        return;
      }
      if (Hotkeys.isSelectAll(event)) {
        event.preventDefault();
        this.selectionHandler.selectAll();
        return;
      }
      // 撤销重做
      // 需要阻止默认的 undo redo 逻辑，否则会触发隐藏输入框的 input 事件
      if (Hotkeys.isUndo(event)) {
        event.preventDefault();
        return;
      }
      if (Hotkeys.isRedo(event)) {
        event.preventDefault();
        return;
      }
    }
    /**
     * detach编辑组件
     */
  }, {
    key: "detachEditingComponent",
    value: function detachEditingComponent() {}
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new Surface();
      }
      return this.instance;
    }
  }]);
}();
var attachSurface = function attachSurface() {
  var surface = Surface.getInstance();
  surface.attach();
  return surface;
};

/**
 * 管理 slate 文字节点的 path 和排版 box 的映射
 */
var SlatePathToBox = /*#__PURE__*/function () {
  function SlatePathToBox() {
    _classCallCheck(this, SlatePathToBox);
    this.map = new Map();
  }
  return _createClass(SlatePathToBox, [{
    key: "link",
    value: function link(slatePath, box) {
      var _a;
      var slatePathString = slatePath.join('-');
      if (!this.map.get(slatePathString)) {
        this.map.set(slatePathString, [box]);
        return;
      }
      (_a = this.map.get(slatePathString)) === null || _a === void 0 ? void 0 : _a.push(box);
    }
  }, {
    key: "getBox",
    value: function getBox(slatePath) {
      var slatePathString = slatePath.join('-');
      return this.map.get(slatePathString);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
    }
  }]);
}();

var BaseEventManager = /*#__PURE__*/function () {
  function BaseEventManager(_ref) {
    var model = _ref.model,
      getPointByPosition = _ref.getPointByPosition,
      setFocus = _ref.setFocus,
      initSelection = _ref.initSelection;
    _classCallCheck(this, BaseEventManager);
    this.model = model;
    this.getPointByPosition = getPointByPosition;
    this.setFocus = setFocus;
    this.initSelection = initSelection;
  }
  return _createClass(BaseEventManager, [{
    key: "handleDoubleClick",
    value: function handleDoubleClick(point) {
      this.model.selectCurrentWord(point);
    }
  }, {
    key: "handleTripleClick",
    value: function handleTripleClick(point) {
      this.model.selectCurrentParagraph(point);
    }
  }]);
}();

function _callSuper$1(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }
var MouseManager = /*#__PURE__*/function (_BaseEventManager) {
  function MouseManager() {
    var _this;
    _classCallCheck(this, MouseManager);
    _this = _callSuper$1(this, MouseManager, arguments);
    // 触发mousedown时的点，用于判定mousemove时的选区设置是否需要生效
    _this.mouseDownTempPoint = null;
    // eslint-disable-next-line @typescript-eslint/member-ordering
    _this.triggerMouseMove = throttle_1(function (mousePosition) {
      if (!_this.isMouseDown) {
        return;
      }
      // 修改选区范围
      var point = _this.getPointByPosition(mousePosition);
      if (!point) {
        return;
      }
      // 如果存在mouseDownTempPoint暂存点，并且和当前点一致，就不处理。
      if (_this.mouseDownTempPoint && Point.equals(_this.mouseDownTempPoint, point)) {
        return;
      }
      // 如果出现不一致，说明需要修改选区，直接把mouseDownTempPoint暂存点清空，后续move正常判定
      _this.clearMouseDownTempPoint();
      var _this$model$getVoidIn = _this.model.getVoidInfoByPoint(point),
        range = _this$model$getVoidIn.range,
        isInsideVoid = _this$model$getVoidIn.isInsideVoid;
      // 如果鼠标滑到void内，需要选中void元素
      if (isInsideVoid) {
        // 右滑要扩展到void range结尾，左滑要扩展到void range开头
        var isSelectionForward = Point.isAfter(_this.selection.focus, _this.selection.anchor);
        _this.model.setSelectionFocus(isSelectionForward ? range.focus : range.anchor);
      } else {
        _this.model.setSelectionFocus(point);
      }
    }, 30);
    return _this;
  }
  _inherits(MouseManager, _BaseEventManager);
  return _createClass(MouseManager, [{
    key: "selection",
    get: function get() {
      return this.model.selection;
    }
  }, {
    key: "triggerMouseDown",
    value: function triggerMouseDown(mousePosition, event) {
      this.isMouseDown = true;
      this.setFocus(false);
      var point = this.getPointByPosition(mousePosition);
      if (!point) {
        return;
      }
      this.setMouseDownTempPoint(point);
      // 如果传了event，就进行双击、三击的选区逻辑，同时兼容下不传的。
      if (event) {
        // 在一串连续的点击中，每一次点击都会触发mouseDown，event.detail表示是第几次点击
        // 所以只要在对应次数的时候触发对应的逻辑即可。
        // 比如三击的行为："第一下显示光标，第二下选中单词，第三下再选中段落"，
        // 只需要在handleSingleClick，handleDoubleClick和handleTripleClick分别处理各自逻辑
        var clickTimes = event.detail;
        if (clickTimes === 1) {
          this.handleSingleClick(point, event);
        } else if (clickTimes === 2) {
          this.handleDoubleClick(point);
        } else if (clickTimes > 2) {
          this.handleTripleClick(point);
        }
      } else {
        this.handleSingleClick(point);
      }
    }
  }, {
    key: "triggerMouseUp",
    value: function triggerMouseUp() {
      this.isMouseDown = false;
      this.clearMouseDownTempPoint();
      this.cancelMouseMoveThrottle();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.cancelMouseMoveThrottle();
    }
  }, {
    key: "handleSingleClick",
    value: function handleSingleClick(point, event) {
      var _this$model$getVoidIn2 = this.model.getVoidInfoByPoint(point),
        range = _this$model$getVoidIn2.range,
        isInsideVoid = _this$model$getVoidIn2.isInsideVoid;
      // 按现在ppt/dom表现，shiftKey只会在单击的时候响应，并且按shift点击的选区，会被双击、三击的选区替换
      // 所以只需要处理单击的装饰键
      if (event && hasDecoratorKey(event, 'shiftKey') && this.selection) {
        var focus = isInsideVoid ? range.focus : point;
        this.model.setSelectionFocus(focus);
        return;
      }
      if (isInsideVoid) {
        this.initSelection(range.anchor, range.focus);
      } else {
        this.initSelection(point);
      }
    }
  }, {
    key: "setMouseDownTempPoint",
    value: function setMouseDownTempPoint(point) {
      this.mouseDownTempPoint = point;
    }
  }, {
    key: "clearMouseDownTempPoint",
    value: function clearMouseDownTempPoint() {
      this.mouseDownTempPoint = null;
    }
    // 清除节流
  }, {
    key: "cancelMouseMoveThrottle",
    value: function cancelMouseMoveThrottle() {
      this.triggerMouseMove.cancel();
    }
  }]);
}(BaseEventManager);

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var LONG_TOUCH_TIME = 300;
var TouchManager = /*#__PURE__*/function (_BaseEventManager) {
  function TouchManager() {
    var _this;
    _classCallCheck(this, TouchManager);
    _this = _callSuper(this, TouchManager, arguments);
    _this.lastTouchTime = 0;
    _this.touchTimes = 0;
    // 判断是否长按的标志
    _this.isLongTouchFlag = false;
    // 标识是否触发长按
    _this.isLongTouched = false;
    return _this;
  }
  _inherits(TouchManager, _BaseEventManager);
  return _createClass(TouchManager, [{
    key: "triggerTouchStart",
    value: function triggerTouchStart(touchPosition) {
      var _this2 = this;
      this.isLongTouched = false;
      this.touchStartPosition = touchPosition;
      Editor.surface.triggerTouchStart(touchPosition);
      this.longTouch().then(function () {
        _this2.isLongTouched = true;
        Editor.surface.triggerLongTouch(touchPosition);
      })["catch"](function () {});
    }
  }, {
    key: "triggerTouchMove",
    value: function triggerTouchMove(touchPosition) {
      this.stopLongTouch();
      Editor.surface.triggerTouchMove(touchPosition);
    }
  }, {
    key: "triggerTouchEnd",
    value: function triggerTouchEnd(touchPosition) {
      this.stopLongTouch();
      Editor.surface.triggerTouchEnd(touchPosition, this.isLongTouched);
      // 如果触发了长按，就不走更新光标的逻辑
      if (this.isLongTouched) {
        return;
      }
      if (!this.isSamePosition(touchPosition)) {
        return;
      }
      // touchend 时候再进入编辑态
      this.setFocus(false);
      var point = this.getPointByPosition(touchPosition);
      if (!point) {
        return;
      }
      this.handleTouchPoint(point);
      this.touchStartPosition = null;
    }
  }, {
    key: "handleTouchPoint",
    value: function handleTouchPoint(point) {
      var nowTime = Date.now();
      this.touchTimes += 1;
      var isSingleClick = false;
      if (nowTime - this.lastTouchTime < 300) {
        if (this.touchTimes === 2) {
          this.handleDoubleClick(point);
        }
        if (this.touchTimes === 3) {
          this.handleTripleClick(point);
        }
      } else {
        this.handleSingleClick(point);
        isSingleClick = true;
        this.touchTimes = 1;
      }
      this.lastTouchTime = nowTime;
      return isSingleClick;
    }
  }, {
    key: "handleSingleClick",
    value: function handleSingleClick(point) {
      var _this$model$getVoidIn = this.model.getVoidInfoByPoint(point),
        range = _this$model$getVoidIn.range,
        isInsideVoid = _this$model$getVoidIn.isInsideVoid;
      if (isInsideVoid) {
        this.initSelection(range.anchor, range.focus);
      } else {
        this.initSelection(point);
      }
    }
  }, {
    key: "longTouch",
    value: function longTouch() {
      var _this3 = this;
      this.isLongTouchFlag = true;
      clearTimeout(this.longTouchTimer);
      return new Promise(function (resolve, reject) {
        _this3.longTouchTimer = setTimeout(function () {
          if (_this3.isLongTouchFlag) {
            resolve();
          } else {
            reject();
          }
        }, LONG_TOUCH_TIME);
      });
    }
    // 在 touchmove 或 touchend 时取消长按标识
  }, {
    key: "stopLongTouch",
    value: function stopLongTouch() {
      this.isLongTouchFlag = false;
    }
    /**
     * 校验给定的点是否和 touchstart 在同一位置
     * 可接受的坐标偏移为 10
     * @param position
     * @returns
     */
  }, {
    key: "isSamePosition",
    value: function isSamePosition(position) {
      if (!this.touchStartPosition) {
        return false;
      }
      var _this$touchStartPosit = this.touchStartPosition,
        startX = _this$touchStartPosit.posXOfWorld,
        startY = _this$touchStartPosit.posYOfWorld;
      var currentX = position.posXOfWorld,
        currentY = position.posYOfWorld;
      return Math.abs(currentX - startX) <= 10 && Math.abs(currentY - startY) <= 10;
    }
  }]);
}(BaseEventManager);

// 逻辑水平方向对齐方式的基准值
var TextAlignStandard;
(function (TextAlignStandard) {
  // 默认值，根据给定的 rect 尺寸进行对齐
  TextAlignStandard["normal"] = "normal";
  // 根据当前文档逻辑水平方向的最大尺寸进行对齐
  TextAlignStandard["maxContentSize"] = "maxContentSize";
})(TextAlignStandard || (TextAlignStandard = {}));

var EditorView = /*#__PURE__*/function () {
  function EditorView(option) {
    _classCallCheck(this, EditorView);
    var rect = option.rect,
      getMatrix = option.getMatrix,
      getScale = option.getScale,
      getAppPosition = option.getAppPosition,
      getCoordinate = option.getCoordinate;
    this.getMatrix = getMatrix;
    this.getScale = getScale;
    this.getAppPosition = getAppPosition;
    this.getCoordinate = getCoordinate;
    this.updateBlockRect(rect);
  }
  return _createClass(EditorView, [{
    key: "matrix",
    get: function get() {
      var _a;
      var matrix = (_a = this.getMatrix) === null || _a === void 0 ? void 0 : _a.call(this);
      if (!matrix) {
        return new Matrix();
      }
      var a = matrix.a,
        b = matrix.b,
        c = matrix.c,
        d = matrix.d,
        tx = matrix.tx,
        ty = matrix.ty;
      return new Matrix(a, b, c, d, tx, ty);
    }
  }, {
    key: "scale",
    get: function get() {
      var _a;
      return ((_a = this.getScale) === null || _a === void 0 ? void 0 : _a.call(this)) || 1;
    }
  }, {
    key: "appPosition",
    get: function get() {
      var _a;
      return ((_a = this.getAppPosition) === null || _a === void 0 ? void 0 : _a.call(this)) || {
        x: 0,
        y: 0
      };
    }
  }, {
    key: "coordinate",
    get: function get() {
      return this.getCoordinate();
    }
  }, {
    key: "minSize",
    get: function get() {
      return this.originRect.minSize || 0;
    }
  }, {
    key: "maxSize",
    get: function get() {
      return this.originRect.maxSize;
    }
    /**
     * 获取逻辑水平方向对齐方式的基准值
     * 文字横排：没有设置 width 时，宽度由内容撑开，换行由 maxSize 决定，水平方向对齐是根据内容最大尺寸决定
     * 文字竖排同理
     * 此处行为类似于 dom 中 display 为 inline-block 时，不设置 width，设置 min-width 和 max-width 之后的表现
     */
  }, {
    key: "textAlignStandard",
    get: function get() {
      var _this$originRect = this.originRect,
        width = _this$originRect.width,
        height = _this$originRect.height,
        maxSize = _this$originRect.maxSize;
      if (this.isNumber(maxSize)) {
        if (this.coordinate === CoordinateZero.LEFT_TOP && !this.isNumber(width)) {
          return TextAlignStandard.maxContentSize;
        }
        if (this.coordinate !== CoordinateZero.LEFT_TOP && !this.isNumber(height)) {
          return TextAlignStandard.maxContentSize;
        }
      }
      return TextAlignStandard.normal;
    }
    // 更新当前绘制区域
  }, {
    key: "updateBlockRect",
    value: function updateBlockRect(rect) {
      this.originRect = Object.assign({}, rect);
      this.blockRect = this.createBlockRect(rect);
    }
  }, {
    key: "isPositionChange",
    value: function isPositionChange(rect) {
      var _this$blockRect = this.blockRect,
        oldX = _this$blockRect.x,
        oldY = _this$blockRect.y;
      var x = rect.x,
        y = rect.y;
      return x !== oldX || y !== oldY;
    }
  }, {
    key: "isSizeChange",
    value: function isSizeChange(rect) {
      var _this$originRect2 = this.originRect,
        oldWidth = _this$originRect2.width,
        oldHeight = _this$originRect2.height,
        oldMaxSize = _this$originRect2.maxSize,
        oldMinSize = _this$originRect2.minSize;
      var width = rect.width,
        height = rect.height,
        maxSize = rect.maxSize,
        minSize = rect.minSize;
      return width !== oldWidth || height !== oldHeight || maxSize !== oldMaxSize || minSize !== oldMinSize;
    }
    /**
     * 合法化传入的 size，保证在 min 和 max 之间
     * @param size
     * @returns
     */
  }, {
    key: "legalizeSize",
    value: function legalizeSize(size) {
      var minSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.minSize;
      var maxSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.maxSize;
      if (this.isNumber(minSize) && size < minSize) {
        return minSize;
      }
      if (this.isNumber(maxSize) && size > maxSize) {
        return maxSize;
      }
      return size;
    }
    /**
     * 根据传入的 rect 生成最终的 blockRect
     * 其中会根据 minSize maxSize 计算出最终的 width 和 height
     */
  }, {
    key: "createBlockRect",
    value: function createBlockRect(rect) {
      var coordinate = this.coordinate;
      if (!this.isNumber(rect.maxSize)) {
        // 没有设置 maxSize minSize，按照类型约束，width height 一定存在
        var _x = rect.x,
          _y = rect.y,
          _width = rect.width,
          _height = rect.height;
        return {
          x: _x,
          y: _y,
          width: _width,
          height: _height
        };
      }
      // 设置了 maxSize minSize
      var x = rect.x,
        y = rect.y,
        width = rect.width,
        height = rect.height,
        minSize = rect.minSize,
        maxSize = rect.maxSize;
      if (coordinate === CoordinateZero.LEFT_TOP) {
        // 横排文字，minSize maxSize 用于限定 width
        var realWidth;
        if (this.isNumber(width)) {
          // 设置了 width，根据 minSize 和 maxSize 合法化 width
          realWidth = this.legalizeSize(width, minSize, maxSize);
        } else {
          // 没设置 width，width 应该是由内容撑开，这里把 width 设置为 maxSize 是用于决定在什么位置换行
          // 这种情况下文字换行时用 maxSize 决定，但是对齐是根据最大内容尺寸对齐
          realWidth = maxSize;
        }
        return {
          x: x,
          y: y,
          width: realWidth,
          // 根据类型约束，此时 height 一定存在，只不过不清楚是不是写法有问题，这里 ts 推断不出 height 的真正类型，所以需要用 as
          height: height
        };
      }
      // 竖排文字，minSize maxSize 用于限定 height
      var realHeight;
      if (this.isNumber(height)) {
        // 设置了 height
        realHeight = this.legalizeSize(height, minSize, maxSize);
      } else {
        // 没设置 height，height 应该是由内容撑开，这里把 height 设置为 maxSize 是用于决定在什么位置换行
        // 这种情况下文字换行时用 maxSize 决定，但是对齐是根据最大内容尺寸对齐
        realHeight = maxSize;
      }
      return {
        x: x,
        y: y,
        // 根据类型约束，此时 width 一定存在，只不过不清楚是不是写法有问题，这里 ts 推断不出 width 的真正类型，所以需要用 as
        width: width,
        height: realHeight
      };
    }
  }, {
    key: "isNumber",
    value: function isNumber(param) {
      return typeof param === 'number';
    }
  }]);
}();

// document中和排版相关的属性
var DOCUMENT_PROPS_RELATED_TO_LAYOUT = ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'vertical', 'anchor', 'whiteSpaceType'];
var DEFAULT_DOCUMENT_ELEMENT = {
  type: '',
  children: [],
  paddingLeft: 0,
  paddingRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
  vertical: undefined,
  anchor: AnchorType.Top,
  whiteSpaceType: WhiteSpaceType.Normal,
  anchorCenter: false,
  docSizeType: undefined,
  columnNumber: 1,
  columnSpace: 0,
  handingChar4OneLine: false,
  handingMaxSpace: -1,
  // 默认值和现网表现一致，即不计算尾部空格
  tailWhitespaceCalculation: TailWhitespaceCalculation.Exclude
};
// 段落中和排版相关的属性
var PARAGRAPH_PROPS_RELATED_TO_LAYOUT = ['characterProps', 'textIndent', 'marginLeft', 'spaceBefore', 'spaceAfter', 'textAlign', 'lineSpacing', 'lineSpacingRule', 'defaultTabSize', 'tabList'];
// 文字中和排版相关的属性
var TEXT_PROPS_RELATED_TO_LAYOUT = ['fontSize', 'fontFamily', 'letterSpacing', 'fontWeight'];

var _hasSingleChildNest = function hasSingleChildNest(editor, node) {
  if (Element.isElement(node)) {
    var element = node;
    if (Editor$1.isVoid(editor, node)) {
      return true;
    }
    if (element.children.length === 1) {
      return _hasSingleChildNest(editor, element.children[0]);
    }
    return false;
  }
  if (Editor$1.isEditor(node)) {
    return false;
  }
  return true;
};
/**
 * 生成新的 mergeNodes 函数，在 slate 原有 mergeNode 的实现中，多加了一个逻辑，具体见下面注释
 * 后续 slate 修复这个问题后，这部分逻辑可以删除
 * @param editor
 * @returns
 */
function createMergeNode(editor) {
  var newMergeNodes = function newMergeNodes() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // eslint-disable-next-line complexity
    Editor$1.withoutNormalizing(editor, function () {
      var match = options.match,
        _options$at = options.at,
        at = _options$at === void 0 ? editor.selection : _options$at;
      var _options$hanging = options.hanging,
        hanging = _options$hanging === void 0 ? false : _options$hanging,
        _options$voids = options.voids,
        voids = _options$voids === void 0 ? false : _options$voids,
        _options$mode = options.mode,
        mode = _options$mode === void 0 ? 'lowest' : _options$mode;
      if (!at) {
        return;
      }
      if (match == null) {
        if (Path.isPath(at)) {
          var _Editor$parent = Editor$1.parent(editor, at),
            _Editor$parent2 = _slicedToArray(_Editor$parent, 1),
            parent = _Editor$parent2[0];
          match = function match(n) {
            return parent.children.includes(n);
          };
        } else {
          match = function match(n) {
            return Element.isElement(n) && Editor$1.isBlock(editor, n);
          };
        }
      }
      if (!hanging && Range.isRange(at)) {
        at = Editor$1.unhangRange(editor, at, {
          voids: voids
        });
      }
      if (Range.isRange(at)) {
        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var _Range$edges = Range.edges(at),
            _Range$edges2 = _slicedToArray(_Range$edges, 2),
            end = _Range$edges2[1];
          var pointRef = Editor$1.pointRef(editor, end);
          Transforms["delete"](editor, {
            at: at
          });
          at = pointRef.unref();
          if (options.at == null) {
            Transforms.select(editor, at);
          }
        }
      }
      var _Editor$nodes = Editor$1.nodes(editor, {
          at: at,
          match: match,
          voids: voids,
          mode: mode
        }),
        _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
        current = _Editor$nodes2[0];
      var prev = Editor$1.previous(editor, {
        at: at,
        match: match,
        voids: voids,
        mode: mode
      });
      if (!current || !prev) {
        return;
      }
      var _current = _slicedToArray(current, 2),
        node = _current[0],
        path = _current[1];
      var _prev = _slicedToArray(prev, 2),
        prevNode = _prev[0],
        prevPath = _prev[1];
      if (path.length === 0 || prevPath.length === 0) {
        return;
      }
      var newPath = Path.next(prevPath);
      var commonPath = Path.common(path, prevPath);
      var isPreviousSibling = Path.isSibling(path, prevPath);
      var levels = Array.from(Editor$1.levels(editor, {
        at: path
      }), function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          n = _ref2[0];
        return n;
      }).slice(commonPath.length).slice(0, -1);
      // Determine if the merge will leave an ancestor of the path empty as a
      // result, in which case we'll want to remove it after merging.
      var emptyAncestor = Editor$1.above(editor, {
        at: path,
        mode: 'highest',
        match: function match(n) {
          return levels.includes(n) && _hasSingleChildNest(editor, n);
        }
      });
      var emptyRef = emptyAncestor && Editor$1.pathRef(editor, emptyAncestor[1]);
      var properties;
      var position;
      // Ensure that the nodes are equivalent, and figure out what the position
      // and extra properties of the merge will be.
      if (Text.isText(node) && Text.isText(prevNode)) {
        node.text;
          var rest = __rest(node, ["text"]);
        position = prevNode.text.length;
        properties = rest;
      } else if (Element.isElement(node) && Element.isElement(prevNode)) {
        node.children;
          var _rest = __rest(node, ["children"]);
        position = prevNode.children.length;
        properties = _rest;
      } else {
        throw new Error("Cannot merge the node at path [".concat(path, "] with the previous sibling because it is not the same kind: ").concat(Scrubber.stringify(node), " ").concat(Scrubber.stringify(prevNode)));
      }
      // If the node isn't already the next sibling of the previous node, move
      // it so that it is before merging.
      if (!isPreviousSibling) {
        Transforms.moveNodes(editor, {
          at: path,
          to: newPath,
          voids: voids
        });
      }
      // If there was going to be an empty ancestor of the node that was merged,
      // we remove it from the tree.
      if (emptyRef) {
        Transforms.removeNodes(editor, {
          at: emptyRef.current,
          voids: voids
        });
      }
      // If the target node that we're merging with is empty, remove it instead
      // of merging the two. This is a common rich text editor behavior to
      // prevent losing formatting when deleting entire nodes when you have a
      // hanging selection.
      // if prevNode is first child in parent,don't remove it.
      if (Element.isElement(prevNode) && Editor$1.isEmpty(editor, prevNode) || Text.isText(prevNode) && prevNode.text === '' && prevPath[prevPath.length - 1] !== 0) {
        // 如果要 merge 的节点本身是空的，那么就删除当前节点
        // https://tapd.woa.com/10143861/bugtrace/bugs/view/1010143861113432393
        // https://github.com/ianstormtaylor/slate/issues/4810
        if (Element.isElement(node) && Editor$1.isEmpty(editor, node)) {
          Transforms.removeNodes(editor, {
            at: path,
            voids: voids
          });
        } else {
          Transforms.removeNodes(editor, {
            at: prevPath,
            voids: voids
          });
        }
      } else {
        editor.apply({
          type: 'merge_node',
          path: newPath,
          position: position,
          properties: properties
        });
      }
      if (emptyRef) {
        emptyRef.unref();
      }
    });
  };
  return newMergeNodes;
}

var propsRelatedToLayout = [].concat(_toConsumableArray(PARAGRAPH_PROPS_RELATED_TO_LAYOUT), _toConsumableArray(TEXT_PROPS_RELATED_TO_LAYOUT));
/**
 * 校验当前 op 之后是否需要重新排版
 * @param op
 * @returns
 */
function checkIfNeedReLayout(op) {
  var type = op.type;
  if (['set_selection', 'merge_node', 'split_node'].includes(type)) {
    return false;
  }
  if (type === 'set_node') {
    var newProperties = op.newProperties;
    return Object.keys(newProperties).some(function (key) {
      return propsRelatedToLayout.includes(key);
    });
  }
  return true;
}

// 记录 editor 的刷新状态
var FLUSHING = new WeakMap();
// 配合判断刷新状态，用于合并多次 onBeforeChange
var FLUSHING_BEFORE_CHANGE = new WeakMap();
var withAlloy = function withAlloy(editor) {
  var alloyEditor = editor;
  // 添加默认值
  alloyEditor.isChangeValue = false;
  alloyEditor.isNeedReLayout = false;
  alloyEditor.onBeforeChange = function () {};
  var apply = alloyEditor.apply,
    deleteFragment = alloyEditor.deleteFragment,
    mergeNodes = alloyEditor.mergeNodes;
  alloyEditor.apply = function (op) {
    if (op.type !== 'set_selection') {
      alloyEditor.isChangeValue = true;
    }
    if (!FLUSHING_BEFORE_CHANGE.get(alloyEditor)) {
      FLUSHING_BEFORE_CHANGE.set(alloyEditor, true);
      alloyEditor.onBeforeChange();
      Promise.resolve().then(function () {
        FLUSHING_BEFORE_CHANGE.set(alloyEditor, false);
      });
    }
    apply(op);
    if (checkIfNeedReLayout(op)) {
      alloyEditor.isNeedReLayout = true;
    }
    // 同一批次的更新只触发一次
    if (!FLUSHING.get(alloyEditor)) {
      FLUSHING.set(alloyEditor, true);
      Promise.resolve().then(function () {
        FLUSHING.set(alloyEditor, false);
        // 清空当前 onchange 的一些状态，这里会在 onchange 之后执行
        alloyEditor.isNeedReLayout = false;
        alloyEditor.isChangeValue = false;
      });
    }
  };
  alloyEditor.isSelectAll = function () {
    var selection = alloyEditor.selection;
    if (!selection) {
      return false;
    }
    var startPoint = alloyEditor.getStartPoint();
    var endPoint = alloyEditor.getEndPoint();
    return Range.includes(selection, startPoint) && Range.includes(selection, endPoint);
  };
  alloyEditor.selectAll = function () {
    var startPoint = alloyEditor.getStartPoint();
    var endPoint = alloyEditor.getEndPoint();
    var selection = {
      anchor: startPoint,
      focus: endPoint
    };
    Transforms.select(alloyEditor, selection);
  };
  alloyEditor.getStartPoint = function () {
    return Editor$1.start(alloyEditor, []);
  };
  alloyEditor.getEndPoint = function () {
    return Editor$1.end(alloyEditor, []);
  };
  alloyEditor.selectStart = function () {
    var startPoint = alloyEditor.getStartPoint();
    var selection = {
      anchor: startPoint,
      focus: startPoint
    };
    Transforms.select(alloyEditor, selection);
  };
  alloyEditor.selectEnd = function () {
    var endPoint = alloyEditor.getEndPoint();
    var selection = {
      anchor: endPoint,
      focus: endPoint
    };
    Transforms.select(alloyEditor, selection);
  };
  /**
   * 判断给定的两个点在当前 editor 中是否指向同一个位置
   * 比如两个节点中间的位置可以用前一个节点表示，也可以用后一个节点表示，二者表示同一个位置
   * @param point
   * @param another
   * @returns
   */
  alloyEditor.isSamePoint = function (point, another) {
    var isEquals = Point.equals(point, another);
    if (isEquals) {
      return true;
    }
    // 如果两个点不相等，则只有其中一个在前一个节点的末尾且另一个在后一个节点的开始位置时，二者才表示同一个位置
    if (point.offset === 0) {
      var normalizedPoint = alloyEditor.normalizePoint(point);
      return Point.equals(normalizedPoint, another);
    }
    if (another.offset === 0) {
      var _normalizedPoint = alloyEditor.normalizePoint(another);
      return Point.equals(point, _normalizedPoint);
    }
    return false;
  };
  /**
   * 判断给定的 range 是否是折叠的（也就是类似光标）
   * 和 Range.isCollapsed 不同的地方在于，Range.isCollapsed 只判断两个 point 是否完全一致
   * 而不一样的两个 point 也可以表示同一个位置
   * @param range
   * @returns
   */
  alloyEditor.isRangeCollapsed = function (range) {
    var anchor = range.anchor,
      focus = range.focus;
    return alloyEditor.isSamePoint(anchor, focus);
  };
  alloyEditor.isRangeExpanded = function (range) {
    return !alloyEditor.isRangeCollapsed(range);
  };
  /**
   * 这里主要是统一一个逻辑，即如果 point 在两个文本节点之间的话，保证 point 使用左侧的节点定位
   * @param point
   * @returns
   */
  alloyEditor.normalizePoint = function (point) {
    if (point.offset > 0) {
      return point;
    }
    var beforePoint = Editor$1.before(alloyEditor, point, {
      distance: 1,
      unit: 'character'
    });
    if (!beforePoint) {
      return point;
    }
    return Editor$1.after(alloyEditor, beforePoint, {
      distance: 1,
      unit: 'character'
    });
  };
  /**
   * 获取给定位置的前一个字符
   * @param point
   */
  alloyEditor.getPrevCharacter = function (point) {
    var prevPoint = Editor$1.before(alloyEditor, point, {
      distance: 1,
      unit: 'character'
    });
    if (!prevPoint) {
      return '';
    }
    var range = {
      anchor: prevPoint,
      focus: point
    };
    return Editor$1.string(alloyEditor, range);
  };
  /**
   * 获取给定位置的上一个单词边界，其实就是找到上一个非英文数字的位置
   * @param point
   */
  alloyEditor.getPrevWordPoint = function (point) {
    if (!point) {
      return null;
    }
    var prevPoint = Editor$1.before(alloyEditor, point, {
      distance: 1,
      unit: 'character'
    });
    if (!prevPoint) {
      return null;
    }
    var prevCharacter = Editor$1.string(alloyEditor, {
      anchor: prevPoint,
      focus: point
    });
    if (prevCharacter.length > 1) {
      // 多字素文本，直接返回
      return prevPoint;
    }
    if (!isAlphabetOrNumber(prevCharacter)) {
      // 非英文数字，直接返回
      return prevPoint;
    }
    var currentPoint = prevPoint;
    while (currentPoint) {
      var _prevPoint = Editor$1.before(alloyEditor, currentPoint, {
        distance: 1,
        unit: 'character'
      });
      if (_prevPoint) {
        var _alloyEditor$getVoidI = alloyEditor.getVoidInfoByPoint(_prevPoint),
          isInsideVoid = _alloyEditor$getVoidI.isInsideVoid;
        if (isInsideVoid) return currentPoint;
      }
      var _prevCharacter = alloyEditor.getPrevCharacter(currentPoint);
      if (!isAlphabetOrNumber(_prevCharacter)) {
        return currentPoint;
      }
      currentPoint = _prevPoint;
    }
    return null;
  };
  /**
   * 获取给定位置的后一个字符
   * @param point
   */
  alloyEditor.getNextCharacter = function (point) {
    var nextPoint = Editor$1.after(alloyEditor, point, {
      distance: 1,
      unit: 'character'
    });
    if (!nextPoint) {
      return '';
    }
    var range = {
      anchor: nextPoint,
      focus: point
    };
    return Editor$1.string(alloyEditor, range);
  };
  /**
   * 获取给定位置的下一个单词边界，其实就是找到下一个非英文数字的位置
   * @param point
   * @returns
   */
  alloyEditor.getNextWordPoint = function (point) {
    if (!point) {
      return null;
    }
    var nextPoint = Editor$1.after(alloyEditor, point, {
      distance: 1,
      unit: 'character'
    });
    if (!nextPoint) {
      return null;
    }
    var nextCharacter = Editor$1.string(alloyEditor, {
      anchor: nextPoint,
      focus: point
    });
    if (nextCharacter.length > 1) {
      // 多字符文本，直接返回
      return nextPoint;
    }
    if (!isAlphabetOrNumber(nextCharacter)) {
      // 非英文数字，直接返回
      return nextPoint;
    }
    var currentPoint = nextPoint;
    while (currentPoint) {
      var _nextPoint = Editor$1.after(alloyEditor, currentPoint, {
        distance: 1,
        unit: 'character'
      });
      if (_nextPoint) {
        // void边界的优先级非常高。如果下一个点在void内，其实就到了边界，直接返回，不然会出现void外面的字母连着void里面内容的情况
        var _alloyEditor$getVoidI2 = alloyEditor.getVoidInfoByPoint(_nextPoint),
          isInsideVoid = _alloyEditor$getVoidI2.isInsideVoid;
        if (isInsideVoid) return currentPoint;
      }
      var _nextCharacter = alloyEditor.getNextCharacter(currentPoint);
      if (!isAlphabetOrNumber(_nextCharacter)) {
        return currentPoint;
      }
      currentPoint = _nextPoint;
    }
    return null;
  };
  alloyEditor.isVoid = function (element) {
    return !!element["void"];
  };
  alloyEditor.getNodeByPath = function (path) {
    var _a;
    return (_a = Editor$1.node(alloyEditor, path)) === null || _a === void 0 ? void 0 : _a[0];
  };
  /**
   * 根据给定 point 获取 void 相关信息
   */
  alloyEditor.getVoidInfoByPoint = function (point) {
    var path = point.path;
    var node = alloyEditor.getNodeByPath(path);
    var range = Editor$1.range(alloyEditor, path);
    var isPointAtRangeEdge = point.offset === range.focus.offset || point.offset === 0;
    var isVoid = alloyEditor.isVoid(node);
    return {
      isInsideVoid: isVoid && !isPointAtRangeEdge,
      range: range
    };
  };
  /**
   * 批量设置 mark
   * @param textProps
   */
  alloyEditor.addMarks = function (textProps, propsMerge) {
    Object.entries(textProps).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        propsKey = _ref2[0],
        propsValue = _ref2[1];
      var _a;
      var value = propsMerge ? propsMerge(propsKey, (_a = alloyEditor.marks) === null || _a === void 0 ? void 0 : _a[propsKey], propsValue) : propsValue;
      alloyEditor.addMark(propsKey, value);
    });
  };
  /**
   * slate 的 deleteFragment 在某些场景下表现不符合预期
   * 选中两个段落所有文字删除时，会保留后面段落的样式，和 office 表现也不一致
   * 排查了一下是在 deleteFragment 中调用的 mergeNodes 里面的某一个逻辑导致
   * 在 deleteFragment 执行前替换掉原有的 mergeNodes 实现，执行之后再还原，避免影响到其他场景
   * 后续 slate 修复这个问题后，这部分逻辑可以删除
   * @param options
   */
  alloyEditor.deleteFragment = function (options) {
    alloyEditor.mergeNodes = createMergeNode(editor);
    deleteFragment.apply(options);
    alloyEditor.mergeNodes = mergeNodes;
  };
  return alloyEditor;
};

var verticalMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, VerticalType.Vertical, CoordinateZero.RIGHT_TOP), VerticalType.Vertical90, CoordinateZero.RIGHT_TOP), VerticalType.WordArtVerticalRtl, CoordinateZero.RIGHT_TOP), VerticalType.WordArtVerticalLtr, CoordinateZero.LEFT_TOP), VerticalType.Vertical270, CoordinateZero.LEFT_BOTTOM);
/**
 * 根据竖排参数获取当前坐标原点位置
 * @param vertical
 * @returns
 */
function getCoordinateZero(vertical) {
  if (!vertical) {
    return CoordinateZero.LEFT_TOP;
  }
  return verticalMap[vertical] || CoordinateZero.LEFT_TOP;
}
/**
 * 根据竖排参数获取当前行扩张的方向，也就是从第一行到第二行是往哪个方向延伸的
 * @param vertical
 * @returns
 */
function getLineExpandDirection(vertical) {
  if (vertical === VerticalType.WordArtVerticalLtr) {
    return LineExpandDirection.HORIZONTAL;
  }
  return LineExpandDirection.VERTICAL;
}

var RangeUtils = /*#__PURE__*/function () {
  function RangeUtils(slate) {
    _classCallCheck(this, RangeUtils);
    this.slate = slate;
  }
  return _createClass(RangeUtils, [{
    key: "convertToParagraph",
    value: function convertToParagraph(range) {
      return RangeUtils.convertToParagraph(range, this.slate);
    }
  }, {
    key: "convertToText",
    value: function convertToText(range) {
      return RangeUtils.convertToText(range, this.slate);
    }
  }], [{
    key: "convertToParagraph",
    value:
    /**
     * 把给定的 range 中的 offset 转换为相对于 paragraph 进行定位
     * @param range
     * @param slate
     * @returns
     */
    function convertToParagraph(range, slate) {
      if (!range) {
        return range;
      }
      var anchor = range.anchor,
        focus = range.focus;
      return {
        anchor: this.convertPointToParagraph(anchor, slate),
        focus: this.convertPointToParagraph(focus, slate)
      };
    }
    /**
     * 把给定的相对于 paragraph 定位的 range 转换为相对于 text 节点定位
     * @param range
     * @param slate
     */
  }, {
    key: "convertToText",
    value: function convertToText(range, slate) {
      if (!range) {
        return range;
      }
      var anchor = range.anchor,
        focus = range.focus;
      var newAnchor = this.convertPointToText(anchor, slate);
      var newFocus = this.convertPointToText(focus, slate);
      if (newAnchor && newFocus) {
        return {
          anchor: newAnchor,
          focus: newFocus
        };
      }
      if (newAnchor) {
        return {
          anchor: newAnchor,
          focus: newAnchor
        };
      }
      if (newFocus) {
        return {
          anchor: newFocus,
          focus: newFocus
        };
      }
      return null;
    }
    /**
     * 把给定 point 的 offset 转换为相对于 paragraph 表示
     * @param point
     * @param slate
     * @returns
     */
  }, {
    key: "convertPointToParagraph",
    value: function convertPointToParagraph(point, slate) {
      var pointPath = point.path;
      var textElementIdx = pointPath[pointPath.length - 1];
      if (textElementIdx === 0) {
        return point;
      }
      var _SlateEditor$parent = Editor$1.parent(slate, pointPath),
        _SlateEditor$parent2 = _slicedToArray(_SlateEditor$parent, 1),
        paragraphNode = _SlateEditor$parent2[0];
      var prevTextElements = paragraphNode.children.slice(0, pointPath[pointPath.length - 1]);
      var offsetOfParagraph = prevTextElements.reduce(function (offset, textElement) {
        return offset + textElement.text.length || 0;
      }, point.offset);
      return {
        path: pointPath,
        offset: offsetOfParagraph
      };
    }
    /**
     * 把给定 point 的 offset 转换为相对于 text 表示
     * @param point
     * @param slate
     * @returns
     */
  }, {
    key: "convertPointToText",
    value: function convertPointToText(point, slate) {
      try {
        var _SlateEditor$parent3 = Editor$1.parent(slate, point.path),
          _SlateEditor$parent4 = _slicedToArray(_SlateEditor$parent3, 2),
          paragraph = _SlateEditor$parent4[0],
          paragraphPath = _SlateEditor$parent4[1];
        var textElements = paragraph.children;
        var currentOffset = 0;
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < textElements.length; i++) {
          var text = textElements[i].text;
          if (currentOffset + text.length >= point.offset) {
            return {
              path: [].concat(_toConsumableArray(paragraphPath), [i]),
              offset: point.offset - currentOffset
            };
          }
          currentOffset += text.length;
        }
        return Editor$1.end(slate, paragraphPath);
      } catch (err) {
        // 说明当前段落的 path 已经不合法了，可能当前段落已经不在了
        return null;
      }
    }
  }]);
}();

var NoExtendPropType;
(function (NoExtendPropType) {
  NoExtendPropType["PRE"] = "pre";
  NoExtendPropType["AFTER"] = "after";
})(NoExtendPropType || (NoExtendPropType = {}));
var NoExtendPropsHelper = /*#__PURE__*/function () {
  function NoExtendPropsHelper() {
    var noExtendProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, NoExtendPropsHelper);
    // 内部的void类型处理也可以归纳成noExtendProps
    this.noExtendProps = {
      "void": {
        afterNoExtend: true,
        preNoExtend: true
      }
    };
    this.noExtendProps = Object.assign(Object.assign({}, this.noExtendProps), this.normalizeNoExtendProps(noExtendProps));
  }
  /**
   * 过滤掉满足条件的 noExtendProps
   */
  return _createClass(NoExtendPropsHelper, [{
    key: "filterNoExtendProps",
    value: function filterNoExtendProps(originProps, currentPoint, slate) {
      var _this = this;
      var _a, _b;
      if (!originProps) {
        return {
          props: originProps,
          hasFiltered: false
        };
      }
      var _this$isInCurrentNode = this.isInCurrentNodeEdge(slate, currentPoint),
        isStart = _this$isInCurrentNode.isStart,
        isEnd = _this$isInCurrentNode.isEnd;
      // 不在当前节点边缘，那么直接返回
      if (!isStart && !isEnd) {
        return {
          props: originProps,
          hasFiltered: false
        };
      }
      // 在节点边缘
      // 如果 isStart 和 isEnd 都是 true，以 end 为准
      var noExtendType;
      // 根据当前 NoExtendPropType 获取相邻节点
      var adjacentNode;
      if (isEnd) {
        noExtendType = NoExtendPropType.AFTER;
        adjacentNode = (_a = Editor$1.next(slate, {
          at: currentPoint,
          mode: 'lowest'
        })) === null || _a === void 0 ? void 0 : _a[0];
      } else {
        noExtendType = NoExtendPropType.PRE;
        adjacentNode = (_b = Editor$1.previous(slate, {
          at: currentPoint,
          mode: 'lowest'
        })) === null || _b === void 0 ? void 0 : _b[0];
      }
      // 获取可以被继承的属性
      var filteredProps = {};
      var hasFiltered = false;
      Object.keys(originProps).forEach(function (propKey) {
        // 如果当前属性不是不可继承属性，那么可以继承
        if (!_this.isNoExtendProp(propKey, noExtendType)) {
          filteredProps[propKey] = originProps[propKey];
          return;
        }
        // 如果当前属性是不可继承属性，但是当前属性值和相邻节点的对应属性值相同，那么可以继承
        if ((adjacentNode === null || adjacentNode === void 0 ? void 0 : adjacentNode[propKey]) && shallowEquals(adjacentNode === null || adjacentNode === void 0 ? void 0 : adjacentNode[propKey], originProps[propKey])) {
          filteredProps[propKey] = originProps[propKey];
          return;
        }
        // 当前属性是不可继承属性，且当前属性值和相邻节点的对应属性值不同，那么需要过滤掉
        hasFiltered = true;
      });
      return {
        props: filteredProps,
        hasFiltered: hasFiltered
      };
    }
    /**
     * 判断给定的点是否在当前节点边缘
     */
  }, {
    key: "isInCurrentNodeEdge",
    value: function isInCurrentNodeEdge(slate, point) {
      var currentNodeRange = Editor$1.range(slate, point.path);
      // 光标在当前 node 的开头
      var isStart = Point.equals(point, currentNodeRange.anchor);
      // 光标在当前 node 的结尾
      var isEnd = Point.equals(point, currentNodeRange.focus);
      return {
        isStart: isStart,
        isEnd: isEnd
      };
    }
  }, {
    key: "isNoExtendProp",
    value: function isNoExtendProp(propKey, type) {
      var _a;
      var noExtendType = type === NoExtendPropType.PRE ? 'preNoExtend' : 'afterNoExtend';
      return !!((_a = this.noExtendProps[propKey]) === null || _a === void 0 ? void 0 : _a[noExtendType]);
    }
    /**
     * 把业务传入的noExtendProps配置，统一标准化为NoExtendPropsMap
     */
  }, {
    key: "normalizeNoExtendProps",
    value: function normalizeNoExtendProps(noExtendProps) {
      var defaultNoExtendOpt = {
        afterNoExtend: true,
        preNoExtend: false
      };
      return noExtendProps.reduce(function (opt, propOpt) {
        if (typeof propOpt === 'string') {
          return Object.assign(Object.assign({}, opt), _defineProperty({}, propOpt, defaultNoExtendOpt));
        }
        return Object.assign(Object.assign({}, opt), _defineProperty({}, propOpt.prop, {
          afterNoExtend: !!propOpt.afterNoExtend,
          preNoExtend: !!propOpt.preNoExtend
        }));
      }, {});
    }
  }]);
}();

/**
 * 简化版深拷贝函数
 */
function deepClone(obj) {
  var clonedObjs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
  if (_typeof(obj) !== 'object' || obj === null) {
    return obj;
  }
  // 处理循环引用
  if (clonedObjs.has(obj)) {
    return obj;
  }
  clonedObjs.add(obj);
  if (Array.isArray(obj)) {
    var newArr = [];
    obj.forEach(function (item) {
      return newArr.push(deepClone(item, clonedObjs));
    });
    return newArr;
  }
  var newObj = {};
  Object.keys(obj).forEach(function (key) {
    return newObj[key] = deepClone(obj[key], clonedObjs);
  });
  return newObj;
}

function errorCatcher(fn) {
  try {
    return fn();
  } catch (error) {
    return null;
  }
}

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var DefaultSlate = withAlloy(createEditor());
var EditorModel = /*#__PURE__*/function () {
  function EditorModel(option) {
    var _this = this;
    _classCallCheck(this, EditorModel);
    // 上次 compositionUpdate 时输入的文字
    this.lastCompositionText = '';
    // 记录上次 selection
    this.lastSelection = null;
    this.getNodeByPath = function (path) {
      return _this.slate.getNodeByPath(path);
    };
    this.handleSlateChange = function () {
      var _a;
      // 在 editor 有变化时，重置软回车的标记
      SoftEnterFlag.resetFlag();
      (_a = _this.onChange) === null || _a === void 0 ? void 0 : _a.call(_this, _this.slate);
      _this.handleSelection();
    };
    this.handleBeforeSlateChange = function () {
      _this.onBeforeChange(_this.slate);
    };
    /**
     * 插入文字之前的回调
     * @param text
     * @param props 应用在即将插入的文字上的属性
     */
    this.handleBeforeInsertText = function (text, props) {
      var _a;
      // 获取要输入的文字前面的节点
      var _Range$start = Range.start(_this.selection),
        path = _Range$start.path;
      var _SlateEditor$leaf = Editor$1.leaf(_this.slate, path),
        _SlateEditor$leaf2 = _slicedToArray(_SlateEditor$leaf, 1),
        originTextElement = _SlateEditor$leaf2[0];
      // 组装出 textElement，包含即将输入文字应用的属性和当前文字节点的内容
      var textElement = Object.assign(Object.assign({}, originTextElement), props);
      return ((_a = _this.onBeforeInput) === null || _a === void 0 ? void 0 : _a.call(_this, text, textElement)) || null;
    };
    var value = option.value,
      onChange = option.onChange,
      onBeforeChange = option.onBeforeChange,
      onSelectionChange = option.onSelectionChange,
      onBeforeInput = option.onBeforeInput,
      _option$noExtendProps = option.noExtendProps,
      noExtendProps = _option$noExtendProps === void 0 ? [] : _option$noExtendProps;
    this.onChange = onChange;
    this.onBeforeChange = onBeforeChange;
    this.onBeforeInput = onBeforeInput;
    this.onSelectionChange = onSelectionChange;
    this.noExtendPropsHelper = new NoExtendPropsHelper(noExtendProps);
    this.initSlate(value);
  }
  // 获取当前选区
  return _createClass(EditorModel, [{
    key: "selection",
    get: function get() {
      return this.slate.selection;
    }
    /**
     * 当前编辑器的逻辑坐标原点
     */
  }, {
    key: "coordinate",
    get: function get() {
      var _a;
      return getCoordinateZero((_a = this === null || this === void 0 ? void 0 : this.slate) === null || _a === void 0 ? void 0 : _a.vertical);
    }
    /**
     * 当前编辑器行扩张的方向
     */
  }, {
    key: "lineExpandDirection",
    get: function get() {
      var _a;
      return getLineExpandDirection((_a = this === null || this === void 0 ? void 0 : this.slate) === null || _a === void 0 ? void 0 : _a.vertical);
    }
  }, {
    key: "setSelectionFocus",
    value: function setSelectionFocus(point) {
      Transforms.setPoint(this.slate, point, {
        edge: 'focus'
      });
    }
  }, {
    key: "selectEnd",
    value: function selectEnd() {
      this.slate.selectEnd();
    }
  }, {
    key: "setSelection",
    value: function setSelection() {
      var selection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!selection) {
        this.clearSelection();
        return;
      }
      Transforms.select(this.slate, selection);
    }
  }, {
    key: "paste",
    value: function paste() {
      var paragraphs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var keepProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (keepProps) {
        this.pasteWithProps(paragraphs);
      } else {
        this.pasteAsPureText(paragraphs);
      }
    }
  }, {
    key: "copy",
    value: function copy() {
      if (!this.selection) {
        return;
      }
      return this.slate.fragment(this.selection);
    }
  }, {
    key: "cut",
    value: function cut() {
      if (!this.selection) {
        return;
      }
      var paragraphs = this.copy();
      this.slate.deleteFragment();
      return paragraphs;
    }
    /**
     * 选中当前光标所在的文字节点
     */
  }, {
    key: "selectCurrentText",
    value: function selectCurrentText() {
      if (!this.selection) {
        return;
      }
      if (!Range.isCollapsed(this.selection)) {
        return;
      }
      var path = this.selection.focus.path;
      var range = this.getRange(path);
      this.setSelection(range);
    }
  }, {
    key: "setSelectionPoints",
    value: function setSelectionPoints(anchor, focus) {
      Transforms.select(this.slate, {
        anchor: anchor,
        focus: focus
      });
    }
    /**
     * 获取当前 editor 的数据
     * 过滤掉 slate 上面的方法和属性
     * @param filterUselessData 是否需要过滤 slate 上无用数据
     * @returns
     */
  }, {
    key: "getValue",
    value: function getValue() {
      var filterUselessData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!filterUselessData) {
        return this.slate;
      }
      var editorValue = {};
      Object.entries(this.slate).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (key !== 'children' && key in DefaultSlate) {
          return;
        }
        editorValue[key] = value;
      });
      return editorValue;
    }
  }, {
    key: "resetValue",
    value: function resetValue(value) {
      var _this2 = this;
      // 如果引用相同，则不要合并，否则会导致对象被 DEFAULT_DOCUMENT_ELEMENT 重置
      if (this.slate !== value) {
        // 由于不确定外界对 value 做了什么改动，所以原有的 selection 可能会失效
        // 在应用改变之前把 selection 改为相对于段落定位，在应用改变之后再转回来
        var oldSelection = RangeUtils.convertToParagraph(this.selection, this.slate);
        Object.entries(this.slate).forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 1),
            key = _ref4[0];
          // 只保留 children type 以及 slate 上默认的属性和方法，其他数据全部删除，否则无法用 value 替换当前所有数据
          if (!(key === 'type' || key === 'children' || key in DefaultSlate)) {
            delete _this2.slate[key];
          }
        });
        Object.assign(this.slate, DEFAULT_DOCUMENT_ELEMENT, value);
        if (oldSelection) {
          var newSelection = RangeUtils.convertToText(oldSelection, this.slate);
          this.setSelection(newSelection);
        }
      }
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      Transforms.deselect(this.slate);
    }
  }, {
    key: "isSelectionExpanded",
    value: function isSelectionExpanded() {
      var selection = this.selection,
        slate = this.slate;
      return selection && slate.isRangeExpanded(selection);
    }
  }, {
    key: "isSelectionCollapsed",
    value: function isSelectionCollapsed() {
      var selection = this.selection,
        slate = this.slate;
      return selection && slate.isRangeCollapsed(selection);
    }
  }, {
    key: "changeTextProps",
    value: function changeTextProps(textProps, isEditing, locationOrRef, propsMerge) {
      if (!textProps) {
        return;
      }
      var mergeFunction = propsMerge ? function (oldProps, newProps) {
        // slate 没有传递出 key，需要自己找一下，后续 slate 优化之后，这个可以删除
        var propKey = Object.keys(textProps).find(function (key) {
          return textProps[key] === newProps;
        });
        return propsMerge(propKey, oldProps, newProps);
      } : void 0;
      var range = this.getRangeFromLocation(locationOrRef);
      // 指定了选区，应用在对应选区上
      if (range) {
        var isCaret = !Range.isExpanded(range);
        // 当前在编辑态且给定 range 就是当前光标位置，才调用 addMarks 设置当前编辑位置样式
        if (this.selection && isCaret && isEditing && Range.equals(range, this.selection)) {
          this.slate.addMarks(textProps, propsMerge);
        } else {
          Transforms.setNodes(this.slate, textProps, {
            match: Text.isText,
            at: range,
            split: true,
            hanging: true,
            compare: function compare(oldProps, newProps) {
              return !shallowEquals(oldProps, newProps);
            },
            merge: mergeFunction
          });
        }
        return;
      }
      // 没有指定选区，则应用在当前选区
      var selection = this.selection;
      if (selection) {
        /**
         * 在 slate addMark 方法中，如果选区是扩张状态，调用 setNodes 传入的 hanging 为 false，导致在某些情况下会忽略空段落
         * 比如，有两段文字，其中第二段为空，这个时候全选文字（选区为第一段开头到第二段结尾）然后设置文字样式，如果 hanging 为 false 的话，
         * 选区会被处理成第一段开头到第一段结尾，导致第二段样式设置不上
         * 所以这里设置 hanging 为 true
         */
        if (Range.isExpanded(selection)) {
          Transforms.setNodes(this.slate, textProps, {
            match: Text.isText,
            split: true,
            hanging: true,
            merge: mergeFunction
          });
        } else {
          this.slate.addMarks(textProps, propsMerge);
        }
      }
      return;
    }
  }, {
    key: "deleteText",
    value: function deleteText(locationOrRef) {
      var range = this.getRangeFromLocation(locationOrRef) || this.selection;
      if (!range) {
        return;
      }
      Transforms["delete"](this.slate, {
        at: range
      });
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      return Editor$1.marks(this.slate);
    }
  }, {
    key: "getFilteredStyle",
    value: function getFilteredStyle() {
      // 获取当前的 marks，根据 slate 的逻辑，一般继承自光标前面的节点
      var style = this.getStyle();
      // 根据 slate 的逻辑，由于 marks 一般继承自光标前面的节点，所以保证 currentPoint 使用左边的节点定位
      var currentPoint = this.normalizePoint(this.selection.focus);
      var _this$noExtendPropsHe = this.noExtendPropsHelper.filterNoExtendProps(style, currentPoint, this.slate),
        props = _this$noExtendPropsHe.props,
        hasFiltered = _this$noExtendPropsHe.hasFiltered;
      return {
        style: props,
        hasFiltered: hasFiltered
      };
    }
  }, {
    key: "getStartPoint",
    value: function getStartPoint() {
      var at = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selection;
      if (!at) {
        return null;
      }
      return Editor$1.start(this.slate, at);
    }
  }, {
    key: "getEndPoint",
    value: function getEndPoint() {
      var at = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selection;
      if (!at) {
        return null;
      }
      return Editor$1.end(this.slate, at);
    }
  }, {
    key: "getBeforePoint",
    value: function getBeforePoint() {
      var at = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selection;
      var distance = arguments.length > 1 ? arguments[1] : undefined;
      var _a;
      if (!at) {
        return null;
      }
      return (_a = Editor$1.before(this.slate, at, {
        distance: distance,
        unit: 'character'
      })) !== null && _a !== void 0 ? _a : null;
    }
  }, {
    key: "getAfterPoint",
    value: function getAfterPoint() {
      var at = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selection;
      var distance = arguments.length > 1 ? arguments[1] : undefined;
      var _a;
      if (!at) {
        return null;
      }
      return (_a = Editor$1.after(this.slate, at, {
        distance: distance,
        unit: 'character'
      })) !== null && _a !== void 0 ? _a : null;
    }
  }, {
    key: "removeTextProps",
    value: function removeTextProps(propsKey, range) {
      if (!range) {
        this.slate.removeMark(propsKey);
        return;
      }
      if (this.slate.isRangeExpanded(range)) {
        Transforms.unsetNodes(this.slate, propsKey, {
          match: Text.isText,
          at: range,
          split: true
        });
      }
    }
  }, {
    key: "changeParagraphProps",
    value: function changeParagraphProps(paragraphProps) {
      var _this3 = this;
      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selection;
      if (!location) {
        return;
      }
      if (!paragraphProps) {
        return;
      }
      // 获取当前选区内所有段落
      var paragraphsEntry = [];
      try {
        paragraphsEntry = _toConsumableArray(Editor$1.nodes(this.slate, {
          match: function match(n) {
            return Element.isElement(n);
          },
          at: location
        }));
      } catch (error) {
        // 说明传入的 location 无效，直接返回
        return;
      }
      paragraphsEntry.forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          path = _ref6[1];
        // 每个段落设置段落属性都深拷贝一份，避免引用同一个对象互相影响
        Transforms.setNodes(_this3.slate, deepClone(paragraphProps), {
          at: path,
          compare: function compare(oldProps, newProps) {
            return !shallowEquals(oldProps, newProps);
          }
        });
      });
    }
  }, {
    key: "changeDocumentProps",
    value: function changeDocumentProps(documentProps) {
      if (!documentProps) {
        return;
      }
      Object.assign(this.slate, documentProps);
    }
    /**
     * 插入文字前会调用钩子，在这个钩子里面返回的属性值需要设置在即将插入的文字上
     * @param text
     * @param props
     * @param needGetCurrentStyle 是否需要获取当前文字样式并应用
     * @returns
     */
  }, {
    key: "insertText",
    value: function insertText(text, props) {
      var needGetCurrentStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (!this.selection) {
        return;
      }
      // 先删除选中部分文本
      var isRangeCollapsed = this.slate.isRangeCollapsed;
      // 这里手动删的原因是，如果交给insert_text自己删，调用的就是底层的api，就不会经过我们这里的处理
      if (!isRangeCollapsed(this.selection)) {
        this.slate.deleteFragment();
      }
      var currentStyleInfo = needGetCurrentStyle ? this.getFilteredStyle() : null;
      // 调用插入文字前的钩子，看是否有新的属性
      var extraProps = this.handleBeforeInsertText(text, Object.assign(Object.assign({}, currentStyleInfo === null || currentStyleInfo === void 0 ? void 0 : currentStyleInfo.style), props));
      // 如果手动传了props, 或者有extraProps，或者style中有需要过滤的属性，就insertNode
      if (props || extraProps || (currentStyleInfo === null || currentStyleInfo === void 0 ? void 0 : currentStyleInfo.hasFiltered)) {
        return this.slate.insertNode(Object.assign(Object.assign(Object.assign(Object.assign({}, currentStyleInfo === null || currentStyleInfo === void 0 ? void 0 : currentStyleInfo.style), props), extraProps), {
          text: text
        }));
      }
      return this.slate.insertText(text);
    }
    /**
     * 插入空段落
     */
  }, {
    key: "insertBreak",
    value: function insertBreak() {
      this.slate.insertBreak();
      // 需要下面逻辑的原因是：
      // insertBreak中调用的 splitNodes，新节点写死了用当前Node的样式，而不是应用marks。marks将会保留到下一次输入的时候应用到节点上
      // 但是实际上，有时候希望新的节点直接应用marks的属性。不然会有问题，比如 链接回车后不输入的回退
      // 所以这里先InsertText，目的是让当前节点应用marks上的属性。然后删除当前的text内容
      this.insertText(' ');
      this.slate.deleteBackward('character');
    }
  }, {
    key: "getSelectionProps",
    value: function getSelectionProps() {
      var _this4 = this;
      var selection = this.selection;
      if (!selection) {
        return [];
      }
      var textNodes = this.getSelectionNodes(function (n) {
        return Text.isText(n);
      });
      var paragraphMap = textNodes.reduce(function (map, _ref7, index, array) {
        var _ref8 = _slicedToArray(_ref7, 2),
          textNode = _ref8[0],
          path = _ref8[1];
        var textProp = Range.isCollapsed(selection) ? Editor$1.marks(_this4.slate) : textNode;
        var _this4$getParent = _this4.getParent(path),
          _this4$getParent2 = _slicedToArray(_this4$getParent, 2),
          paragraphNode = _this4$getParent2[0],
          paragraphPath = _this4$getParent2[1];
        if (!map.has(paragraphNode)) {
          var isComplete = _this4.isIncludedInRange(paragraphPath);
          map.set(paragraphNode, {
            textProps: [],
            isComplete: isComplete
          });
        }
        var text = textNode.text;
        if (index === 0 || index === array.length - 1) {
          text = _this4.getStringInSelectionByPath(path);
        }
        map.get(paragraphNode).textProps.push(Object.assign(Object.assign({}, textProp), {
          text: text
        }));
        return map;
      }, new Map());
      return _toConsumableArray(paragraphMap).map(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
          paragraph = _ref10[0],
          _ref10$ = _ref10[1],
          textProps = _ref10$.textProps,
          isComplete = _ref10$.isComplete;
        paragraph.children;
          var paragraphProps = __rest(paragraph, ["children"]);
        return {
          paragraphProps: paragraphProps,
          isComplete: isComplete,
          textProps: textProps
        };
      });
    }
  }, {
    key: "getSelectionNodes",
    value: function getSelectionNodes(match) {
      var selection = this.selection;
      if (!selection) {
        return [];
      }
      var nodeEntry = _toConsumableArray(Editor$1.nodes(this.slate, {
        match: match
      }));
      if (Range.isCollapsed(selection)) {
        return nodeEntry;
      }
      var _nodeEntry$ = _slicedToArray(nodeEntry[0], 2),
        firstNodePath = _nodeEntry$[1];
      var firstNodeEndPoint = Editor$1.end(this.slate, firstNodePath);
      var selectionStartPoint = Range.start(selection);
      // 如果选区内不包含第一个文本节点的内容，那么直接过滤掉第一个节点
      if (Point.equals(firstNodeEndPoint, selectionStartPoint)) {
        return nodeEntry.slice(1);
      }
      return nodeEntry;
    }
  }, {
    key: "getNodes",
    value: function getNodes(match) {
      var locationOrRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var at = null;
      if (locationOrRef && 'unref' in locationOrRef) {
        at = locationOrRef.current;
      } else {
        at = locationOrRef;
      }
      if (!at) {
        return [];
      }
      return _toConsumableArray(Editor$1.nodes(this.slate, {
        match: match,
        at: at
      }));
    }
  }, {
    key: "getString",
    value: function getString() {
      var at = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selection;
      if (!at) {
        return '';
      }
      return Editor$1.string(this.slate, at);
    }
  }, {
    key: "getRange",
    value: function getRange(at) {
      return Editor$1.range(this.slate, at);
    }
    /**
     * 选中当前点所在的单词
     * @param point
     * @returns
     */
  }, {
    key: "selectCurrentWord",
    value: function selectCurrentWord(point) {
      var _this$getVoidInfoByPo = this.getVoidInfoByPoint(point),
        isInsideVoid = _this$getVoidInfoByPo.isInsideVoid;
      // 如果光标在void内部，不处理。单击已经处理了void选中
      if (isInsideVoid) {
        return;
      }
      // 根据dom、ppt的表现，是取光标后面文字内容,不会跨段
      var nextWordPoint = this.getNextWordPointWithinVoids(point);
      var isCrossParagraph = (nextWordPoint === null || nextWordPoint === void 0 ? void 0 : nextWordPoint.path[0]) !== point.path[0];
      // 不处理的情况： 1.后面没有文字 2.后面文字跨段了
      if (!nextWordPoint || Point.equals(nextWordPoint, point) || isCrossParagraph) {
        return;
      }
      var focus = nextWordPoint;
      var anchor = this.getPrevWordPointWithinVoids(nextWordPoint);
      // nextWordPoint的前一个word的边界一定存在
      this.setSelectionPoints(anchor, focus);
    }
    /**
     * 选中当前点所在的段落
     * @param point
     */
  }, {
    key: "selectCurrentParagraph",
    value: function selectCurrentParagraph(point) {
      var paragraphPath = point.path.slice(0, point.path.length - 1);
      var _this$getRange = this.getRange(paragraphPath),
        anchor = _this$getRange.anchor,
        focus = _this$getRange.focus;
      this.setSelectionPoints(anchor, focus);
    }
  }, {
    key: "selectAll",
    value: function selectAll() {
      this.slate.selectAll();
    }
    // 获取当前点所属的node是否为void，并返回其相关信息
  }, {
    key: "getVoidInfoByPoint",
    value: function getVoidInfoByPoint(point) {
      return this.slate.getVoidInfoByPoint(point);
    }
    /*
     * 如果前一个单词边界在void里，将会跳过void，返回void的边界
     */
  }, {
    key: "getPrevWordPointWithinVoids",
    value: function getPrevWordPointWithinVoids(point) {
      var prevWordPoint = this.slate.getPrevWordPoint(point);
      if (!prevWordPoint) {
        return prevWordPoint;
      }
      var _this$getVoidInfoByPo2 = this.getVoidInfoByPoint(prevWordPoint),
        isInsideVoid = _this$getVoidInfoByPo2.isInsideVoid,
        range = _this$getVoidInfoByPo2.range;
      if (isInsideVoid) {
        return range.anchor;
      }
      return prevWordPoint;
    }
    /*
     * 如果后一个单词边界在void里，将会跳过void，返回void的边界
     */
  }, {
    key: "getNextWordPointWithinVoids",
    value: function getNextWordPointWithinVoids(point) {
      var nextWordPoint = this.slate.getNextWordPoint(point);
      if (!nextWordPoint) {
        return nextWordPoint;
      }
      var _this$getVoidInfoByPo3 = this.getVoidInfoByPoint(nextWordPoint),
        isInsideVoid = _this$getVoidInfoByPo3.isInsideVoid,
        range = _this$getVoidInfoByPo3.range;
      if (isInsideVoid) {
        return range.focus;
      }
      return nextWordPoint;
    }
  }, {
    key: "getLeafNodeAndRangeRef",
    value: function getLeafNodeAndRangeRef(range) {
      var _this5 = this;
      if (!range) {
        return [];
      }
      var nodeEntry = Array.from(Editor$1.nodes(this.slate, {
        mode: 'lowest',
        at: range
      }));
      return nodeEntry.map(function (_ref11, index, arr) {
        var _ref12 = _slicedToArray(_ref11, 2),
          node = _ref12[0],
          path = _ref12[1];
        var anchor = index === 0 ? Range.start(range) : {
          path: path,
          offset: 0
        };
        var focus = index === arr.length - 1 ? Range.end(range) : {
          path: path,
          offset: node.text.length
        };
        var rangeRef = Editor$1.rangeRef(_this5.slate, {
          anchor: anchor,
          focus: focus
        });
        return {
          node: node,
          rangeRef: rangeRef
        };
      });
    }
  }, {
    key: "getParent",
    value: function getParent(location) {
      return Editor$1.parent(this.slate, location);
    }
  }, {
    key: "isSelectAll",
    value: function isSelectAll() {
      return this.slate.isSelectAll();
    }
  }, {
    key: "handleCompositionStart",
    value: function handleCompositionStart() {
      var selection = this.selection;
      if (!selection) {
        return;
      }
      if (this.slate.isRangeExpanded(selection)) {
        Editor$1.deleteFragment(this.slate);
        return;
      }
    }
  }, {
    key: "handleCompositionEnd",
    value: function handleCompositionEnd(text) {
      // 合成输入结束后也更新下输入文字，解决 safari 浏览器中在合成输入结束时不触发 compositionupdate 事件导致的编辑问题
      this.changeCompositionText(text);
      this.clearCompositionState();
    }
  }, {
    key: "clearCompositionState",
    value: function clearCompositionState() {
      this.lastCompositionText = '';
    }
  }, {
    key: "isVoid",
    value: function isVoid(node) {
      return this.slate.isVoid(node);
    }
  }, {
    key: "deleteCharacterBack",
    value: function deleteCharacterBack(length) {
      var _a;
      var point = (_a = this.selection) === null || _a === void 0 ? void 0 : _a.anchor;
      if (!point) {
        return;
      }
      Transforms["delete"](this.slate, {
        at: point,
        unit: 'character',
        reverse: true,
        distance: length
      });
    }
  }, {
    key: "changeCompositionText",
    value: function changeCompositionText(text) {
      var _a;
      // 如果合成输入的内容没有变化，直接返回
      if (this.lastCompositionText === text) {
        return;
      }
      var current = (_a = this.selection) === null || _a === void 0 ? void 0 : _a.anchor;
      // 获取输入时要带上的样式，并且在边缘输入处理不需要继承的属性
      var _this$getFilteredStyl = this.getFilteredStyle(),
        style = _this$getFilteredStyl.style;
      // 删除掉从上次合成输入的文字
      if (this.lastCompositionText.length) {
        Transforms["delete"](this.slate, {
          at: current,
          unit: 'character',
          reverse: true,
          distance: this.lastCompositionText.length
        });
      }
      /**
       * 插入新文字
       * 这里手动加上 style 是因为，如果输入中文前设置了新的样式的话，此时 slate.marks 上会有这个样式，
       * 这里其实是会新建节点的，节点起始点就是当前合成输入的文字起始点，插入完成之后 slate.marks 就置为 null 了，
       * 这种情况下，在下次输入的时候，经过上面的 delete 操作之后，当前节点会被删掉，导致新插入的 text 应用不上之前设置的样式
       * 所以就在删除前缓存下即将要应用的样式，然后手动设置上去
       * 这里获取到的 style 已经是当前输入需要的全量样式，所以不需要再次获取，第三个参数为 false
       */
      this.insertText(text, style, false);
      this.lastCompositionText = text;
    }
  }, {
    key: "normalizePoint",
    value: function normalizePoint(point) {
      return this.slate.normalizePoint(point);
    }
  }, {
    key: "getPrevTextElement",
    value: function getPrevTextElement(path) {
      if (!path) {
        return null;
      }
      var nodeEntry = Editor$1.previous(this.slate, {
        at: path,
        match: Text.isText
      });
      if (nodeEntry) {
        return nodeEntry[0];
      }
      return null;
    }
  }, {
    key: "getNextTextElement",
    value: function getNextTextElement(path) {
      if (!path) {
        return null;
      }
      var nodeEntry = Editor$1.next(this.slate, {
        at: path,
        match: Text.isText
      });
      if (nodeEntry) {
        return nodeEntry[0];
      }
      return null;
    }
    /**
     * 提供遍历 textElement 的方法
     * @param callback
     */
  }, {
    key: "traverseTextElements",
    value: function traverseTextElements(callback) {
      var _loop = function loop(element, path) {
        if (Text.isText(element)) {
          callback(element, path);
          return;
        }
        if (element.children) {
          element.children.forEach(function (child, index) {
            _loop(child, [].concat(_toConsumableArray(path), [index]));
          });
        }
      };
      _loop(this.slate, []);
    }
    /**
     * 提供遍历 paragraphElement 的方法
     * @param callback
     */
  }, {
    key: "traverseParagraphElements",
    value: function traverseParagraphElements(callback) {
      var paragraphs = this.slate.children;
      for (var i = 0; i < paragraphs.length; i++) {
        var paragraph = paragraphs[i];
        var needBreak = callback(paragraph, [i]);
        if (needBreak) {
          break;
        }
      }
    }
    /**
     * 给定 location 是否完全包含在给定选区中
     * @param location
     * @param range
     * @returns
     */
  }, {
    key: "isIncludedInRange",
    value: function isIncludedInRange(location) {
      var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selection;
      if (!range || !location) {
        return false;
      }
      var _SlateEditor$range = Editor$1.range(this.slate, location),
        anchor = _SlateEditor$range.anchor,
        focus = _SlateEditor$range.focus;
      return Range.includes(range, anchor) && Range.includes(range, focus);
    }
    /**
     * 清除所有 ref，避免内存泄漏
     * 在下一次事件循环中清除，保证清除之前所有依赖 ref 的逻辑都能执行完成
     */
  }, {
    key: "clearRefs",
    value: function clearRefs() {
      var _this6 = this;
      Promise.resolve().then(function () {
        var _iterator = _createForOfIteratorHelper(Editor$1.pathRefs(_this6.slate)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var ref = _step.value;
            ref.unref();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var _iterator2 = _createForOfIteratorHelper(Editor$1.pointRefs(_this6.slate)),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _ref13 = _step2.value;
            _ref13.unref();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        var _iterator3 = _createForOfIteratorHelper(Editor$1.rangeRefs(_this6.slate)),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _ref14 = _step3.value;
            _ref14.unref();
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      });
    }
  }, {
    key: "initSlate",
    value: function initSlate(value) {
      var editor = withAlloy(createEditor());
      this.slate = Object.assign(editor, value);
      this.slate.onChange = this.handleSlateChange;
      this.slate.onBeforeChange = this.handleBeforeSlateChange;
    }
    /**
     * 判断 selection 是否变化，记录 lastSelectionRef
     * 使用 ref 是避免保存 selection 的话，有可能下次使用的时候已经失效了，会导致一些错误
     * @returns
     */
  }, {
    key: "handleSelection",
    value: function handleSelection() {
      var _a;
      var selection = this.selection,
        lastSelection = this.lastSelection;
      if (!selection && !lastSelection) {
        return;
      }
      if (selection && !lastSelection || !selection && lastSelection || !Range.equals(selection, lastSelection)) {
        (_a = this.onSelectionChange) === null || _a === void 0 ? void 0 : _a.call(this, lastSelection, selection, this.slate);
        this.lastSelection = selection;
      }
    }
    /**
     * 获取给定节点在选区中的字符串
     * @param path
     * @returns
     */
  }, {
    key: "getStringInSelectionByPath",
    value: function getStringInSelectionByPath(path) {
      if (!this.selection || Range.isCollapsed(this.selection)) {
        return '';
      }
      var range = Editor$1.range(this.slate, path);
      return this.getIntersectString(this.selection, range);
    }
    /**
     * 获取两个 range 交叉部分的字符串
     * @param range
     * @param another
     * @returns
     */
  }, {
    key: "getIntersectString",
    value: function getIntersectString(range, another) {
      var intersectRange = Range.intersection(range, another);
      return this.getString(intersectRange);
    }
  }, {
    key: "getRangeFromLocation",
    value: function getRangeFromLocation(locationOrRef) {
      if (!locationOrRef) {
        return null;
      }
      if ('unref' in locationOrRef) {
        // 说明是 ref，取到对应的值后再次解析
        return this.getRangeFromLocation(locationOrRef.current);
      }
      if (Path.isPath(locationOrRef)) {
        return this.getRange(locationOrRef);
      }
      if (Range.isRange(locationOrRef)) {
        return locationOrRef;
      }
      return locationOrRef;
    }
    /**
     * 带格式粘贴并且保留段落结构
     * 第一段、最后一段和相邻的原文本段落进行合并，并且保留粘贴的段落属性
     * @param paragraphs
     * @returns
     */
  }, {
    key: "pasteWithProps",
    value: function pasteWithProps() {
      var _this7 = this;
      var paragraphs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!paragraphs.length) {
        return;
      }
      if (paragraphs.length === 1) {
        // 只保留子节点，抛弃段落样式
        var children = paragraphs[0].children;
        this.slate.insertNodes(children);
        return;
      }
      // 段落样式都要保留，并且覆盖原段落样式
      var beforePastedParagraphPath = this.slate.start(this.selection).path.slice(0, -1);
      this.slate.insertNodes(paragraphs);
      // 把粘贴的最后一段和后面的段落合并，并使用粘贴段落的属性
      var lastPastedParagraphPath = this.selection.focus.path.slice(0, -1);
      var lastPastedParagraph = this.slate.getNodeByPath(lastPastedParagraphPath);
      var afterPastedParagraphPath = Path.next(lastPastedParagraphPath);
      var afterPastedParagraph = errorCatcher(function () {
        return _this7.slate.getNodeByPath(afterPastedParagraphPath);
      });
      if (afterPastedParagraph) {
        this.changeParagraphProps(Object.assign(Object.assign(Object.assign({}, afterPastedParagraph), lastPastedParagraph), {
          children: undefined
        }), lastPastedParagraphPath);
        this.slate.mergeNodes({
          at: afterPastedParagraphPath
        });
      }
      // 把粘贴的第一段和前面的段落合并，并使用粘贴段落的属性
      var beforePastedParagraph = this.slate.getNodeByPath(beforePastedParagraphPath);
      var firstPastedParagraphPath = Path.next(beforePastedParagraphPath);
      var firstPastedParagraph = this.slate.getNodeByPath(firstPastedParagraphPath);
      this.changeParagraphProps(Object.assign(Object.assign(Object.assign({}, beforePastedParagraph), firstPastedParagraph), {
        children: undefined
      }), beforePastedParagraphPath);
      this.slate.mergeNodes({
        at: firstPastedParagraphPath
      });
    }
    /**
     * 粘贴为纯文本并且保留段落结构
     * 第一段、最后一段和相邻的原文本段落进行合并
     * @param paragraphs
     * @returns
     */
  }, {
    key: "pasteAsPureText",
    value: function pasteAsPureText() {
      var _this8 = this;
      var paragraphs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!paragraphs.length) {
        return;
      }
      paragraphs.forEach(function (paragraph, index) {
        var children = paragraph.children;
        // 要保留段落结构且首段和尾段要和原段落合并，所以需要在中间添加断行点
        if (index > 0) {
          _this8.insertBreak();
        }
        // 遍历所有文字节点插入即可，丢弃原有样式
        children.forEach(function (textElement) {
          _this8.insertText(textElement.text);
        });
      });
    }
  }]);
}();

/**
 * 管理 slate 文字节点和 path 的映射
 */
var TextElementToPath = /*#__PURE__*/function () {
  function TextElementToPath() {
    _classCallCheck(this, TextElementToPath);
    this.map = new Map();
  }
  return _createClass(TextElementToPath, [{
    key: "link",
    value: function link(textElement, path) {
      this.map.set(textElement, path);
    }
  }, {
    key: "get",
    value: function get(textElement) {
      return this.map.get(textElement);
    }
  }, {
    key: "has",
    value: function has(textElement) {
      return this.map.has(textElement);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
    }
  }]);
}();

var id = 0;
function getIncrementId() {
  return id += 1;
}

var Editor = /*#__PURE__*/function () {
  function Editor(editorOption) {
    var _this = this;
    _classCallCheck(this, Editor);
    // slate 文本节点对应排版中的 box
    this.slatePathToBox = new SlatePathToBox();
    this.id = getIncrementId();
    // 在获取到焦点时是否阻止系统默认滚动
    this.preventScrollOnFocus = false;
    // 当前是否在合成输入中
    this.isComposing = false;
    this.mouseManager = null;
    this.textElementToPath = new TextElementToPath();
    // 是否主动进入 readyEditing 状态
    // 加 setReadyEditingFlag 是保证必须要显示 setReadyEditing 才能进入这个状态，避免影响只是单纯想隐藏光标的情况
    this.setReadyEditingFlag = false;
    /**
     * 触发编辑器获取焦点
     * 默认选区会设置在文本最末尾
     * @param needAutoSelect
     * 在输入框失去焦点时，如果想重新获取焦点，可以调用这个方法
     */
    this.focus = function () {
      var needAutoSelect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      // 需要先挂载编辑模块，这样当前 editor isFocused 才是 true
      Editor.surface.attachEditor(_this);
      // 已有选区的话就不自动设置焦点
      if (needAutoSelect && !_this.selection) {
        _this.model.selectEnd();
      }
      // 如果有选区，就更新下选区或光标的显示
      if (_this.selection) {
        _this.updateEditorSurface();
      }
      Editor.surface.attachEditor(_this);
      _this.enterRealEditing();
    };
    /**
     * 进入 readyEditing 状态
     */
    this.setReadyEditing = function () {
      // 更改 setReadyEditingFlag 可能会影响 isEditing 状态，所以先获取值
      var isEditing = _this.isEditing;
      // 在触发外界钩子前，修改 setReadyEditingFlag 标记
      _this.setReadyEditingFlag = true;
      if (isEditing) {
        _this.realEditingToReadyEditing();
      } else {
        _this.blurredToReadyEditing();
      }
    };
    /**
     * 退出 readyEditing 状态，进入失焦状态
     */
    this.removeReadyEditing = function () {
      // 更改 setReadyEditingFlag 可能会影响 isReadyEditing 状态，所以先获取值
      var isReadyEditing = _this.isReadyEditing;
      // 在触发外界钩子前，清除 setReadyEditingFlag 标记
      _this.setReadyEditingFlag = false;
      if (isReadyEditing) {
        _this.readyEditingToBlurred();
      }
    };
    /**
     * 获取给定位置所在点对应的 slate 中的 point
     * @param pointPosition
     */
    this.getPointByPosition = function (pointPosition) {
      var posXOfWorld = pointPosition.posXOfWorld,
        posYOfWorld = pointPosition.posYOfWorld;
      var position = _this.positionOfAppToPositionOfEditor(posXOfWorld, posYOfWorld);
      return Editor.surface.getPointFromPointPosition(position);
    };
    /**
     * 进入编辑态时初始化选区
     */
    this.initSelection = function (anchor, focus) {
      var selection = {
        anchor: anchor,
        focus: focus || anchor
      };
      if (_this.selection && Range.equals(selection, _this.selection)) {
        // 相同，就不会触发 surface.update()，就手动触发下
        _this.updateEditorSurface();
      } else {
        _this.setSelection(selection);
      }
    };
    this.handleBeforeChange = function (slate) {
      var _a;
      if (slate.isChangeValue) {
        (_a = _this.onBeforeValueChange) === null || _a === void 0 ? void 0 : _a.call(_this);
      }
    };
    this.handleSelectionChange = function (prevSelection, currentSelection, slate) {
      var _a;
      // 如果值有变化，会在值变化完成之后调用 Editor.surface.update，这里不需要调用
      if (!slate.isChangeValue) {
        _this.updateEditorSurface();
      }
      (_a = _this.onSelectionChange) === null || _a === void 0 ? void 0 : _a.call(_this, prevSelection, currentSelection);
    };
    this.traverseTextHook = function (slatePath, textBox, textElement) {
      _this.slatePathToBox.link(slatePath, textBox);
      if (textElement) {
        _this.textElementToPath.link(textElement, slatePath);
      }
    };
    this.getNodeByPath = function (path) {
      return _this.model.getNodeByPath(path);
    };
    var rect = editorOption.rect,
      getScale = editorOption.getScale,
      _editorOption$readonl = editorOption.readonly,
      readonly = _editorOption$readonl === void 0 ? false : _editorOption$readonl,
      value = editorOption.value,
      drawContext = editorOption.drawContext,
      renderUtils = editorOption.renderUtils,
      _editorOption$eventAr = editorOption.eventArea,
      eventArea = _editorOption$eventAr === void 0 ? EventArea.text : _editorOption$eventAr,
      _editorOption$prevent = editorOption.preventScrollOnFocus,
      preventScrollOnFocus = _editorOption$prevent === void 0 ? false : _editorOption$prevent,
      renderText = editorOption.renderText,
      getMatrix = editorOption.getMatrix,
      getAppPosition = editorOption.getAppPosition,
      getBackDeleteTextProps = editorOption.getBackDeleteTextProps,
      getContainer = editorOption.getContainer,
      onBeforeInput = editorOption.onBeforeInput,
      noExtendProps = editorOption.noExtendProps;
    // 挂载编辑模块
    Editor.attachSurface();
    this.model = new EditorModel({
      value: value,
      onChange: function onChange(slate) {
        _this.handleChange(slate);
      },
      onBeforeChange: this.handleBeforeChange,
      onSelectionChange: this.handleSelectionChange,
      onBeforeInput: onBeforeInput,
      noExtendProps: noExtendProps
    });
    this.view = new EditorView({
      rect: rect,
      getMatrix: getMatrix,
      getScale: getScale,
      getAppPosition: getAppPosition,
      getCoordinate: function getCoordinate() {
        return _this.coordinate;
      }
    });
    // 移动端不触发 mouse 相关事件
    if (!isMobile(Editor.platform)) {
      this.mouseManager = new MouseManager({
        model: this.model,
        getPointByPosition: this.getPointByPosition,
        setFocus: this.focus,
        initSelection: this.initSelection
      });
    }
    this.touchManager = new TouchManager({
      model: this.model,
      getPointByPosition: this.getPointByPosition,
      setFocus: this.focus,
      initSelection: this.initSelection
    });
    this.getContainer = getContainer;
    this.readonly = readonly;
    this.drawContext = drawContext;
    this.renderUtils = renderUtils;
    this.getBackDeleteTextProps = getBackDeleteTextProps;
    this.preventScrollOnFocus = preventScrollOnFocus;
    this.initHook(editorOption);
    this.initLayout();
    this.initRender(renderText, eventArea);
  }
  return _createClass(Editor, [{
    key: "rangeUtil",
    get: function get() {
      if (!this._rangeUtil) {
        this._rangeUtil = new RangeUtils(this.model.slate);
      }
      return this._rangeUtil;
    }
    // 获取当前选区
  }, {
    key: "selection",
    get: function get() {
      return this.model.selection;
    }
    /**
     * 给外界使用，获取当前编辑状态
     * !!! isEditing 为 true 并不代表能输入文字，可能此时输入框已经失焦，无法输入
     * isEditing 是指当前 editor 还有选区，可以设置选区的样式
     * 和 readyEditing 状态互斥
     */
  }, {
    key: "isEditing",
    get: function get() {
      if (this.readonly) {
        return false;
      }
      var hasSelection = !!this.selection;
      return hasSelection && !this.isReadyEditing;
    }
    /**
     * 是否在 readyEditing 状态
     * 此时，editor 已经进入了实际的编辑态，可以直接输入文字，但是光标被隐藏掉了
     * 大部分场景可能用不到这个状态，这个状态是为了实现类似于「直接输入」的需求，而不是先手动进入编辑态再输入
     */
  }, {
    key: "isReadyEditing",
    get: function get() {
      if (this.readonly) {
        return false;
      }
      var hasSelection = !!this.selection;
      return hasSelection && this.setReadyEditingFlag && Editor.isKeepCaretHide && this.isSelectionCollapsed();
    }
    /**
     * 给外界使用，表示当前编辑器是否可输入文字
     * 和 isEditing 状态可以对应着看
     * isTextEnterable 为 true 表示当前 editor 可以编辑而且输入框在激活状态，可以正常输入文字，此时输入框的各种事件可以正常响应
     * 实在是想不到合适的名字，有合适的可以告诉我
     */
  }, {
    key: "isTextEnterable",
    get: function get() {
      return this.isEditing && this.isFocused && Editor.surface.isHiddenInputFocus;
    }
  }, {
    key: "scale",
    get: function get() {
      return this.view.scale;
    }
  }, {
    key: "container",
    get: function get() {
      if (this.getContainer) {
        return this.getContainer() || null;
      }
      return document.body;
    }
  }, {
    key: "matrix",
    get: function get() {
      return this.view.matrix;
    }
    // 当前编辑区域应用的 transform 缩放
  }, {
    key: "transformScale",
    get: function get() {
      // 根据 matrix 反算出 scale，计算方式参考：https://math.stackexchange.com/questions/13150/extracting-rotation-scale-values-from-2d-transformation-matrix/13165#13165
      var _this$matrix = this.matrix,
        a = _this$matrix.a,
        b = _this$matrix.b;
      // 目前以 x 方向的 scale 为准，正常情况下都是等比缩放，scaleX scaleY 的值应该相同
      var scaleX = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
      return scaleX;
    }
  }, {
    key: "blockRect",
    get: function get() {
      return this.view.blockRect;
    }
    /**
     * 获取当前编辑器所有文字的范围，相对于 blockRect 偏移前的原点
     */
  }, {
    key: "textRect",
    get: function get() {
      var _this$layoutManager$l = this.layoutManager.layoutBox.rect,
        width = _this$layoutManager$l.width,
        height = _this$layoutManager$l.height,
        x = _this$layoutManager$l.x,
        y = _this$layoutManager$l.y;
      return {
        x: twipsToPx(x),
        y: twipsToPx(y),
        width: twipsToPx(width),
        height: twipsToPx(height)
      };
    }
  }, {
    key: "appPosition",
    get: function get() {
      return this.view.appPosition;
    }
    /**
     * 当前编辑器的逻辑坐标原点
     */
  }, {
    key: "coordinate",
    get: function get() {
      return this.model.coordinate;
    }
    /**
     * 当前编辑器行扩张的方向
     */
  }, {
    key: "lineExpandDirection",
    get: function get() {
      return this.model.lineExpandDirection;
    }
  }, {
    key: "triggerMouseDown",
    value: function triggerMouseDown(mousePosition, event) {
      var _a;
      (_a = this.mouseManager) === null || _a === void 0 ? void 0 : _a.triggerMouseDown(mousePosition, event);
    }
  }, {
    key: "triggerMouseMove",
    value: function triggerMouseMove(mousePosition) {
      var _a;
      (_a = this.mouseManager) === null || _a === void 0 ? void 0 : _a.triggerMouseMove(mousePosition);
    }
  }, {
    key: "triggerMouseUp",
    value: function triggerMouseUp() {
      var _a;
      (_a = this.mouseManager) === null || _a === void 0 ? void 0 : _a.triggerMouseUp();
    }
  }, {
    key: "triggerTouchStart",
    value: function triggerTouchStart(touchPosition) {
      this.touchManager.triggerTouchStart(touchPosition);
    }
  }, {
    key: "triggerTouchMove",
    value: function triggerTouchMove(touchPosition) {
      this.touchManager.triggerTouchMove(touchPosition);
    }
  }, {
    key: "triggerTouchEnd",
    value: function triggerTouchEnd(touchPosition) {
      this.touchManager.triggerTouchEnd(touchPosition);
    }
  }, {
    key: "handleTouchPoint",
    value: function handleTouchPoint(point) {
      this.touchManager.handleTouchPoint(point);
    }
    /**
     * 外界调用，用于更新编辑器光标和输入框位置
     */
  }, {
    key: "updateSurface",
    value: function updateSurface() {
      this.updateEditorSurface({
        needUpdateSelection: false,
        needFocus: false
      });
    }
    /**
     * 光标移动到文档末尾
     */
  }, {
    key: "selectEnd",
    value: function selectEnd() {
      this.model.selectEnd();
    }
    /**
     * 选中所有文字
     */
  }, {
    key: "selectAll",
    value: function selectAll() {
      this.model.selectAll();
    }
    /**
     * 编辑器失焦
     * 理论上需要在这里清除掉所有编辑相关的逻辑
     */
  }, {
    key: "blur",
    value: function blur() {
      /**
       * 最后再 detachEditor，因为 detachEditor 里面会触发 blurhook，保证在 blurhook 的全部逻辑中
       * 当前 editor 已经清除了所有编辑的逻辑
       */
      Editor.surface.detachEditor(this);
    }
    /**
     * 开始持续展示光标
     * 这里是指光标是否展示不受输入框焦点影响，只要当前 editor 的选区是光标状态就一直显示
     */
  }, {
    key: "startKeepCaretShow",
    value: function startKeepCaretShow() {
      if (this.isFocused) {
        Editor.surface.startKeepCaretShow();
      }
    }
    /**
     * 停止持续展示光标
     * 这里是指光标是否展示跟随输入框焦点状态
     */
  }, {
    key: "stopKeepCaretShow",
    value: function stopKeepCaretShow() {
      if (this.isFocused) {
        Editor.surface.stopKeepCaretShow();
      }
    }
    /**
     * 开始隐藏光标
     */
  }, {
    key: "startKeepCaretHide",
    value: function startKeepCaretHide() {
      if (this.isFocused) {
        Editor.surface.startKeepCaretHide();
      }
    }
    /**
     * 停止隐藏光标
     */
  }, {
    key: "stopKeepCaretHide",
    value: function stopKeepCaretHide() {
      if (this.isFocused) {
        Editor.surface.stopKeepCaretHide();
      }
    }
    /**
     * 调用 blur 钩子
     * 理论上需要在这里清除掉所有编辑相关的逻辑
     */
  }, {
    key: "blurHook",
    value: function blurHook() {
      var _a;
      if (this.isReadyEditing) {
        /**
         * 从 readyEditing 失焦
         * 理论上来说都是非编辑态，所以不需要触发 blur 回调
         * 但是需要清除编辑相关状态
         */
        this.setReadyEditingFlag = false;
        this.clearEditStatus();
        return;
      }
      this.clearEditStatus();
      // 只读状态下不需要触发 blur 的钩子
      if (this.readonly) {
        return;
      }
      if (this.isFocused) {
        (_a = this.onBlur) === null || _a === void 0 ? void 0 : _a.call(this);
      }
    }
  }, {
    key: "focusHook",
    value: function focusHook() {
      var _a;
      // 只读状态下不需要触发 focus 的钩子
      if (this.readonly) {
        return;
      }
      if (this.isReadyEditing) {
        return;
      }
      if (!this.isFocused) {
        (_a = this.onFocus) === null || _a === void 0 ? void 0 : _a.call(this);
      }
    }
    /**
     * 获取编辑器当前数据
     * @param filterUselessData 是否需要过滤掉无用数据
     * @returns
     */
  }, {
    key: "getValue",
    value: function getValue() {
      var filterUselessData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return this.model.getValue(filterUselessData);
    }
    /**
     * 修改 readonly 状态
     * @param readonly
     * @returns
     */
  }, {
    key: "changeReadonly",
    value: function changeReadonly(readonly) {
      if (readonly === this.readonly) {
        return;
      }
      this.readonly = readonly;
      // 由可编辑变为不可编辑，需要退出编辑态
      if (this.readonly) {
        this.blur();
      }
    }
    /**
     * 外部修改内容
     * 只需要重新绘制，不需要触发 valueChange 的钩子
     * @param value
     * @param rect 可选参数，有的话就更新 blockRect，加这个参数是希望业务中 value 和 rect 都有更新时只需要进行一次排版和绘制
     */
  }, {
    key: "resetValue",
    value: function resetValue(value, rect) {
      this.model.resetValue(value);
      // 如果传了 rect 参数，就更新下 rect
      rect && this.view.updateBlockRect(rect);
      this.handleValueChange(false);
    }
    /** @description 仅用于更新 editor 数据，不会触发排版和重新绘制*/
  }, {
    key: "resetValueWithoutEffect",
    value: function resetValueWithoutEffect(value) {
      this.model.resetValue(value);
      // 手动更新 textElement 和 path 之间的映射关系
      this.updateTextElementToPath();
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      this.model.clearSelection();
    }
  }, {
    key: "setSelection",
    value: function setSelection(selection) {
      this.model.setSelection(selection);
    }
  }, {
    key: "changeRect",
    value: function changeRect(rect) {
      if (this.view.isSizeChange(rect)) {
        this.onSizeChange(rect);
        return;
      }
      if (this.view.isPositionChange(rect)) {
        this.onPositionChange(rect);
        return;
      }
    }
    /**
     * 给外界调用，手动触发排版和绘制
     */
  }, {
    key: "forceRender",
    value: function forceRender() {
      this.clearRect();
      this.layout();
      this.draw();
      this.updateEditorSurface({
        needFocus: false
      });
    }
    /**
     * 当前选区是否是展开状态
     * @returns
     */
  }, {
    key: "isSelectionExpanded",
    value: function isSelectionExpanded() {
      return this.model.isSelectionExpanded();
    }
    /**
     * 当前选区是否是光标状态
     * @returns
     */
  }, {
    key: "isSelectionCollapsed",
    value: function isSelectionCollapsed() {
      return this.model.isSelectionCollapsed();
    }
    /**
     * 获取当前选区的位置和大小
     */
  }, {
    key: "getSelectionRect",
    value: function getSelectionRect() {
      if (this.isFocused) {
        // 只有在 focus 状态下才能使用 surface 计算选区
        return Editor.surface.selectionBlockRect;
      }
      return undefined;
    }
    /**
     * 修改文字样式，默认修改选区内的文字样式
     * 第二个参数支持多种数据类型，均可以转换为 range，传入的话可以修改对应 range 的文字样式
     */
  }, {
    key: "changeTextProps",
    value: function changeTextProps(textProps, locationOrRef, propsMerge) {
      return this.model.changeTextProps(textProps, this.isEditing, locationOrRef, propsMerge);
    }
    /**
     * 删除指定位置的文字
     */
  }, {
    key: "deleteText",
    value: function deleteText(locationOrRef) {
      return this.model.deleteText(locationOrRef);
    }
    /**
     * 删除文字样式
     * @param propsKey
     */
  }, {
    key: "removeTextProps",
    value: function removeTextProps(propsKey, range) {
      return this.model.removeTextProps(propsKey, range);
    }
    /**
     * 设置当前选中的段落属性
     */
  }, {
    key: "changeParagraphProps",
    value: function changeParagraphProps(paragraphProps, location) {
      return this.model.changeParagraphProps(paragraphProps, location);
    }
    /**
     * 设置当前文档的属性
     * 注意：现在修改文档属性不会触发 slate 的 onchange
     */
  }, {
    key: "changeDocumentProps",
    value: function changeDocumentProps(documentProps) {
      var _this2 = this;
      this.model.changeDocumentProps(documentProps);
      // 放在 promise 中是为了和正常的回调时机保持一致
      Promise.resolve().then(function () {
        _this2.handleValueChange();
      });
    }
    /**
     * 在当前选区插入，支持设置属性
     * @param text
     * @param props
     * @returns
     */
  }, {
    key: "insertText",
    value: function insertText(text, props) {
      this.enterRealEditing();
      return this.model.insertText(text, props);
    }
    /**
     * 在当前位置插入空段落
     */
  }, {
    key: "insertBreak",
    value: function insertBreak() {
      this.model.insertBreak();
    }
    /**
     * 插入软回车
     */
  }, {
    key: "insertSoftBreak",
    value: function insertSoftBreak() {
      this.insertText('\n');
    }
    /**
     * 粘贴文本，数据都是段落节点，否则会丢失段落属性
     * @param paragraphs
     * @param keepProps 是否需要保留粘贴的属性
     */
  }, {
    key: "paste",
    value: function paste() {
      var paragraphs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var keepProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.model.paste(paragraphs, keepProps);
    }
    /**
     * 复制选中的内容
     * @returns
     */
  }, {
    key: "copy",
    value: function copy() {
      return this.model.copy();
    }
    /**
     * 剪切选中的内容
     * @returns
     */
  }, {
    key: "cut",
    value: function cut() {
      return this.model.cut();
    }
  }, {
    key: "handleCompositionStart",
    value: function handleCompositionStart() {
      this.isComposing = true;
      this.enterRealEditing();
      this.model.handleCompositionStart();
    }
  }, {
    key: "handleCompositionEnd",
    value: function handleCompositionEnd(text) {
      var _a;
      this.model.handleCompositionEnd(text);
      // 在合成输入完成，最后一次触发 compositionupdate 修改文字时当前编辑器还在 composing 状态中，不会触发 onValueChange
      // 所以在合成输入完成时，如果 text 有值就手动触发下，text 没值说明是把合成输入的文字删除了，不需要额外触发
      if (text) {
        (_a = this.onValueChange) === null || _a === void 0 ? void 0 : _a.call(this);
      }
      this.isComposing = false;
    }
    // 合成输入时更新文本
  }, {
    key: "changeCompositionText",
    value: function changeCompositionText(text) {
      var _this3 = this;
      this.model.changeCompositionText(text);
      // 合成输入的回调
      // 上面更新文本会触发 onChange，这里加异步是为了保证触发回调时数据和排版都已经变化完成，否则数据变化了但排版还是旧的
      Promise.resolve().then(function () {
        var _a;
        (_a = _this3.onCompositionInput) === null || _a === void 0 ? void 0 : _a.call(_this3);
      });
    }
    /**
     * 清除合成输入的状态
     */
  }, {
    key: "clearCompositionState",
    value: function clearCompositionState() {
      this.model.clearCompositionState();
    }
  }, {
    key: "normalizePoint",
    value: function normalizePoint(point) {
      return this.model.normalizePoint(point);
    }
    /**
     * 获取当前选区内节点的样式，以 paragraph 为单位
     * @returns
     */
  }, {
    key: "getSelectionProps",
    value: function getSelectionProps() {
      return this.model.getSelectionProps();
    }
    /**
     * 获取当前选区内符合要求的节点
     * @param match
     * @returns
     */
  }, {
    key: "getSelectionNodes",
    value: function getSelectionNodes(match) {
      return this.model.getSelectionNodes(match);
    }
    /**
     * 获取整个编辑器内所有符合要求的节点
     * @param match
     * @returns
     */
  }, {
    key: "getNodes",
    value: function getNodes(match, locationOrRef) {
      return this.model.getNodes(match, locationOrRef);
    }
    /**
     * 获取当前输入文字时会添加的样式
     * 一般就是选区是光标状态时使用
     */
  }, {
    key: "getStyle",
    value: function getStyle() {
      return this.model.getStyle();
    }
    /**
     * 获取某些位置的字符串，默认为当前选区
     * @param at
     * @returns
     */
  }, {
    key: "getString",
    value: function getString() {
      var at = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selection;
      return this.model.getString(at);
    }
    /**
     * 获取给定位置的起点，默认为当前选区
     * @param at
     * @returns
     */
  }, {
    key: "getStartPoint",
    value: function getStartPoint() {
      var at = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selection;
      return this.model.getStartPoint(at);
    }
    /**
     * 获取给定位置的终点，默认为当前选区
     * @param at
     * @returns
     */
  }, {
    key: "getEndPoint",
    value: function getEndPoint() {
      var at = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selection;
      return this.model.getEndPoint(at);
    }
    /**
     * 获取该位置前指定距离的点
     * @param at
     * @param distance
     * @returns
     */
  }, {
    key: "getBeforePoint",
    value: function getBeforePoint() {
      var at = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selection;
      var distance = arguments.length > 1 ? arguments[1] : undefined;
      return this.model.getBeforePoint(at, distance);
    }
    /**
     * 获取该位置后指定距离的点
     * @param at
     * @param distance
     * @returns
     */
  }, {
    key: "getAfterPoint",
    value: function getAfterPoint() {
      var at = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selection;
      var distance = arguments.length > 1 ? arguments[1] : undefined;
      return this.model.getAfterPoint(at, distance);
    }
    /** @deprecated 请改用 ${@link getSelectionLeafNodeAndRangeRef}，返回值已修改为 rangeRef */
  }, {
    key: "getSelectionLeafNodeAndRange",
    value: function getSelectionLeafNodeAndRange() {
      return this.getSelectionLeafNodeAndRangeRef();
    }
    /**
     * 获取当前选区内的叶子节点及节点的 range 引用
     * @returns
     */
  }, {
    key: "getSelectionLeafNodeAndRangeRef",
    value: function getSelectionLeafNodeAndRangeRef() {
      return this.model.getLeafNodeAndRangeRef(this.selection);
    }
    /**
     * 获取给定选区内的叶子节点及节点的 range 引用
     */
  }, {
    key: "getLeafNodeAndRangeRef",
    value: function getLeafNodeAndRangeRef(range) {
      return this.model.getLeafNodeAndRangeRef(range);
    }
  }, {
    key: "getParent",
    value: function getParent(location) {
      return this.model.getParent(location);
    }
    /**
     * 是否全选
     * @returns
     */
  }, {
    key: "isSelectAll",
    value: function isSelectAll() {
      return this.model.isSelectAll();
    }
  }, {
    key: "getLayoutSize",
    value: function getLayoutSize() {
      var _this$layoutManager$l2 = this.layoutManager.layoutBox.rect,
        width = _this$layoutManager$l2.width,
        height = _this$layoutManager$l2.height;
      return {
        width: twipsToPx(width),
        height: twipsToPx(height)
      };
    }
    /**
     * 暂时想不到更清晰的名字
     * 相对于当前编辑器的点的位置转换为相对于当前 app（也就是 transform 上下文）的位置
     * 是 positionOfAppToPositionOfEditor 的逆操作
     * @param x
     * @param y
     * @returns
     */
  }, {
    key: "positionOfEditorToPositionOfApp",
    value: function positionOfEditorToPositionOfApp(x, y) {
      var _this$blockRect = this.blockRect,
        blockX = _this$blockRect.x,
        blockY = _this$blockRect.y;
      // 转换需要加上当前编辑器的偏移
      var offset = this.matrix.apply({
        x: x + blockX,
        y: y + blockY
      });
      // 这个 offset 是相对于当前编辑器的位置，所以要算上缩放
      return {
        x: offset.x / this.scale,
        y: offset.y / this.scale
      };
    }
    /**
     * 暂时想不到更清晰的名字
     * 相对于当前 app（也就是 transform 上下文）的点的位置转换为相对于当前编辑器的点的位置
     * 是 positionOfEditorToPositionOfApp 的逆操作
     * @param x
     * @param y
     * @returns
     */
  }, {
    key: "positionOfAppToPositionOfEditor",
    value: function positionOfAppToPositionOfEditor(x, y) {
      // 这个 offset 是相对于当前 transform 上下文的位置，所以要算上缩放
      var offset = {
        x: x * this.scale,
        y: y * this.scale
      };
      // 根据当前的 transform，计算下相对于当前编辑器的点的位置
      var newOffset = this.matrix.applyInverse(offset);
      // 在转换完成之后需要减去编辑器的偏移
      var _this$blockRect2 = this.blockRect,
        blockX = _this$blockRect2.x,
        blockY = _this$blockRect2.y;
      return {
        x: newOffset.x - blockX,
        y: newOffset.y - blockY
      };
    }
  }, {
    key: "selectTextElement",
    value: function selectTextElement(textElement) {
      var path = this.textElementToPath.get(textElement);
      if (!path) {
        return;
      }
      var range = this.model.getRange(path);
      this.setSelection(range);
    }
    /**
     * 根据 location 获取对应的 range
     * 默认参数为根节点 path，对应返回值为根节点 range
     * @param at
     * @returns
     */
  }, {
    key: "getRange",
    value: function getRange() {
      var at = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this.model.getRange(at);
    }
    /**
     * 选中给定的 textElement 数组
     * @param textElements
     */
  }, {
    key: "selectTextElements",
    value: function selectTextElements(textElements) {
      var _this4 = this;
      var minPath = null;
      var maxPath = null;
      textElements.forEach(function (textElement) {
        var path = _this4.textElementToPath.get(textElement);
        if (!path) {
          return;
        }
        if (!minPath || !maxPath) {
          minPath = path;
          maxPath = path;
        } else {
          if (Path.isBefore(path, minPath)) {
            // path 在 minPath 之前
            minPath = path;
          }
          if (Path.isAfter(path, maxPath)) {
            // path 在 maxPath 之后
            maxPath = path;
          }
        }
      });
      if (minPath && maxPath) {
        var startPoint = this.model.getStartPoint(minPath);
        var endPoint = this.model.getEndPoint(maxPath);
        this.model.setSelectionPoints(startPoint, endPoint);
      }
    }
    /**
     * 获取给定 textElement 的前一个 textElement
     * @param textElement
     * @returns
     */
  }, {
    key: "getPrevTextElement",
    value: function getPrevTextElement(textElement) {
      var path = this.textElementToPath.get(textElement);
      return this.model.getPrevTextElement(path);
    }
    /**
     * 获取给定 textElement 的后一个 textElement
     * @param textElement
     * @returns
     */
  }, {
    key: "getNextTextElement",
    value: function getNextTextElement(textElement) {
      var path = this.textElementToPath.get(textElement);
      return this.model.getNextTextElement(path);
    }
    /**
     * 选中当前光标所在的文字节点
     */
  }, {
    key: "selectCurrentText",
    value: function selectCurrentText() {
      this.model.selectCurrentText();
    }
    /**
     * 键盘事件
     */
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var _a;
      return (_a = this.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(this, event);
    }
    /**
     * 复制粘贴相关事件的钩子
     */
  }, {
    key: "handleCopy",
    value: function handleCopy(event) {
      var _a;
      return (_a = this.onCopy) === null || _a === void 0 ? void 0 : _a.call(this, event);
    }
  }, {
    key: "handlePaste",
    value: function handlePaste(event) {
      var _a;
      return (_a = this.onPaste) === null || _a === void 0 ? void 0 : _a.call(this, event);
    }
  }, {
    key: "handleCut",
    value: function handleCut(event) {
      var _a;
      return (_a = this.onCut) === null || _a === void 0 ? void 0 : _a.call(this, event);
    }
    /**
     * 卸载逻辑，销毁时调用
     */
  }, {
    key: "detach",
    value: function detach() {
      // 因为 surface 不会销毁，所以需要解绑当前 editor
      Editor.surface.detachEditor(this, false);
      this.clearRect();
      this.clearEditStatus();
    }
    /**
     * 判断当前光标是否在拖拽中（用于移动端）
     */
  }, {
    key: "isCaretDragging",
    get: function get() {
      return Editor.surface.isCaretDragging;
    }
    /**
     * 在当前光标位置向前删除几个字符
     * @param length
     * @returns
     */
  }, {
    key: "deleteCharacterBack",
    value: function deleteCharacterBack(length) {
      return this.model.deleteCharacterBack(length);
    }
    /**
     * 给定 location 是否完全包含在给定选区中
     * @param location
     * @param range
     * @returns
     */
  }, {
    key: "isIncludedInRange",
    value: function isIncludedInRange(location, range) {
      return this.model.isIncludedInRange(location, range);
    }
    /**
     * 获取某一行的逻辑尺寸和位置
     * @param lineIndex
     * @returns
     */
  }, {
    key: "getLineLogicRect",
    value: function getLineLogicRect(lineIndex) {
      return this.layoutManager.getLineLogicRect(lineIndex);
    }
    /**
     * 输入框失焦时清除合成输入相关状态
     */
  }, {
    key: "handleInputBlur",
    value: function handleInputBlur() {
      this.model.clearCompositionState();
      this.isComposing = false;
    }
    /**
     * 更新编辑相关的状态
     * 如果触发当前操作的 editor 没有在编辑态，就忽略掉
     */
  }, {
    key: "updateEditorSurface",
    value: function updateEditorSurface() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$needUpdateSelect = _ref.needUpdateSelection,
        needUpdateSelection = _ref$needUpdateSelect === void 0 ? true : _ref$needUpdateSelect,
        _ref$needFocus = _ref.needFocus,
        needFocus = _ref$needFocus === void 0 ? true : _ref$needFocus;
      if (!this.isFocused) {
        return;
      }
      Editor.surface.update({
        needUpdateSelection: needUpdateSelection,
        needFocus: needFocus
      });
    }
  }, {
    key: "initHook",
    value: function initHook(editorOption) {
      var onSelectionChange = editorOption.onSelectionChange,
        onSelectionDragStart = editorOption.onSelectionDragStart,
        onSelectionDragEnd = editorOption.onSelectionDragEnd,
        onValueChange = editorOption.onValueChange,
        onBeforeValueChange = editorOption.onBeforeValueChange,
        onKeyDown = editorOption.onKeyDown,
        onFocus = editorOption.onFocus,
        onBlur = editorOption.onBlur,
        onBeforeLayout = editorOption.onBeforeLayout,
        onCompositionInput = editorOption.onCompositionInput,
        onCopy = editorOption.onCopy,
        onPaste = editorOption.onPaste,
        onCut = editorOption.onCut;
      this.onSelectionChange = onSelectionChange;
      this.onSelectionDragStart = onSelectionDragStart;
      this.onSelectionDragEnd = onSelectionDragEnd;
      this.onValueChange = onValueChange;
      this.onBeforeValueChange = onBeforeValueChange;
      this.onKeyDown = onKeyDown;
      this.onCopy = onCopy;
      this.onPaste = onPaste;
      this.onCut = onCut;
      this.onFocus = onFocus;
      this.onBlur = onBlur;
      this.onBeforeLayout = onBeforeLayout;
      this.onCompositionInput = onCompositionInput;
    }
  }, {
    key: "isFocused",
    get: function get() {
      return Editor.surface.editor === this;
    }
  }, {
    key: "onSizeChange",
    value: function onSizeChange(rect) {
      this.clearRect();
      var _this$model$slate = this.model.slate,
        _this$model$slate$anc = _this$model$slate.anchor,
        anchor = _this$model$slate$anc === void 0 ? AnchorType.Top : _this$model$slate$anc,
        _this$model$slate$pad = _this$model$slate.paddingTop,
        paddingTop = _this$model$slate$pad === void 0 ? 0 : _this$model$slate$pad,
        _this$model$slate$pad2 = _this$model$slate.paddingBottom,
        paddingBottom = _this$model$slate$pad2 === void 0 ? 0 : _this$model$slate$pad2,
        _this$model$slate$col = _this$model$slate.columnNumber,
        columnNumber = _this$model$slate$col === void 0 ? 1 : _this$model$slate$col;
      // 临时优化逻辑，横排文字，文字垂直方向向上对齐，宽度没修改，且 padding 抵消逻辑不变时不需要重新排版
      var prevOffset = paddingTop + paddingBottom > this.blockRect.height;
      var currentOffset = paddingTop + paddingBottom > rect.height;
      var isNeedLayout = !(columnNumber === 1 && this.coordinate === CoordinateZero.LEFT_TOP && this.lineExpandDirection === LineExpandDirection.VERTICAL && anchor === AnchorType.Top && rect.width === this.blockRect.width &&
      // 判断更新前后 padding 的抵消逻辑是否一致
      prevOffset === currentOffset);
      this.view.updateBlockRect(rect);
      if (isNeedLayout) {
        // 需要重新排版
        this.layout();
      }
      this.draw();
      this.updateEditorSurface({
        needFocus: false
      });
    }
  }, {
    key: "onPositionChange",
    value: function onPositionChange(rect) {
      this.clearRect();
      this.view.updateBlockRect(rect);
      this.draw();
      // 由于编辑模块元素的 matrix 计算用到了 editor 的偏移量，所以偏移变化之后，也需要更新下编辑模块
      this.updateEditorSurface({
        needFocus: false
      });
    }
  }, {
    key: "handleValueChange",
    value: function handleValueChange() {
      var needTriggerValueChangeHook = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _a;
      this.clearRect();
      this.layout();
      this.draw();
      this.updateEditorSurface({
        needFocus: false
      });
      // 合成输入过程中不往外触发回调
      if (needTriggerValueChangeHook && !this.isComposing) {
        (_a = this.onValueChange) === null || _a === void 0 ? void 0 : _a.call(this);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(slate) {
      if (slate.isChangeValue) {
        this.handleValueChange();
      }
    }
  }, {
    key: "initLayout",
    value: function initLayout() {
      var _this5 = this;
      this.layoutManager = new LayoutManager(function () {
        return _this5.layoutData || _this5.getValue(false);
      });
      this.layout();
    }
  }, {
    key: "layout",
    value: function layout() {
      var _a;
      // 调用钩子更新 layoutData，主要用于生成一些动态计算的数据（比如项目符号的文字）
      this.layoutData = ((_a = this.onBeforeLayout) === null || _a === void 0 ? void 0 : _a.call(this, this.getValue())) || null;
      this.layoutManager.layout(this.blockRect);
      this.ifLayoutAgain();
    }
    /**
     * 根据当前逻辑水平对齐方式决定是否要再次排版
     * 如果是根据当前文档逻辑水平方向的最大尺寸进行对齐，由于目前排版层不支持，只能通过动态修改排版区域来实现这个功能
     */
  }, {
    key: "ifLayoutAgain",
    value: function ifLayoutAgain() {
      if (this.view.textAlignStandard === TextAlignStandard.maxContentSize) {
        // 如果所有段落都向左对齐的话，也没必要进行第二次排版了，因为排版结果不会变
        if (this.isAllParagraphAlignLeft()) {
          return;
        }
        // 可能是小数，需要向上取整，避免最长的那一行再次排版结果不对
        var textMaxSize = Math.ceil(getMaxLogicSize(this.layoutManager.layoutBox));
        var _this$model$slate2 = this.model.slate,
          _this$model$slate2$pa = _this$model$slate2.paddingTop,
          paddingTop = _this$model$slate2$pa === void 0 ? 0 : _this$model$slate2$pa,
          _this$model$slate2$pa2 = _this$model$slate2.paddingBottom,
          paddingBottom = _this$model$slate2$pa2 === void 0 ? 0 : _this$model$slate2$pa2,
          _this$model$slate2$pa3 = _this$model$slate2.paddingLeft,
          paddingLeft = _this$model$slate2$pa3 === void 0 ? 0 : _this$model$slate2$pa3,
          _this$model$slate2$pa4 = _this$model$slate2.paddingRight,
          paddingRight = _this$model$slate2$pa4 === void 0 ? 0 : _this$model$slate2$pa4;
        var _this$blockRect3 = this.blockRect,
          width = _this$blockRect3.width,
          height = _this$blockRect3.height;
        // textMaxSize 并不包括文档的 padding，所以再次排版时需要加上对应方向的 padding
        var size = this.coordinate === CoordinateZero.LEFT_TOP ? {
          width: this.view.legalizeSize(textMaxSize + paddingLeft + paddingRight),
          height: height
        } : {
          width: width,
          height: this.view.legalizeSize(textMaxSize + paddingTop + paddingBottom)
        };
        this.layoutManager.layout(Object.assign(Object.assign({}, this.blockRect), size));
      }
    }
    // 判断是否所有段落都向左对齐
  }, {
    key: "isAllParagraphAlignLeft",
    value: function isAllParagraphAlignLeft() {
      var allAlignLeft = true;
      this.model.traverseParagraphElements(function (paragraphElement) {
        if (paragraphElement.textAlign !== TextAlignmentType.Left) {
          allAlignLeft = false;
          return true;
        }
        return void 0;
      });
      return allAlignLeft;
    }
  }, {
    key: "initRender",
    value: function initRender(renderText, eventArea) {
      var _this6 = this;
      var drawContext = this.drawContext,
        renderUtils = this.renderUtils,
        traverseTextHook = this.traverseTextHook,
        getNodeByPath = this.getNodeByPath,
        coordinate = this.coordinate,
        lineExpandDirection = this.lineExpandDirection;
      this.renderManager = new RenderManager({
        drawContext: drawContext,
        renderText: renderText,
        traverseTextHook: traverseTextHook,
        eventArea: eventArea,
        renderUtils: renderUtils,
        coordinate: coordinate,
        lineExpandDirection: lineExpandDirection,
        getNodeByPath: getNodeByPath,
        // 判断给定的 textElement 是否过期，过期代表给定的 textElement 已经不在当前数据中
        isTextElementExpired: function isTextElementExpired(textElement) {
          return !_this6.textElementToPath.has(textElement);
        }
      });
      this.draw();
    }
    /**
     * 清除文字绘制和选区绘制，以及缓存的映射关系
     * 如果触发当前操作的 editor 没有在编辑态，就不清除选区的绘制
     * @param rect
     * @returns
     */
  }, {
    key: "clearRect",
    value: function clearRect() {
      var rect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.blockRect;
      this.renderManager.clearRect(rect);
      this.slatePathToBox.clear();
      this.textElementToPath.clear();
      if (!this.isFocused) {
        return;
      }
      Editor.surface.clear();
    }
  }, {
    key: "draw",
    value: function draw() {
      var layoutBox = this.layoutManager.layoutBox;
      this.renderManager.startDraw(layoutBox, this.blockRect);
    }
    /**
     * 清除编辑相关状态
     */
  }, {
    key: "clearEditStatus",
    value: function clearEditStatus() {
      var _a;
      (_a = this.mouseManager) === null || _a === void 0 ? void 0 : _a.clear();
      this.clearSelection();
      this.model.clearRefs();
    }
    /**
     * 更新 textElement 和 path 之间的映射关系
     * 正常来说是在遍历数据渲染时顺带更新的
     * 如果数据变更了，但是不需要重新渲染的话，就可以使用这个方法手动更新这个映射关系
     */
  }, {
    key: "updateTextElementToPath",
    value: function updateTextElementToPath() {
      var _this7 = this;
      this.textElementToPath.clear();
      this.model.traverseTextElements(function (textElement, path) {
        _this7.textElementToPath.link(textElement, path);
      });
    }
  }, {
    key: "enterRealEditing",
    value: function enterRealEditing() {
      if (this.isReadyEditing) {
        this.readyEditingToRealEditing();
      }
    }
    /**
     * 从 readyEditing 状态进入到真正的 editing 状态
     * 从逻辑上来看，就是从非编辑态切换到了编辑态，所以要触发 focus 回调
     */
  }, {
    key: "readyEditingToRealEditing",
    value: function readyEditingToRealEditing() {
      var _a, _b;
      // 停止强制隐藏光标
      Editor.stopKeepCaretHide();
      // 在触发外界钩子前，清除 setReadyEditingFlag 标记
      this.setReadyEditingFlag = false;
      (_a = this.onFocus) === null || _a === void 0 ? void 0 : _a.call(this);
      (_b = this.onSelectionChange) === null || _b === void 0 ? void 0 : _b.call(this, null, this.selection);
    }
    /**
     * 从真正的 editing 状态切换到 readyEditing 状态
     * 从逻辑上来看，就是从编辑态切换到了非编辑态，所以要触发 blur 回调
     */
  }, {
    key: "realEditingToReadyEditing",
    value: function realEditingToReadyEditing() {
      var _a;
      // 开始强制隐藏光标
      Editor.startKeepCaretHide();
      this.model.selectEnd();
      this.updateEditorSurface();
      (_a = this.onBlur) === null || _a === void 0 ? void 0 : _a.call(this);
    }
  }, {
    key: "blurredToReadyEditing",
    value: function blurredToReadyEditing() {
      // 开始强制隐藏光标
      Editor.startKeepCaretHide();
      this.model.selectEnd();
      // 设置选区后在绑定编辑模块，否则会触发 focus 回调
      Editor.surface.attachEditor(this);
      // 更新编辑模块，获取到焦点
      this.updateEditorSurface();
    }
  }, {
    key: "readyEditingToBlurred",
    value: function readyEditingToBlurred() {
      Editor.surface.detachEditor(this);
      // 停止强制隐藏光标
      Editor.stopKeepCaretHide();
    }
  }], [{
    key: "setDefaultFontFamily",
    value:
    // 设置全局默认字体
    function setDefaultFontFamily(defaultFontFamilies) {
      var specificFontFamilies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.defaultFontFamilyString) {
        return;
      }
      this.defaultFontFamilyString = defaultFontFamilies.map(function (font) {
        return "\"".concat(font, "\"");
      }).join(',');
      // 根据文字脚本类型设置默认字体
      var specificFontFamilyStrings = {};
      Object.entries(specificFontFamilies).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          scriptType = _ref3[0],
          fontFamilies = _ref3[1];
        if (scriptType && fontFamilies) {
          specificFontFamilyStrings[scriptType] = fontFamilies.map(function (font) {
            return "\"".concat(font, "\"");
          }).join(',');
        }
      });
      LayoutManager.setDefaultFontFamily(this.defaultFontFamilyString, specificFontFamilyStrings);
    }
    // 设置编辑器所在的设备类型
  }, {
    key: "setPlatform",
    value: function setPlatform(platform) {
      this.platform = platform;
    }
    // 设置触摸屏设备中是否支持鼠标操作
  }, {
    key: "setSupportMouseOnTouchScreen",
    value: function setSupportMouseOnTouchScreen(value) {
      this.supportMouseOnTouchScreen = value;
    }
  }, {
    key: "attachSurface",
    value: function attachSurface$1() {
      this.surface = attachSurface();
    }
    /**
     * 清除某个字体对应的测量缓存
     * 目前用于云字体场景，在字体加载完成后要清理掉旧的缓存以保证新加载的字体测量结果正确
     * @param fontFamily 待清理缓存的字体名称
     */
  }, {
    key: "invalidateMeasureCache",
    value: function invalidateMeasureCache(fontFamily) {
      LayoutManager.invalidateMeasureCache(fontFamily);
    }
    /**
     * 获取当前光标是否可见
     */
  }, {
    key: "isKeepCaretHide",
    get: function get() {
      return this.surface.isKeepCaretHide;
    }
    /**
     * 开始强制隐藏光标
     */
  }, {
    key: "startKeepCaretHide",
    value: function startKeepCaretHide() {
      Editor.surface.startKeepCaretHide();
    }
    /**
     * 停止强制隐藏光标
     */
  }, {
    key: "stopKeepCaretHide",
    value: function stopKeepCaretHide() {
      Editor.surface.stopKeepCaretHide();
    }
  }]);
}();
Editor.defaultFontFamilyString = '';
Editor.platform = Platform.pc;

var defaultLayoutOption = {
  preciseMeasurement: false
};
/**
 * 根据指定数据排版并返回排版树
 * @param documentElement
 * @param size
 * @param layoutOption
 * @returns
 */
function getTextLayout(documentElement, size) {
  var layoutOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultLayoutOption;
  return executeWithTemporaryPreciseMeasurement(function () {
    var layoutManager = new LayoutManager(function () {
      return documentElement;
    });
    var blockRect = Object.assign({
      x: 0,
      y: 0
    }, getSizeObj(size));
    layoutManager.layout(blockRect);
    return layoutManager.layoutBox;
  }, layoutOption.preciseMeasurement);
}
/**
 * 在执行给定函数期间临时修改 preciseMeasurement 值
 * 执行完成后重置，避免影响其他地方的逻辑
 * @param func
 * @param preciseMeasurement
 * @returns
 */
function executeWithTemporaryPreciseMeasurement(func, preciseMeasurement) {
  var currentPreciseMeasurement = LayoutManager.getPreciseMeasurement();
  if (currentPreciseMeasurement === preciseMeasurement) {
    return func();
  }
  LayoutManager.setPreciseMeasurement(preciseMeasurement);
  var result = func();
  LayoutManager.setPreciseMeasurement(currentPreciseMeasurement);
  return result;
}
function getSizeObj(size) {
  if (typeof size === 'number') {
    return {
      width: size,
      height: size
    };
  }
  return size;
}

/**
 * 给定一段文本和限制尺寸（横排限制宽，竖排限制高）
 * 测试文本实际的宽高
 * @param documentElement
 * @param size
 * @returns
 */
function measureText(documentElement, size) {
  var layoutBox = getTextLayout(documentElement, size);
  var _layoutBox$rect = layoutBox.rect,
    width = _layoutBox$rect.width,
    height = _layoutBox$rect.height;
  return {
    width: twipsToPx(width),
    height: twipsToPx(height)
  };
}

/**
 * 获取文档根节点的 path
 * @returns
 */
function getRootPath() {
  return [];
}

export { ContainerType, DEFAULT_DOCUMENT_ELEMENT, DOCUMENT_PROPS_RELATED_TO_LAYOUT, EDITOR_CARET_CLASS_NAME, EDITOR_INPUT_CLASS_NAME, Editor, EventArea, PARAGRAPH_PROPS_RELATED_TO_LAYOUT, Platform, TEXT_PROPS_RELATED_TO_LAYOUT, TextAlignStandard, getEditorSelectableAreaRect, getMaxLogicSize, getRootPath, getTextLayout, measureText };
//# sourceMappingURL=index.esm.js.map
